{
  "jobsIA": {
    "interrumpido": "La generació amb IA s'ha interromput.",
    "reintentar": "Torna-ho a provar",
    "descartar": "Descarta l'avís",
    "confirmarTitulo": "Vols tornar a provar la generació?",
    "confirmarMensaje": "L'esborrany es va editar després de la interrupció. Si ho tornes a provar, tornarà a l'estat anterior al pas interromput i es perdran aquests canvis.",
    "yaReintentado": "Una altra persona ja ha tornat a provar aquesta generació.",
    "ocupado": "L'esborrany està ocupat amb una altra generació. Torna-ho a provar d'aquí a uns segons.",
    "noReintentable": "Aquesta generació ja no es pot tornar a provar.",
    "noDisponible": "El servei no està disponible ara. Torna-ho a provar més tard.",
    "noEncontrado": "No s'ha trobat la generació.",
    "errorRed": "No s'ha pogut tornar a provar. Comprova la connexió.",
    "procesando": "Processant"
  },
  "imageUpload": {
    "preparing": "Preparant la imatge…",
    "uploading": "Pujant la imatge…",
    "retrying": "Tornant a provar la pujada…",
    "failed": "No s'ha pogut pujar la imatge",
    "failedTooLarge": "La imatge és massa gran",
    "failedUnsupported": "Format d'imatge no admès",
    "failedNetwork": "Sense connexió amb el servidor",
    "failedPrepare": "No s'ha pogut processar la imatge",
    "retry": "Torna-ho a provar",
    "pendingWarning": "Hi ha {{count}} imatge(s) que només existeixen en aquest navegador i no s'han desat al servidor. Es perdran si tanques o recarregues la pàgina."
  },
  "super": {
    "title": "Administració",
    "issuesTitle": "Incidències i idees",
    "issuesSubtitle": "Revisa les incidències i els suggeriments enviats pels usuaris",
    "brandsTab": "Marques",
    "brandsTitle": "Marques i distribuïdors",
    "brandsSubtitle": "Qui ens porta cada client i què veu quan entra"
  },
  "radiologyStyle": {
    "title": "El teu estil radiològic",
    "description": "Crea una llista amb les teves preferències sobre com t'agrada redactar els informes. Per exemple: «Vull que totes les troballes estiguin en negreta».",
    "menuLabel": "El teu estil radiològic",
    "settingsTitle": "El teu estil radiològic",
    "settingsDescription": "Defineix com t'agrada redactar els informes amb una llista de preferències personals",
    "settingsText": "Crea i edita la teva llista de preferències d'estil. Per exemple: «Vull que totes les troballes estiguin en negreta».",
    "settingsButton": "Editar el meu estil",
    "empty": "Encara no has afegit cap preferència d'estil.",
    "placeholder": "Ex.: Vull que totes les troballes estiguin en negreta",
    "addRule": "Afegir preferència",
    "removeRule": "Eliminar preferència",
    "saving": "Desant…",
    "saved": "El teu estil radiològic s'ha desat correctament",
    "saveError": "No s'ha pogut desar el teu estil radiològic",
    "limitHint": "Fins a {{maxRules}} preferències de {{maxLength}} caràcters cadascuna.",
    "maxRulesReached": "Has arribat al màxim de {{maxRules}} preferències",
    "ruleTooLong": "Una preferència supera els {{maxLength}} caràcters: escurça-la per poder desar"
  },
  "common": {
    "welcome": "Benvingut",
    "unknownModality": "Modalitat desconeguda",
    "unknownRegion": "Regió desconeguda",
    "professionalTitleDefault": "Dr.",
    "login": "Iniciar sessió",
    "logout": "Tancar sessió",
    "save": "Desar",
    "cancel": "Cancel·lar",
    "delete": "Eliminar",
    "edit": "Editar",
    "view": "Veure",
    "close": "Tancar",
    "search": "Cercar",
    "loading": "Carregant...",
    "sending": "Enviant...",
    "error": "Error",
    "success": "Èxit",
    "email": "Correu electrònic",
    "password": "Contrasenya",
    "submit": "Enviar",
    "back": "Tornar",
    "continue": "Continuar",
    "next": "Següent",
    "previous": "Anterior",
    "confirm": "Confirmar",
    "yes": "Sí",
    "no": "No",
    "goHome": "Anar a l'inici",
    "home": "Inici",
    "myInsights": "Les meves estadístiques",
    "groupReports": "Historial de treball",
    "createReport": "Crear informe",
    "templates": "Plantilles",
    "accounts": "Comptes",
    "users": "Usuaris",
    "issues": "Problemes",
    "adminPanel": "Tauler d'administració",
    "orgAdmin": "Organització",
    "configuration": "Configuració",
    "parameters": "Paràmetres",
    "openMenu": "Obrir menú",
    "collapseMenu": "Plegar menú",
    "expandMenu": "Desplegar menú",
    "writeHere": "Escriu aquí...",
    "headingPlaceholder": "Títol",
    "selectButtonsToExport": "Seleccionar botons per exportar",
    "exportSelection": "Exportar selecció",
    "configureButtons": "Configurar botons per exportar",
    "searchPlaceholder": "Cercar...",
    "clearSelection": "Esborrar selecció",
    "noResults": "No s'han trobat resultats",
    "commands": "Ordres",
    "insert": "Inserir",
    "update": "Actualitzar",
    "generate": "Generar",
    "select": "Seleccionar",
    "dictate": "Dictar",
    "language": "Idioma",
    "showing": "Mostrant",
    "of": "de",
    "or": "o",
    "page": "Pàgina",
    "item": "element",
    "items": "elements",
    "copy": "Copiar",
    "clear": "Esborrar",
    "share": "Compartir",
    "discard": "Descartar",
    "deleting": "Eliminant...",
    "enabled": "Activat",
    "disabled": "Desactivat",
    "send": "Enviar",
    "pause": "Posar en pausa",
    "resume": "Reprendre",
    "showLaterality": "Mostrar lateralitat",
    "hideLaterality": "Amagar lateralitat",
    "laterality": {
      "left": "Esquerra",
      "right": "Dreta",
      "both": "Bilateral"
    },
    "groups": "Grups"
  },
  "commandPalette": {
    "searchPlaceholder": "Escriu una ordre...",
    "results": "Resultats",
    "searching": "Cercant...",
    "noTemplatesFound": "No s'han trobat plantilles",
    "suggestions": "Suggeriments",
    "createTemplate": "Crear plantilla",
    "startDictation": "Iniciar dictat",
    "generateReport": "Generar informe",
    "recentTemplates": "Plantilles recents",
    "errorLoadingTemplates": "Error en carregar les plantilles",
    "errorSearching": "Error en cercar les plantilles",
    "mustUseWithinProvider": "useCommandPalette s'ha d'utilitzar dins de CommandPaletteProvider"
  },
  "auth": {
    "welcomeHello": "Hola,",
    "welcomeBack": "Benvingut",
    "launchSignInNeeded": "El teu estudi t'espera. Inicia sessió per continuar.",
    "launchIdentityRefused": "No s'ha pogut obrir la sessió automàticament: el teu usuari no està autoritzat a la instal·lació des de la qual s'ha iniciat l'estudi. Demana a l'administrador que t'hi afegeixi. Mentrestant, pots iniciar sessió aquí.",
    "emailLabel": "Correu electrònic",
    "passwordLabel": "Contrasenya",
    "loginTitle": "Iniciar sessió a Ainovis",
    "loginSubtitle": "Introdueix les teves credencials per accedir-hi",
    "forgotPassword": "Has oblidat la contrasenya?",
    "rememberMe": "Recorda'm",
    "noAccount": "No tens compte?",
    "signUp": "Registrar-se",
    "alreadyHaveAccount": "Ja tens compte?",
    "signIn": "Iniciar sessió",
    "verifyEmail": "Verificar correu electrònic",
    "verifyEmailText": "Hem enviat un correu de verificació a la teva adreça electrònica",
    "resetPassword": "Restablir contrasenya",
    "resetPasswordText": "Introdueix la nova contrasenya",
    "newPassword": "Nova contrasenya",
    "confirmPassword": "Confirmar contrasenya",
    "sendResetLink": "Enviar enllaç de restabliment",
    "backToLogin": "Tornar a l'inici de sessió",
    "googleLogin": "Continuar amb Google",
    "microsoftLogin": "Continuar amb Microsoft",
    "orLoginWith": "O iniciar sessió amb",
    "authenticatingMicrosoft": "Autenticant amb Microsoft...",
    "processingAuth": "Processant l'autenticació...",
    "resetPasswordTitle": "Restablir contrasenya",
    "resetPasswordDescription": "Introdueix la nova contrasenya",
    "resetting": "Restablint...",
    "resetPasswordButton": "Restablir contrasenya",
    "invalidToken": "Token no vàlid o caducat",
    "completeAllFields": "Si us plau, completa tots els camps",
    "passwordsDoNotMatch": "Les contrasenyes no coincideixen",
    "passwordMinLength": "La contrasenya ha de tenir almenys 6 caràcters",
    "passwordResetSuccess": "Contrasenya restablerta correctament",
    "enterButton": "Entrar",
    "emailPlaceholder": "Correu electrònic",
    "passwordPlaceholder": "Contrasenya",
    "completeCaptcha": "Si us plau, completa el captcha",
    "continueWith": "o iniciar sessió amb",
    "continueWithMicrosoft": "Continuar amb Microsoft",
    "forgotPasswordTitle": "Has oblidat la contrasenya?",
    "forgotPasswordDescription": "No et preocupis, t'enviarem instruccions per restablir-la",
    "sendInstructions": "Enviar instruccions",
    "emailSentTitle": "Correu enviat",
    "emailSentMessage": "Hem enviat un correu a {{email}} amb les instruccions per restablir la contrasenya",
    "checkSpam": "Si no reps el correu al cap d'uns minuts, revisa la carpeta de correu brossa"
  },
  "notFound": {
    "title": "404",
    "subtitle": "Pàgina no trobada",
    "message": "Ho sentim, la pàgina que cerques no existeix o s'ha mogut"
  },
  "dashboard": {
    "title": "Tauler de control",
    "reports": "Informes",
    "recentReports": "Els teus informes diagnòstics",
    "createReport": "Crear informe",
    "viewAll": "Veure tots",
    "statistics": "Estadístiques",
    "totalReports": "Total d'informes",
    "pendingReports": "Informes pendents",
    "completedReports": "Informes completats"
  },
  "reports": {
    "deselectAll": "Deseleccionar-ho tot",
    "allSelected": "Tots seleccionats ({{count}})",
    "tapToSelectAll": "Seleccionar-ho tot",
    "selectedCountHint": "· {{count}} seleccionats",
    "selectedCountHint_one": "· {{count}} seleccionat",
    "selectedCountHint_other": "· {{count}} seleccionats",
    "signReport": "Signar",
    "signedBy": "Signat per:",
    "licenseNumber": "Núm. de col·legiat",
    "sendBusy": "Espera que acabi el procés en curs",
    "requestEdit": "Sol·licitar permís d'edició",
    "requestEditSent": "Sol·licitud enviada",
    "requestEditError": "No s'ha pogut enviar la sol·licitud. Torna-ho a provar.",
    "editRequestToast": "{{name}} sol·licita permís d'edició.",
    "editRequestManage": "Gestionar",
    "editRequestSomeone": "Un usuari",
    "title": "Informes",
    "newReport": "Nou informe",
    "reportList": "Llista d'informes",
    "reportDetails": "Detalls de l'informe",
    "status": "Estat",
    "createdAt": "Creat el",
    "updatedAt": "Actualitzat el",
    "createdBy": "Creat per",
    "draft": "Esborrany",
    "published": "Publicat",
    "archived": "Arxivat",
    "noReports": "No hi ha informes disponibles",
    "deleteConfirm": "Segur que vols eliminar aquest informe?",
    "studyDescription": "Descripció de l'estudi",
    "studyDescriptionPlaceholder": "Escriu la descripció de l'estudi",
    "reasonForRequestedProcedure": "Motiu de la petició",
    "reportGeneration": "Generació",
    "automatic": "Automàtica",
    "manual": "Manual",
    "automaticTooltip": "Genera l'informe automàticament",
    "manualTooltip": "Genera l'informe a partir de la plantilla seleccionada",
    "reportFormat": "Tipus d'informe",
    "inside": "Dins del text",
    "first": "Al principi",
    "insideTooltip": "Les troballes es repartiran uniformement dins de l'apartat 'Troballes'",
    "firstTooltip": "Les troballes es col·locaran al principi de l'apartat 'Troballes'",
    "selectedTemplate": "Plantilla seleccionada",
    "templateList": "Llista de plantilles",
    "auto": "Auto",
    "automatic2": "Automàtica",
    "enterDescription": "Si us plau, introdueix una descripció de l'estudi",
    "reportCopied": "Informe copiat correctament",
    "reportGenerated": "Informe generat correctament",
    "reportSaved": "Informe desat correctament",
    "noReportToSave": "No hi ha cap informe generat per desar",
    "missingReportInfo": "Falta informació de l'informe",
    "timeoutError": "La generació ha trigat massa. Prova amb una descripció més curta",
    "generateButton": "Generar informe",
    "generating": "Generant...",
    "thinking": "Pensant...",
    "saveButton": "Desar informe",
    "saving": "Desant...",
    "generatingMessage": "Generant informe...",
    "savingMessage": "Desant informe...",
    "editorPlaceholder": "L'informe generat apareixerà aquí",
    "activateDictation": "Activar dictat per veu",
    "holdMicSendHint": "Deixa anar per enviar · Esc per cancel·lar",
    "holdMicCancelHint": "Deixa anar per cancel·lar",
    "keepAllContent": "Mantenir tot el contingut marcat",
    "keepContentDesc": "Mantenir el contingut marcat (fusionar sense eliminar)",
    "deleteAllContent": "Eliminar tot el contingut marcat",
    "keepOriginal": "Mantenir text original",
    "keepOriginalDesc": "Mantenir el text original (descartar canvis)",
    "applyUpdates": "Aplicar totes les actualitzacions",
    "generateReport": "Generar informe",
    "basedOnRecentActivity": "Basat en la teva activitat recent",
    "aiDisclaimer": "Ainovis pot cometre errors. Considera verificar la informació important",
    "reportContent": "Paràmetres de l'informe",
    "continueWithBaseTemplate": "Continuar amb la plantilla base",
    "blocksDetected": "Blocs detectats",
    "selectBlockHint": "Selecciona un bloc o continua amb la plantilla base",
    "continueWithNormalTemplate": "Continuar sense blocs",
    "referenceSelected": "Referència seleccionada ✓",
    "blockSelected": "Bloc seleccionat ✓",
    "blockSkipped": "Continuant sense bloc ✓",
    "description": "Descriptiu",
    "detectedProcedures": "Procediments detectats",
    "noProceduresDetected": "No s'han detectat procediments",
    "detectedLaterality": "Lateralitat detectada",
    "noLateralityFound": "No s'ha trobat lateralitat",
    "searchLaterality": "Alinear lateralitat",
    "lateralityUpdated": "Lateralitat actualitzada",
    "errorSearchingLaterality": "Error en detectar la lateralitat",
    "findingsFirst": "Troballes al principi",
    "findingsInside": "Troballes dins del text",
    "welcome": "Benvingut {{title}} {{surname}}",
    "searchTemplate": "Cercar plantilla...",
    "loadingTemplate": "Carregant plantilla...",
    "multipleReferencesDetected": "S'han detectat diverses referències",
    "selectReferenceHint": "Selecciona una opció per continuar amb la generació",
    "generateManualReport": "Generar informe manual",
    "blankCanvas": "Document en blanc",
    "createTemplate": "Crear plantilla",
    "viewPowerBI": "Veure estadístiques",
    "uploadAudio": "Processar àudio per lots",
    "noTemplatesFound": "No s'han trobat plantilles",
    "errorCreatingBlankCanvas": "Error en crear el document en blanc",
    "manualModePlaceholder": "Escriu la plantilla que vols utilitzar",
    "navigate": "navegar",
    "select": "seleccionar",
    "close": "tancar",
    "loadingTemplates": "Carregant plantilles...",
    "searchPlaceholder": "Cercar informe...",
    "reportsHistorySidebarTitle": "Historial d'informes",
    "reportsHistorySidebarTitleSaved": "Informes enviats",
    "reportsHistoryPreviewStamp": "Informe enviat",
    "versionHistoryPreviewStamp": "Versió anterior",
    "reportsHistorySidebarClose": "Tancar el tauler de l'historial",
    "reportsHistoryLoading": "Carregant…",
    "reportsHistoryError": "No s'ha pogut carregar l'historial",
    "reportsHistoryNoResults": "Sense resultats",
    "reportsHistoryDraftsEmpty": "No tens esborranys",
    "reportsHistorySavedEmpty": "No tens informes enviats",
    "reportsHistoryUntitled": "Sense títol",
    "reportsHistoryTabDrafts": "Esborranys",
    "reportsHistoryTabSaved": "Enviats",
    "createReport": "Crear informe",
    "currentStatus": "Estat actual",
    "pendingReview": "Informes pendents de revisió",
    "savedToday": "Informes desats avui",
    "draftReports": "Informes en esborrany",
    "recentReports": "Els teus informes",
    "drafts": "Esborranys",
    "saved": "Enviats",
    "sharedWithMe": "Compartits amb mi",
    "ownedByMe": "Sóc el propietari",
    "noOwnedDrafts": "No hi ha esborranys dels quals siguis propietari",
    "countOwned": "{{count}} propis",
    "diagnosis": "Conclusió",
    "versions": "Versions",
    "version": "versió",
    "lastUpdate": "Última actualització",
    "actions": "Accions",
    "noDrafts": "No hi ha esborranys",
    "noSharedDrafts": "No hi ha informes compartits amb tu",
    "noDiagnosis": "(Sense diagnòstic)",
    "loadingVersions": "Carregant versions...",
    "owner": "Propietari",
    "modalities": "Modalitats",
    "procedure": "Procediment",
    "procedures": "Procediments",
    "time": "Hora",
    "draftVersionsInfo": "Versions desades d'aquest esborrany: {{count}}",
    "report": "informe",
    "reports": "informes",
    "yourPerformance": "El teu rendiment",
    "last7Days": "Últims 7 dies",
    "thisWeek": "Aquesta setmana",
    "thisMonth": "Aquest mes",
    "today": "Avui",
    "yesterday": "Ahir",
    "last30Days": "Últims 30 dies",
    "older": "Anteriors",
    "totalReports": "Total",
    "deleteDraftTitle": "Eliminar esborrany",
    "leaveDraft": "Abandonar esborrany",
    "leaveDraftTitle": "Abandonar esborrany",
    "leaveDraftConfirm": "Abandonar",
    "leaveDraftMessage": "Deixaràs de tenir accés a aquest esborrany compartit. El propietari el podrà tornar a compartir amb tu.",
    "deleteReportTitle": "Eliminar informe",
    "deleteDraftMessage": "Segur que vols eliminar aquest esborrany i totes les seves versions? Aquesta acció no es pot desfer.",
    "deleteReportMessage": "Segur que vols eliminar aquest informe desat? Aquesta acció no es pot desfer.",
    "deleteBatchTitle": "Eliminar lot",
    "deleteBatchMessage": "Segur que vols eliminar aquest lot i tots els seus estudis? Aquesta acció no es pot desfer.",
    "errorLoadingReport": "Error en carregar l'informe",
    "noContentToCopy": "No hi ha contingut per copiar",
    "contentCopied": "Contingut copiat al porta-retalls",
    "errorCopying": "Error en copiar el contingut",
    "errorPreSaveValidation": "Error en validar abans de desar",
    "preSaveInconsistencies": "Incoherències detectades",
    "preSaveVersions": "Diverses versions",
    "preSaveVersionsMsg": "Només es desarà la versió actual i es descartaran les {{count}} restants.",
    "errorSavingReport": "Error en desar l'informe",
    "errorSavingDraft": "Error en desar l'esborrany",
    "draftDeleted": "Esborrany eliminat correctament",
    "errorDeletingDraft": "Error en eliminar l'esborrany",
    "emptyTechnique": "La tècnica és buida",
    "proceduresFound": "Procediments actualitzats",
    "errorSearchingProcedures": "Error en cercar procediments",
    "blankVersionCreated": "Document en blanc creat",
    "errorCreatingBlankVersion": "Error en crear el document en blanc",
    "loadingReport": "Carregant informe...",
    "deletingMessage": "Eliminant esborrany...",
    "searchingProcedures": "Cercant procediments...",
    "searchingLaterality": "Detectant lateralitat...",
    "hideProcedures": "Amagar procediments",
    "searchProcedures": "Cercar procediments",
    "showProcedures": "Mostrar procediments",
    "confirmDeleteDraft": "Segur que vols eliminar aquest esborrany? Aquesta acció no es pot desfer.",
    "inconsistency": "Incoherència",
    "show": "Mostrar",
    "preSaveTitle": "Abans de desar",
    "preSaveSubtitle": "S'han detectat els advertiments següents:",
    "confirmSave": "Enviar igualment",
    "unsavedChanges": "Canvis sense desar",
    "unsavedChangesMessage": "\"{{title}}\" té canvis sense desar. Vols descartar-los?",
    "maxVersionsReached": "S'ha arribat al màxim d'informes",
    "settings": "Configuració",
    "reportType": "Tipus d'informe",
    "noTemplateSelected": "Detecció automàtica",
    "useAnotherTemplate": "Utilitzar una altra plantilla",
    "change": "Canviar",
    "changeTemplate": "Canviar plantilla",
    "backToAutoDetection": "Tornar a la detecció automàtica",
    "autoDetection": "Detecció automàtica",
    "noDescription": "Sense descripció",
    "resume": "Reprendre",
    "pause": "Posar en pausa",
    "process": "Processar",
    "processingAudio": "Processant àudio...",
    "analyzingVoice": "Analitzant la teva veu...",
    "transcribingAudio": "Transcrivint àudio...",
    "interpretingCommands": "Interpretant ordres...",
    "preparingResult": "Preparant el resultat...",
    "analyzingText": "Analitzant el teu text...",
    "understandingIntent": "Entenent la intenció...",
    "readingContext": "Llegint el context...",
    "identifyingSections": "Identificant seccions...",
    "writing": "Escrivint...",
    "fillingReport": "Emplenant l'informe...",
    "writingSections": "Redactant seccions...",
    "addingFindings": "Afegint troballes...",
    "refiningContent": "Polint el contingut...",
    "applyingClassifications": "Aplicant classificacions...",
    "evaluatingCriteria": "Avaluant criteris...",
    "calculatingResults": "Calculant resultats...",
    "finalizingReport": "Finalitzant...",
    "aiAssistantPlaceholder": "Escriu un text o dicta amb el micròfon...",
    "sendToDescriptive": "Al descriptiu",
    "aiChatEmpty": "Envia un missatge per començar la conversa",
    "carolinaAssistance": "Carolina Assistance",
    "send": "Enviar",
    "record": "Enregistrar",
    "generate": "Generar",
    "selectReference": "Selecciona una de les referències per continuar",
    "errorGenerating": "Error en generar l'informe",
    "noTemplateDetected": "No s'ha detectat cap plantilla",
    "reportGeneratedWithReference": "Informe generat amb la referència seleccionada",
    "versionCreated": "Nova versió creada correctament",
    "errorCreatingVersion": "Error en crear la versió",
    "emptyRecording": "L'enregistrament és buit",
    "invalidServerResponse": "Error: resposta del servidor no vàlida",
    "noAudioDetected": "No s'ha detectat àudio",
    "commandExecuted": "Ordre executada correctament",
    "audioTranscribed": "Àudio transcrit correctament",
    "audioProcessingError": "Error en processar l'àudio",
    "microphoneAccessError": "No s'ha pogut accedir al micròfon",
    "descriptionRequired": "Has d'escriure una descripció",
    "errorLoadingTemplates": "No s'han pogut carregar les plantilles",
    "patient": "Pacient",
    "patientId": "ID del pacient",
    "patientIdPlaceholder": "ID...",
    "patientAge": "Edat",
    "patientAgePlaceholder": "Anys",
    "patientSex": "Sexe",
    "patientSexPlaceholder": "Seleccionar...",
    "sexMale": "Masculí",
    "sexFemale": "Femení",
    "studyDate": "Data de l'estudi",
    "requestReason": "Motiu de la petició",
    "patientNamePlaceholder": "Cognoms, Nom",
    "requestReasonPlaceholder": "Descripció del motiu...",
    "cancel": "Cancel·lar",
    "cancelEditing": "Cancel·lar edició",
    "patientNameRequired": "El nom del pacient és obligatori",
    "confirmHint": "Enter per confirmar · Esc per cancel·lar",
    "editPatient": "Editar pacient",
    "deletePatient": "Esborrar pacient",
    "contractReason": "Plegar motiu",
    "expandReason": "Desplegar motiu",
    "years": "Anys",
    "modality": "Modalitat",
    "accessionNumber": "Núm. d'accés",
    "referringPhysician": "Metge sol·licitant",
    "previousStudiesTitle": "Estudis previs",
    "previousStudiesHint": "Consulta i compara amb estudis anteriors del pacient",
    "allProcedures": "Tots els procediments",
    "study": "estudi",
    "studiesCount": "estudis",
    "studyPlural": "estudis",
    "batches": "Lots",
    "batchStudies": "Estudis",
    "noBatches": "No hi ha lots pendents",
    "continueBatch": "Continuar",
    "noStudiesFound": "No s'han trobat estudis previs",
    "studyStatus_completed": "Completat",
    "studyStatus_pending": "Pendent",
    "studyStatus_cancelled": "Cancel·lat",
    "loadPrevStudies": "Carregar estudis previs",
    "reportClinicalInfo": "Informació clínica",
    "reportTechnique": "Tècnica",
    "reportFindings": "Troballes",
    "reportConclusion": "Conclusió",
    "conclusionType": "Conclusió",
    "conclusionBrief": "Conclusió breu",
    "conclusionNormal": "Conclusió normal",
    "conclusionExtensive": "Conclusió extensa",
    "conclusionBriefShort": "Resumida",
    "conclusionNormalShort": "Normal",
    "conclusionExtensiveShort": "Extensa",
    "speedMode": "Mode de velocitat",
    "fast": "Ràpid",
    "accurate": "Precís",
    "fastModeDesc": "Generació ràpida",
    "accurateModeDesc": "Més precisió",
    "loadTemplate": "Carregar informe sense canvis",
    "templateNotes": "Vols modificar res en generar el nou informe?",
    "templateNotesPlaceholder": "Ex.: Canviar troballes al fetge, afegir nòdul pulmonar de 8mm…",
    "needDescriptive": "Escriu alguna cosa al camp de text per poder generar",
    "useAsTemplate": "Generar utilitzant això com a plantilla",
    "noReportContent": "No hi ha contingut d'informe disponible",
    "searchStudies": "Cercar per procediment o data…",
    "previousStudy": "Estudi previ",
    "makeChanges": "Fer canvis",
    "makeChangesPlaceholder": "Descriu els canvis que vols fer a l'informe comparatiu…",
    "classificationSectionsEmpty": "Les seccions de tècnica, troballes i conclusió han d'estar completes per classificar",
    "classificationSuccess": "Classificació feta correctament",
    "classificationError": "Error en fer la classificació",
    "editorNotReady": "L'editor no està preparat",
    "classificationUnchanged": "El contingut de l'informe no ha canviat des de l'última classificació.",
    "classificationNoFindings": "No s'han localitzat troballes compatibles amb aquesta classificació",
    "classificationInResearch": "Aquesta funcionalitat està en fase de recerca. Si la vols utilitzar, sol·licita-la a l'administrador.",
    "classifications": "Classificacions",
    "classificationsTitle": "Classificacions",
    "fleischnerClassification": "Classificació de Fleischner",
    "fleischnerDesc": "Nòduls pulmonars incidentals — Fleischner 2017",
    "analyzing": "Analitzant…",
    "classify": "Classificar",
    "results": "Resultats",
    "table": "Taula",
    "fleischnerCriteria": "Criteris de Fleischner",
    "fleischner_toggleHighlight": "Mostrar/amagar ressaltat",
    "fleischnerDescription": "Guies de seguiment per a nòduls pulmonars incidentals detectats per TC, segons la mida, el nombre i el tipus de nòdul.",
    "singleSolidNodule": "Nòdul sòlid únic",
    "multipleSolidNodules": "Múltiples nòduls sòlids",
    "subsolidNodules": "Nòduls subsòlids",
    "pureGroundGlass": "Vidre esmerilat pur",
    "partSolidNodule": "Nòdul parcialment sòlid",
    "size": "Mida",
    "lowRisk": "Risc baix",
    "highRisk": "Risc alt",
    "followUp": "Seguiment",
    "noFollowUp": "Sense seguiment",
    "partSolidNote": "Si la part sòlida ≥ 6 mm, considerar PET-TC o resecció.",
    "reference": "Referència: MacMahon H et al.",
    "singleLt6LowRisk": "Sense seguiment",
    "singleLt6HighRisk": "TC als 12 mesos (opcional)",
    "single6to8LowRisk": "TC als 6–12 mesos → considerar als 18–24 mesos",
    "single6to8HighRisk": "TC als 6–12 mesos → repetir als 18–24 mesos",
    "singleGt8LowRisk": "Considerar TC als 3 mesos, PET-TC o biòpsia",
    "singleGt8HighRisk": "Igual que en el risc baix",
    "multipleLt6LowRisk": "Sense seguiment",
    "multipleLt6HighRisk": "TC als 12 mesos",
    "multipleGte6LowRisk": "TC als 3–6 mesos → considerar als 18–24 mesos",
    "multipleGte6HighRisk": "TC als 3–6 mesos → repetir als 18–24 mesos",
    "ggLt6": "Sense seguiment",
    "ggGte6": "TC als 6–12 mesos → després cada 2 anys fins als 5 anys",
    "psLt6": "Sense seguiment",
    "psGte6": "TC als 3–6 mesos → si persisteix, control anual fins als 5 anys",
    "conclusionNoFollowUp": "No requereix seguiment segons els criteris de Fleischner 2017.",
    "conclusionOptionalCT12": "Es recomana un control opcional amb TC als 12 mesos segons els criteris de Fleischner 2017.",
    "conclusionCT6to12Consider18to24": "Es recomana un control amb TC als 6-12 mesos, considerant un seguiment addicional als 18-24 mesos segons els criteris de Fleischner 2017.",
    "conclusionCT6to12Repeat18to24": "Es recomana un control amb TC als 6-12 mesos, amb seguiment addicional als 18-24 mesos segons els criteris de Fleischner 2017.",
    "conclusionConsiderCT3PetBiopsy": "Es recomana considerar TC als 3 mesos, PET-TC o biòpsia segons els criteris de Fleischner 2017.",
    "conclusionCT12": "Es recomana un control amb TC als 12 mesos segons els criteris de Fleischner 2017.",
    "conclusionCT3to6Consider18to24": "Es recomana un control amb TC als 3-6 mesos, considerant un seguiment addicional als 18-24 mesos segons els criteris de Fleischner 2017.",
    "conclusionCT3to6Repeat18to24": "Es recomana un control amb TC als 3-6 mesos, amb seguiment addicional als 18-24 mesos segons els criteris de Fleischner 2017.",
    "conclusionCT6to12Every2y5y": "Es recomana un control amb TC als 6-12 mesos, seguit de controls cada 2 anys fins a completar 5 anys segons els criteris de Fleischner 2017.",
    "conclusionCT3to6Annual5y": "Es recomana un control amb TC als 3-6 mesos i, si persisteix, un seguiment anual durant 5 anys segons els criteris de Fleischner 2017.",
    "tirads_classification": "Classificació TI-RADS",
    "tirads_desc": "Nòduls tiroïdals — ACR TI-RADS 2017",
    "tirads_criteria": "Criteris ACR TI-RADS",
    "tirads_description": "Sistema de puntuació per a nòduls tiroïdals detectats per ecografia, basat en la composició, l'ecogenicitat, la forma, els marges i els focus ecogènics.",
    "tirads_composition": "Composició",
    "tirads_echogenicity": "Ecogenicitat",
    "tirads_shape": "Forma",
    "tirads_margin": "Marges",
    "tirads_echogenicFoci": "Focus ecogènics",
    "tirads_feature": "Característica",
    "tirads_points": "Punts",
    "tirads_compositionCystic": "Quístic o gairebé completament quístic",
    "tirads_compositionSpongiform": "Espongiforme",
    "tirads_compositionMixed": "Mixt quístic i sòlid",
    "tirads_compositionSolid": "Sòlid o gairebé completament sòlid",
    "tirads_echogenicityAnechoic": "Anecoic",
    "tirads_echogenicityHyperIso": "Hiperecogènic o isoecoic",
    "tirads_echogenicityHypo": "Hipoecoic",
    "tirads_echogenicityVeryHypo": "Molt hipoecoic",
    "tirads_shapeWider": "Més ample que alt",
    "tirads_shapeTaller": "Més alt que ample",
    "tirads_marginSmooth": "Llis",
    "tirads_marginIllDefined": "Mal definit",
    "tirads_marginLobulated": "Lobulat o irregular",
    "tirads_marginExtrathyroidal": "Extensió extratiroïdal",
    "tirads_fociNone": "Cap o artefactes de cua de cometa grans",
    "tirads_fociMacro": "Macrocalcificacions",
    "tirads_fociPeripheral": "Calcificacions perifèriques (en anell)",
    "tirads_fociPunctate": "Focus ecogènics puntiformes",
    "tirads_categoriesTitle": "Categories i recomanacions",
    "tirads_categoryCol": "Categoria",
    "tirads_fnaThreshold": "PAAF si",
    "tirads_followUpThreshold": "Seguiment si",
    "tirads_tr1_name": "TR1 — Benigne",
    "tirads_tr2_name": "TR2 — No sospitós",
    "tirads_tr3_name": "TR3 — Lleugerament sospitós",
    "tirads_tr4_name": "TR4 — Moderadament sospitós",
    "tirads_tr5_name": "TR5 — Altament sospitós",
    "tirads_scoringNote": "Sumar els punts de cada categoria (el valor més alt de cadascuna). Només s'aplica a nòduls ≥ 1 cm o amb característiques sospitoses.",
    "tirads_reference": "Referència: Tessler FN et al.",
    "tirads_conclusionTR1": "Nòdul tiroïdal classificat com a TI-RADS 1 (benigne). No requereix PAAF ni seguiment segons ACR TI-RADS 2017.",
    "tirads_conclusionTR2": "Nòdul tiroïdal classificat com a TI-RADS 2 (no sospitós). No requereix PAAF ni seguiment segons ACR TI-RADS 2017.",
    "tirads_conclusionTR3": "Nòdul tiroïdal classificat com a TI-RADS 3 (lleugerament sospitós). Es recomana PAAF si ≥ 2.5 cm o seguiment si ≥ 1.5 cm segons ACR TI-RADS 2017.",
    "tirads_conclusionTR4": "Nòdul tiroïdal classificat com a TI-RADS 4 (moderadament sospitós). Es recomana PAAF si ≥ 1.5 cm o seguiment si ≥ 1 cm segons ACR TI-RADS 2017.",
    "tirads_conclusionTR5": "Nòdul tiroïdal classificat com a TI-RADS 5 (altament sospitós). Es recomana PAAF si ≥ 1 cm o seguiment si ≥ 0.5 cm segons ACR TI-RADS 2017.",
    "tirads_chooseOne": "Triar 1",
    "tirads_chooseAll": "Tots els que siguin aplicables",
    "tirads_sumPoints": "Sumar punts de totes les categories",
    "tirads_selectOptions": "Selecciona opcions",
    "tirads_recommendationCol": "Recomanació",
    "tirads_noFnaNoFollowUp": "Sense PAAF · Sense seguiment",
    "tirads_tr1_label": "Benigne",
    "tirads_tr2_label": "No sospitós",
    "tirads_tr3_label": "Lleugerament sospitós",
    "tirads_tr4_label": "Moderadament sospitós",
    "tirads_tr5_label": "Altament sospitós",
    "pirads_classification": "Classificació PI-RADS",
    "pirads_desc": "Lesions prostàtiques — PI-RADS v2.1",
    "pirads_title": "PI-RADS v2.1 — Classificació per zones",
    "pirads_description": "Sistema de puntuació per a la detecció de càncer de pròstata clínicament significatiu mitjançant RM multiparamètrica. Basat en la guia de Radiology Assistant.",
    "pirads_dominant": "Dominant",
    "pirads_secondary": "Secundari",
    "pirads_probabilityCol": "Probabilitat",
    "pirads_refinedV21": "Refinat v2.1",
    "pirads_tabPZ": "Zona perifèrica (PZ)",
    "pirads_tabTZ": "Zona transicional (TZ)",
    "pirads_tabDCE": "DCE i ajustos",
    "pirads_tabInfo": "Protocol i TNM",
    "pirads_zonePZ": "Zona perifèrica",
    "pirads_zoneTZ": "Zona transicional",
    "pirads_pr1_legend": "PI-RADS 1 — Molt baix",
    "pirads_pr2_legend": "PI-RADS 2 — Baix",
    "pirads_pr3_legend": "PI-RADS 3 — Equívoc",
    "pirads_pr4_legend": "PI-RADS 4 — Alt",
    "pirads_pr5_legend": "PI-RADS 5 — Molt alt",
    "pirads_pr1_label": "Molt baix",
    "pirads_pr2_label": "Baix",
    "pirads_pr3_label": "Equívoc",
    "pirads_pr4_label": "Alt",
    "pirads_pr5_label": "Molt alt",
    "pirads_pr1_prob_short": "< 3%",
    "pirads_pr2_prob_short": "~5%",
    "pirads_pr3_prob_short": "~12-18%",
    "pirads_pr4_prob_short": "~25-40%",
    "pirads_pr5_prob_short": "~60-90%",
    "pirads_pz1_dwi": "Sense anomalia visible en ADC ni en DWI d'alt valor b.",
    "pirads_pz1_t2w": "Senyal hiperintens homogeni normal.",
    "pirads_pz1_prob": "Molt baixa (< 3%)",
    "pirads_pz2_dwi": "Hipointensitat en ADC i/o hiperintensitat en DWI amb configuració lineal o en falca.",
    "pirads_pz2_t2w": "Hipointensitat difusa o en falca.",
    "pirads_pz2_prob": "Baixa (~5%)",
    "pirads_pz3_dwi": "Hipointensitat focal en ADC i/o hiperintensitat focal en DWI. Pot ser marcada en un però no en tots dos simultàniament.",
    "pirads_pz3_t2w": "Hipointensitat focal heterogènia, no marcada.",
    "pirads_pz3_prob": "Intermèdia (~12-18%)",
    "pirads_pz3_dce_adjust": "Puja a PI-RADS 4 si hi ha un realçament focal precoç. Si DCE (−), es manté en 3.",
    "pirads_pz4_dwi": "Hipointensitat marcada focal en ADC i hiperintensitat marcada en DWI.",
    "pirads_pz4_t2w": "Hipointensitat focal marcada.",
    "pirads_pz4_prob": "Alta (~25-40%)",
    "pirads_pz5_dwi": "Igual que la puntuació 4 però ≥ 1.5 cm o extensió extraprostàtica (EPE) / comportament invasiu definitiu.",
    "pirads_pz5_t2w": "Hipointensitat marcada focal amb possible invasió.",
    "pirads_pz5_prob": "Molt alta (~60-90%)",
    "pirads_tz1_t2w": "ZT d'aspecte normal o nòdul arrodonit completament encapsulat (\"nòdul típic\").",
    "pirads_tz1_dwi": "Normal.",
    "pirads_tz1_prob": "Molt baixa (< 2%)",
    "pirads_tz2_t2w": "Nòdul majoritàriament encapsulat, o nòdul homogeni circumscrit sense càpsula (\"nòdul atípic\"), o àrea homogènia lleugerament hipointensa entre nòduls.",
    "pirads_tz2_dwi": "DWI ≤ 3: no altera la puntuació.",
    "pirads_tz2_prob": "Baixa (~5%)",
    "pirads_tz2_dwi_adjust": "Puja a PI-RADS 3. Si DWI ≤ 3, es manté en 2.",
    "pirads_tz3_t2w": "Senyal heterogeni amb marges poc definits. Inclou troballes que no compleixen els criteris de les categories 2, 4 o 5.",
    "pirads_tz3_dwi": "DWI < 5: no altera la puntuació.",
    "pirads_tz3_prob": "Intermèdia (~10-15%)",
    "pirads_tz3_dwi_adjust": "Puja a PI-RADS 4. Si DWI ≤ 4, es manté en 3.",
    "pirads_tz4_t2w": "Lesió lenticular o no circumscrita, homogènia, moderadament hipointensa.",
    "pirads_tz4_dwi": "Restricció de difusió moderada-marcada.",
    "pirads_tz4_prob": "Alta (~25-40%)",
    "pirads_tz5_t2w": "Igual que la puntuació 4 però ≥ 1.5 cm o extensió extraprostàtica / comportament invasiu definitiu.",
    "pirads_tz5_dwi": "Restricció marcada de difusió.",
    "pirads_tz5_prob": "Molt alta (~60-90%)",
    "pirads_dcePositive": "DCE positiu (+)",
    "pirads_dcePositiveDesc": "Realçament focal, precoç o contemporani amb el realçament del teixit prostàtic normal adjacent, i que correspongui a una troballa sospitosa en T2W i/o DWI.",
    "pirads_dceNegative": "DCE negatiu (−)",
    "pirads_dceNeg1": "Absència de realçament precoç.",
    "pirads_dceNeg2": "Realçament difús, no corresponent a la lesió focal en T2W/DWI.",
    "pirads_dceNeg3": "Realçament focal que correspon a un nòdul d'HBP.",
    "pirads_zoneCol": "Zona",
    "pirads_baseScoreCol": "Puntuació base",
    "pirads_conditionCol": "Condició",
    "pirads_finalScoreCol": "Puntuació final",
    "pirads_dce_pz_3_pos_base": "DWI/ADC = 3",
    "pirads_dce_pz_3_pos_cond": "DCE (+) → Realçament focal precoç",
    "pirads_dce_pz_3_pos_final": "↑ PI-RADS 4",
    "pirads_dce_pz_3_neg_base": "DWI/ADC = 3",
    "pirads_dce_pz_3_neg_cond": "DCE (−) → Sense realçament focal",
    "pirads_dce_pz_3_neg_final": "PI-RADS 3",
    "pirads_dce_tz_2_up_base": "T2W = 2",
    "pirads_dce_tz_2_up_cond": "DWI ≥ 4",
    "pirads_dce_tz_2_up_final": "↑ PI-RADS 3",
    "pirads_dce_tz_2_stay_base": "T2W = 2",
    "pirads_dce_tz_2_stay_cond": "DWI ≤ 3",
    "pirads_dce_tz_2_stay_final": "PI-RADS 2",
    "pirads_dce_tz_3_up_base": "T2W = 3",
    "pirads_dce_tz_3_up_cond": "DWI = 5 (marcadament intens ≥ 1.5 cm)",
    "pirads_dce_tz_3_up_final": "↑ PI-RADS 4",
    "pirads_dce_tz_3_stay_base": "T2W = 3",
    "pirads_dce_tz_3_stay_cond": "DWI ≤ 4",
    "pirads_dce_tz_3_stay_final": "PI-RADS 3",
    "pirads_afmsTitle": "Estroma fibromuscular anterior (AFMS)",
    "pirads_afmsDesc": "El càncer de pròstata no s'origina a l'AFMS. Quan s'identifica una lesió sospitosa en aquesta zona, s'han d'aplicar els criteris de la zona (PZ o TZ) d'on probablement s'origina la lesió. L'AFMS normal mostra una forma simètrica de mitja lluna bilateral amb un senyal baix homogeni similar al múscul obturador en T2W, ADC i DWI alt.",
    "pirads_protocolTitle": "Protocol d'RM recomanat (v2.1)",
    "pirads_protocolT2W": "Pla axial (o oblic perpendicular a l'eix llarg de la pròstata) + almenys un pla ortogonal addicional (sagital i/o coronal).",
    "pirads_protocolDWI": "Valor b baix (0-100, preferible 50-100), intermedi (800-1000) i alt (≥ 1400 s/mm²) obligatori. Mapa ADC calculat.",
    "pirads_protocolDCE": "Resolució temporal ≤ 15 s. Preferiblement 3D T1W GRE.",
    "pirads_protocolT1W": "Per detectar hemorràgia postbiòpsia. FOV ampli fins a la bifurcació aòrtica per als ganglis i les metàstasis òssies.",
    "pirads_csCancerTitle": "Càncer clínicament significatiu (definició PI-RADS)",
    "pirads_csCancer1": "Puntuació de Gleason ≥ 7 (incloent-hi 3+4 amb component Gleason 4 prominent).",
    "pirads_csCancer2": "Volum tumoral > 0.5 cc.",
    "pirads_csCancer3": "Extensió extraprostàtica (EPE).",
    "pirads_volumeTitle": "Volum prostàtic i densitat de PSA",
    "pirads_ellipsoidFormula": "Fórmula de l'el·lipsoide",
    "pirads_psaDensity": "Densitat de PSA ≥ 0.20 → sospita de malignitat clínicament significativa.",
    "pirads_rtLimit": "Límit per a radioteràpia externa convencional: 55 cc.",
    "pirads_tStagingTitle": "Estadificació T rellevant per a la imatge",
    "pirads_stageT2": "Tumor confinat a la pròstata (T2a: ≤ meitat d'un lòbul; T2b: > meitat d'un lòbul; T2c: tots dos lòbuls).",
    "pirads_stageT3a": "Extensió extraprostàtica (EPE).",
    "pirads_stageT3b": "Invasió de les vesícules seminals.",
    "pirads_stageT4": "Invasió d'estructures adjacents (recte, paret pelviana, esfínter, bufeta).",
    "pirads_stageN1": "Ganglis regionals positius (pelvians, hipogàstrics, sacres, ilíacs).",
    "pirads_stageM1a": "Ganglis a distància (aòrtics, ilíacs comuns, inguinals).",
    "pirads_nodesTitle": "Ganglis sospitosos (estadificació N)",
    "pirads_node1": "Rodó amb eix curt ≥ 8 mm.",
    "pirads_node2": "Oval amb eix curt ≥ 10 mm.",
    "pirads_node3": "Aspecte heterogeni.",
    "pirads_node4": "Marges irregulars.",
    "pirads_node5": "DWI és la millor seqüència per a la detecció ganglionar.",
    "pirads_changesTitle": "Canvis clau v2.0 → v2.1",
    "pirads_change1": "Els nòduls rodons completament encapsulats en TZ ara són PI-RADS 1 (abans 2).",
    "pirads_change2": "Criteris més precisos per a la categoria 2 en TZ i PZ.",
    "pirads_change3": "Actualització de les recomanacions del valor b DWI i de la resolució temporal DCE.",
    "pirads_change4": "Consideracions especials per a l'AFMS i la zona central.",
    "pirads_change5": "Guia millorada per a l'avaluació del senyal de fons en TZ.",
    "pirads_scoringNote": "La seqüència dominant determina la puntuació base. En PZ la dominant és DWI/ADC; en TZ la dominant és T2W. Els ajustos DCE i DWI poden modificar la puntuació final.",
    "pirads_reference": "Font: Radiology Assistant — PI-RADS v2.1. Només per a ús educatiu i de referència clínica.",
    "pirads_conclusionPR1": "Lesió prostàtica classificada com a PI-RADS 1 (probabilitat molt baixa de càncer clínicament significatiu). No requereix seguiment especial.",
    "pirads_conclusionPR2": "Lesió prostàtica classificada com a PI-RADS 2 (probabilitat baixa de càncer clínicament significatiu). No requereix biòpsia.",
    "pirads_conclusionPR3": "Lesió prostàtica classificada com a PI-RADS 3 (probabilitat equívoca de càncer clínicament significatiu). Es recomana correlació clínica i possible seguiment o biòpsia segons el context clínic.",
    "pirads_conclusionPR4": "Lesió prostàtica classificada com a PI-RADS 4 (probabilitat alta de càncer clínicament significatiu). Es recomana biòpsia dirigida.",
    "pirads_conclusionPR5": "Lesió prostàtica classificada com a PI-RADS 5 (probabilitat molt alta de càncer clínicament significatiu). Es recomana biòpsia dirigida urgent.",
    "bosniak_classification": "Classificació Bosniak 2019",
    "bosniak_desc": "Masses renals quístiques — Bosniak 2019",
    "bosniak_criteria": "Criteris Bosniak 2019",
    "bosniak_description": "Sistema de classificació per a masses renals quístiques basat en les característiques de la paret, els septes, el realçament, la calcificació, la nodularitat i l'atenuació per TC/RM.",
    "bosniak_wall": "Paret",
    "bosniak_septa": "Septes",
    "bosniak_enhancement": "Realçament",
    "bosniak_calcification": "Calcificació",
    "bosniak_attenuation": "Atenuació / Senyal",
    "bosniak_chooseOne": "Triar 1",
    "bosniak_highestCategory": "La categoria més alta determina la classificació",
    "bosniak_selectFeatures": "Selecciona característiques",
    "bosniak_malignancyRisk": "Risc de malignitat",
    "bosniak_wallThinSmooth": "Paret prima (≤ 2 mm) llisa",
    "bosniak_wallThinSmoothWithSepta": "Paret prima (≤ 2 mm) llisa (amb septes o calcificació)",
    "bosniak_wallMinimalThickening3mm": "Engruiximent mínim llis (3 mm) amb realçament",
    "bosniak_wallThickOrIrregular": "Paret gruixuda (≥ 4 mm) o irregular amb realçament",
    "bosniak_wallWithNodule": "Paret amb nòdul(s) amb realçament",
    "bosniak_septaNone": "Sense septes",
    "bosniak_septaFewThin": "Pocs (1–3) septes prims (≤ 2 mm) amb realçament",
    "bosniak_septaMinimalThickeningOrMany": "Engruiximent mínim (3 mm) dels septes o ≥ 4 septes prims",
    "bosniak_septaThickOrIrregular": "Septes gruixuts (≥ 4 mm) o irregulars amb realçament",
    "bosniak_septaWithNodule": "Septes amb nòdul(s) (≥ 4 mm obtús o qualsevol angle agut)",
    "bosniak_enhanceWallOnly": "La paret pot realçar-se; sense realçament intern",
    "bosniak_enhanceSeptaWall": "Els septes i la paret poden realçar-se",
    "bosniak_enhanceSmoothMinimal": "Realçament llis de la paret o els septes (3 mm)",
    "bosniak_enhanceThickIrregular": "Realçament de la paret o els septes gruixuts/irregulars",
    "bosniak_enhanceNodular": "Component(s) nodular(s) amb realçament",
    "bosniak_calcNone": "Sense calcificació",
    "bosniak_calcAnyType": "Calcificació de qualsevol tipus (paret prima, pocs septes)",
    "bosniak_attenSimpleFluid": "Líquid simple homogeni (−9 a 20 UH)",
    "bosniak_attenHyperNonContrast": "Hiperatenuant homogeni (≥ 70 UH) TC sense contrast",
    "bosniak_attenNonEnhancingGt20": "Homogeni sense realçament > 20 UH (protocol renal de TC)",
    "bosniak_attenPortalVenous2130": "Homogeni 21–30 UH en fase portal venosa",
    "bosniak_attenTooSmall": "Homogeni de baixa atenuació, massa petit per caracteritzar",
    "bosniak_attenHeteroT1Hyper": "Heterogeni en T1 sense contrast amb saturació de greix (hiperintens)",
    "bosniak_bI_label": "Benigne",
    "bosniak_bII_label": "Mínimament complex",
    "bosniak_bIIF_label": "Mínimament complex (seguiment)",
    "bosniak_bIII_label": "Indeterminat",
    "bosniak_bIV_label": "Clarament maligne",
    "bosniak_scoringNote": "La categoria Bosniak final es determina per la característica de grau més alt. No aplicar en lesions amb > 25% de component sòlid, etiologia infecciosa/inflamatòria o vascular.",
    "bosniak_reference": "Referència: Silverman SG et al.",
    "bosniak_conclusionI": "Massa renal quística classificada com a Bosniak I (benigna). No requereix seguiment segons la classificació Bosniak 2019.",
    "bosniak_conclusionII": "Massa renal quística classificada com a Bosniak II (mínimament complexa, benigna). Risc de malignitat < 1%. No requereix seguiment segons la classificació Bosniak 2019.",
    "bosniak_conclusionIIF": "Massa renal quística classificada com a Bosniak IIF (mínimament complexa, requereix seguiment). Risc de malignitat 5–10%. Es recomana seguiment per imatge segons la classificació Bosniak 2019.",
    "bosniak_conclusionIII": "Massa renal quística classificada com a Bosniak III (indeterminada). Risc de malignitat ~50%. Es recomana cirurgia o vigilància activa segons el context clínic i la classificació Bosniak 2019.",
    "bosniak_conclusionIV": "Massa renal quística classificada com a Bosniak IV (clarament maligna). Risc de malignitat ~90%. Es recomana tractament quirúrgic segons la classificació Bosniak 2019.",
    "bosniak_tabScoring": "Calculadora",
    "bosniak_tabCategories": "Categories",
    "bosniak_tabImaging": "Imatge",
    "bosniak_tabInfo": "Info",
    "bosniak_wallDesc": "Avaluació del gruix, la regularitat i la presència de nòduls a la paret del quist renal. L'engruiximent o la irregularitat de la paret incrementa la categoria Bosniak.",
    "bosniak_septaDesc": "Valoració del nombre, el gruix i la regularitat dels septes intraquístics. Els septes gruixuts o amb nòduls suggereixen més risc de malignitat.",
    "bosniak_enhancementDesc": "Patró de realçament després de l'administració de contrast intravenós. El realçament veritable (≥ 20 UH) dels components sòlids és clau per diferenciar masses benignes de malignes.",
    "bosniak_calcificationDesc": "La calcificació per si sola no canvia la categoria Bosniak en la versió 2019. Es documenta però no altera la classificació.",
    "bosniak_attenuationDesc": "Característiques d'atenuació (TC) o de senyal (RM) del contingut quístic. Els valors d'UH i el patró de senyal determinen si el quist és simple o complex.",
    "bosniak_typicalFindings": "Troballes típiques",
    "bosniak_catI_desc": "Quist renal simple. Paret prima i imperceptible, contingut homogeni de densitat d'aigua (−9 a 20 UH), sense septes, calcificació ni realçament intern.",
    "bosniak_catI_finding1": "Paret prima (≤ 2 mm), llisa, sense realçament mural apreciable",
    "bosniak_catI_finding2": "Contingut homogeni d'aigua (−9 a 20 UH) sense septes",
    "bosniak_catI_finding3": "Senyal d'RM: hiperintens en T2, hipointens en T1 sense restricció de difusió",
    "bosniak_catII_desc": "Quist mínimament complex sense realçament sospitós. Inclou quists amb pocs septes prims, calcificació fina o contingut hiperdens sense realçament.",
    "bosniak_catII_finding1": "Pocs septes prims (≤ 2 mm) que poden realçar-se",
    "bosniak_catII_finding2": "Calcificació de qualsevol tipus en paret fina o septes fins",
    "bosniak_catII_finding3": "Quists hiperdensos ≥ 70 UH o sense realçament > 20 UH",
    "bosniak_catIIF_desc": "Quist mínimament complex que requereix seguiment. Presenta característiques lleugerament més complexes que Bosniak II, però sense realçament clarament sospitós.",
    "bosniak_catIIF_finding1": "Engruiximent mínim llis (3 mm) de la paret o els septes amb realçament",
    "bosniak_catIIF_finding2": "Múltiples septes prims (≥ 4) o complexitat moderada",
    "bosniak_catIIF_finding3": "Senyal heterogeni en T1 amb saturació de greix (hiperintens)",
    "bosniak_catIII_desc": "Massa quística indeterminada. Presenta troballes sospitoses com ara engruiximent irregular de la paret/els septes amb realçament, però sense component clarament nodular.",
    "bosniak_catIII_finding1": "Paret o septes gruixuts (≥ 4 mm) o irregulars amb realçament",
    "bosniak_catIII_finding2": "Realçament mesurable de components engruixits/irregulars",
    "bosniak_catIII_finding3": "Sense nòdul mural o septal clarament definit",
    "bosniak_catIV_desc": "Massa quística clarament maligna. Conté component(s) nodular(s) sòlid(s) amb realçament, cosa que indica carcinoma de cèl·lules renals fins que es demostri el contrari.",
    "bosniak_catIV_finding1": "Nòdul(s) mural(s) o septal(s) amb realçament (component sòlid)",
    "bosniak_catIV_finding2": "Marges aguts del nòdul (< 90°) amb la paret o el septe",
    "bosniak_catIV_finding3": "Component sòlid amb realçament i restricció de difusió",
    "bosniak_protocolTitle": "Protocol de TC renal",
    "bosniak_phasePrecontrast": "Fase sense contrast",
    "bosniak_phasePrecontrastDesc": "Mesurar l'atenuació basal del quist (UH). Clau per detectar quists hiperdensos i calcular el realçament veritable.",
    "bosniak_phaseCorticomedullary": "Fase corticomedul·lar",
    "bosniak_phaseCorticomedullaryDesc": "25–70 s postinjecció. Útil per detectar realçament precoç, però es prefereix la fase nefrogràfica per a Bosniak.",
    "bosniak_phaseNephrographic": "Fase nefrogràfica",
    "bosniak_phaseNephrographicDesc": "80–180 s postinjecció. Fase òptima per avaluar el realçament de la paret/els septes. És la fase més important per a la classificació.",
    "bosniak_phaseExcretory": "Fase excretora",
    "bosniak_phaseExcretoryDesc": "≥ 3 min. Valorar la relació amb el sistema col·lector i descartar un diverticle calicial.",
    "bosniak_enhancementCritTitle": "Criteris de realçament",
    "bosniak_enhanceCrit1": "Realçament veritable: increment ≥ 20 UH entre la fase sense contrast i la nefrogràfica",
    "bosniak_enhanceCrit2": "Pseudorealçament: increment < 10 UH per dispersió/enduriment del feix, no és realçament veritable",
    "bosniak_enhanceCrit3": "Zona grisa (10–20 UH): considerar RM amb subtracció per confirmar",
    "bosniak_mriTitle": "Avaluació per RM",
    "bosniak_mriT1": "Pre i post-Gd amb saturació de greix. Subtracció obligatòria per detectar realçament subtil.",
    "bosniak_mriT2": "Contingut quístic hiperintens. Els components sòlids són relativament hipointensos.",
    "bosniak_mriDWI": "Útil com a complement. La restricció de difusió pot indicar un component sòlid, però no substitueix el realçament.",
    "bosniak_mriSubtraction": "Subtracció",
    "bosniak_mriSubtractionDesc": "Imprescindible en RM. Sostreu T1 pre-Gd de T1 post-Gd per aïllar el realçament veritable del senyal intrínsec T1.",
    "bosniak_pitfallsTitle": "Errors diagnòstics freqüents",
    "bosniak_pitfall1": "Confondre el pseudorealçament per dispersió amb realçament veritable en quists petits (< 2 cm) adjacents al parènquima",
    "bosniak_pitfall2": "No mesurar l'atenuació basal sense contrast — és impossible determinar el realçament veritable sense referència",
    "bosniak_pitfall3": "Classificar quists hemorràgics/proteïnacis (hiperdensos) com a complexos quan NO es realcen",
    "bosniak_pitfall4": "Aplicar Bosniak a masses amb > 25% de component sòlid — la classificació no està dissenyada per a masses sòlides",
    "bosniak_changesTitle": "Canvis de Bosniak 2019 respecte a la versió anterior",
    "bosniak_change1": "Eliminació de la distinció entre Bosniak I i II basada en la calcificació — la calcificació ja no afecta la categoria",
    "bosniak_change2": "Nova definició dels llindars de gruix: ≤ 2 mm (prim), 3 mm (mínimament engruixit), ≥ 4 mm (gruixut)",
    "bosniak_change3": "Incorporació formal de l'RM com a modalitat equivalent a la TC per a la classificació",
    "bosniak_change4": "Es defineix clarament que el nòdul mural/septal (component sòlid amb realçament) = Bosniak IV",
    "bosniak_change5": "La regla del 'grau màxim' es manté: la característica individual més sospitosa determina la categoria final",
    "bosniak_indicationsTitle": "Indicacions",
    "bosniak_indication1": "Masses renals quístiques incidentals detectades en TC o RM amb contrast",
    "bosniak_indication2": "Seguiment de quists prèviament classificats com a Bosniak IIF",
    "bosniak_indication3": "Avaluació preoperatòria de masses renals quístiques complexes per a la planificació quirúrgica",
    "bosniak_limitationsTitle": "Limitacions",
    "bosniak_limitation1": "No aplicar a masses renals amb > 25% de component sòlid (utilitzar la classificació de masses sòlides)",
    "bosniak_limitation2": "No és vàlida sense contrast intravenós — el realçament és un pilar fonamental de la classificació",
    "bosniak_limitation3": "Excloure masses d'etiologia infecciosa/inflamatòria coneguda (abscessos, quists infectats)",
    "bosniak_limitation4": "No està dissenyada per a masses quístiques d'origen vascular (aneurismes, MAV renals)",
    "bosniak_followUpTitle": "Seguiment recomanat",
    "bosniak_followUp12": "No requereix seguiment per imatge",
    "bosniak_followUpIIF": "TC o RM als 6 i 12 mesos, després anual durant 5 anys. Si progressa → reclassificar.",
    "bosniak_followUpIII": "Cirurgia parcial/radical o vigilància activa amb imatge cada 6 mesos segons les comorbiditats i la preferència del pacient.",
    "bosniak_followUpIV": "Tractament quirúrgic (preferiblement nefrectomia parcial si és tècnicament factible). Biòpsia si cal confirmació preoperatòria.",
    "bosniak_referencesTitle": "Referències",
    "garden_classification": "Classificació Garden",
    "garden_desc": "Fractures subcapitals del coll femoral — Garden",
    "garden_criteria": "Classificació de Garden",
    "garden_description": "Sistema de classificació per a fractures subcapitals del coll femoral basat en el grau de desplaçament dels fragments ossis a la radiografia AP.",
    "garden_fracturePattern": "Patró de fractura",
    "garden_trabecularPattern": "Patró trabecular",
    "garden_chooseOne": "Triar 1",
    "garden_highestGrade": "El grau més alt determina la classificació",
    "garden_selectFeatures": "Selecciona característiques",
    "garden_displacement": "Desplaçament",
    "garden_fractureIncomplete": "Fractura incompleta (impactació en valg, només la cortical inferior)",
    "garden_fractureCompleteNondisplaced": "Fractura completa, no desplaçada (totes dues corticals trencades, alineades)",
    "garden_fractureCompletePartial": "Fractura completa, parcialment desplaçada",
    "garden_fractureCompleteFull": "Fractura completa, totalment desplaçada (sense contacte entre fragments)",
    "garden_trabecularAngulated": "Trabècules angulades (patró d'impactació en valg)",
    "garden_trabecularInterrupted": "Trabècules interrompudes, alineades a través del traç de fractura",
    "garden_trabecularDisrupted": "Trabècules amb discontinuïtat i rotació del cap femoral",
    "garden_trabecularNone": "Sense continuïtat trabecular (separació completa)",
    "garden_gI_label": "Incompleta / Impactada en valg",
    "garden_gII_label": "Completa, no desplaçada",
    "garden_gIII_label": "Completa, parcialment desplaçada",
    "garden_gIV_label": "Completa, totalment desplaçada",
    "garden_scoringNote": "El grau Garden final es determina pel nivell de desplaçament observat. En la pràctica clínica, els graus I-II (no desplaçades) i III-IV (desplaçades) s'agrupen per prendre decisions terapèutiques.",
    "garden_reference": "Referència:",
    "garden_conclusionI": "Fractura subcapital del coll femoral classificada com a Garden I (fractura incompleta / impactada en valg). Es recomana fixació interna amb cargols canulats.",
    "garden_conclusionII": "Fractura subcapital del coll femoral classificada com a Garden II (fractura completa, no desplaçada). Es recomana fixació interna amb cargols canulats.",
    "garden_conclusionIII": "Fractura subcapital del coll femoral classificada com a Garden III (fractura completa, parcialment desplaçada). Es recomana artroplàstia parcial o total segons l'edat i el nivell d'activitat del pacient.",
    "garden_conclusionIV": "Fractura subcapital del coll femoral classificada com a Garden IV (fractura completa, totalment desplaçada). Es recomana artroplàstia parcial o total segons l'edat i el nivell d'activitat del pacient.",
    "garden_clickToInsert": "Fes clic per inserir la recomanació a l'informe",
    "garden_toggleHighlight": "Mostrar/amagar ressaltat",
    "eaton_classification": "Classificació Eaton-Littler",
    "eaton_desc": "Artrosi trapeziometacarpiana (rizartrosi) — Eaton-Littler",
    "eaton_criteria": "Classificació d'Eaton-Littler",
    "eaton_description": "Sistema de classificació radiològica per a l'artrosi trapeziometacarpiana (rizartrosi) basat en l'estrenyiment articular, els osteòfits, la subluxació i l'afectació de l'articulació escafotrapeziotrapezoïdal (ETT).",
    "eaton_jointSpace": "Espai articular",
    "eaton_osteophytes": "Osteòfits",
    "eaton_subluxation": "Subluxació",
    "eaton_sttJoint": "Articulació ETT",
    "eaton_chooseOne": "Triar 1",
    "eaton_highestStage": "L'estadi més alt determina la classificació",
    "eaton_selectFeatures": "Selecciona característiques",
    "eaton_jointNormal": "Espai articular normal o lleugerament eixamplat",
    "eaton_jointSlightNarrowing": "Estrenyiment lleu de l'espai articular",
    "eaton_jointMarkedNarrowing": "Estrenyiment marcat o destrucció articular",
    "eaton_jointNarrowingBoth": "Estrenyiment marcat de TMC + articulació ETT",
    "eaton_osteoAbsent": "Sense osteòfits",
    "eaton_osteoSmall": "Osteòfits petits (< 2 mm)",
    "eaton_osteoLarge": "Osteòfits > 2 mm, esclerosi subcondral/quists",
    "eaton_osteoBothJoints": "Osteòfits a les articulacions TMC + ETT",
    "eaton_subluxMinimal": "Subluxació ≤ 1/3 de la superfície articular",
    "eaton_subluxSlight": "Subluxació lleu de l'articulació TMC",
    "eaton_subluxSignificant": "Subluxació significativa (> 1/3)",
    "eaton_subluxFixed": "Subluxació TMC + deformitat fixa en adducció",
    "eaton_sttNormalI": "Articulació ETT normal",
    "eaton_sttNormalII": "Articulació ETT normal",
    "eaton_sttNormalIII": "Articulació ETT normal",
    "eaton_sttAffected": "Articulació ETT afectada (estrenyiment, osteòfits, esclerosi)",
    "eaton_eI_label": "Preartròsic",
    "eaton_eII_label": "Artrosi lleu",
    "eaton_eIII_label": "Artrosi avançada (només TMC)",
    "eaton_eIV_label": "Artrosi pantrapezoïdal (TMC + ETT)",
    "eaton_scoringNote": "L'estadi Eaton-Littler final es determina per la troballa radiològica de més gravetat. Els estadis I-II generalment es tracten de manera conservadora, mentre que els estadis III-IV requereixen valoració quirúrgica.",
    "eaton_reference": "Referència:",
    "eaton_conclusionI": "Artrosi trapeziometacarpiana classificada com a Eaton-Littler I (estadi preartròsic). Es recomana tractament conservador amb fèrula, antiinflamatoris i rehabilitació.",
    "eaton_conclusionII": "Artrosi trapeziometacarpiana classificada com a Eaton-Littler II (artrosi lleu). Es recomana tractament conservador o cirurgia segons la simptomatologia clínica.",
    "eaton_conclusionIII": "Artrosi trapeziometacarpiana classificada com a Eaton-Littler III (artrosi avançada de l'articulació TMC). Es recomana trapeziectomia o artroplàstia.",
    "eaton_conclusionIV": "Artrosi trapeziometacarpiana classificada com a Eaton-Littler IV (artrosi pantrapezoïdal, afectació TMC + ETT). Es recomana artròdesi o artroplàstia total.",
    "snyder_classification": "Classificació de Snyder",
    "snyder_desc": "Ruptures completes del manegot dels rotadors — Snyder",
    "snyder_criteria": "Classificació de Snyder",
    "snyder_description": "Sistema de classificació per a ruptures completes del manegot dels rotadors (supraespinós i/o infraespinós) basat en el diàmetre anteroposterior de la ruptura i el nombre de tendons afectats.",
    "snyder_tearSize": "Mida de la ruptura (AP)",
    "snyder_tendonCount": "Tendons afectats",
    "snyder_chooseOne": "Triar 1",
    "snyder_highestGrade": "El grau més alt determina la classificació",
    "snyder_selectFeatures": "Selecciona característiques",
    "snyder_tearSmall": "Ruptura completa < 10 mm de diàmetre AP",
    "snyder_tearMedium": "Ruptura completa de 10–20 mm de diàmetre AP",
    "snyder_tearLarge": "Ruptura completa > 20 mm de diàmetre AP",
    "snyder_tearMassive": "Ruptura completa que afecta ≥ 2 tendons",
    "snyder_tendonSingle": "Un sol tendó (supraespinós o infraespinós)",
    "snyder_tendonSingleRetracted": "Un sol tendó amb retracció moderada",
    "snyder_tendonSingleAtrophy": "Un sol tendó amb retracció/atròfia significativa",
    "snyder_tendonMultiple": "Dos o més tendons afectats",
    "snyder_sC1_label": "Ruptura completa petita (< 10 mm)",
    "snyder_sC2_label": "Ruptura completa mitjana (10–20 mm)",
    "snyder_sC3_label": "Ruptura completa gran (> 20 mm)",
    "snyder_sC4_label": "Ruptura massiva (≥ 2 tendons)",
    "snyder_scoringNote": "El grau Snyder final es determina per la troballa de més gravetat. C4 té prioritat quan s'afecten dos o més tendons, independentment de la mida de la ruptura.",
    "snyder_reference": "Referència:",
    "snyder_conclusionC1": "Ruptura completa del manegot dels rotadors classificada com a Snyder C1 (ruptura petita, < 10 mm de diàmetre AP). Es recomana reparació artroscòpica.",
    "snyder_conclusionC2": "Ruptura completa del manegot dels rotadors classificada com a Snyder C2 (ruptura mitjana, 10–20 mm de diàmetre AP). Es recomana reparació artroscòpica o minioberta.",
    "snyder_conclusionC3": "Ruptura completa del manegot dels rotadors classificada com a Snyder C3 (ruptura gran, > 20 mm de diàmetre AP). Es recomana reparació oberta o artroscòpica segons la retracció i la qualitat tissular.",
    "snyder_conclusionC4": "Ruptura completa del manegot dels rotadors classificada com a Snyder C4 (ruptura massiva que afecta dos o més tendons). Valorar transferència tendinosa o artroplàstia inversa d'espatlla.",
    "herbertUi": {
      "modeLabel": "Mode de classificació",
      "modeGuided": "Guiat",
      "modeDirect": "Directe",
      "hintGuided": "Pas a pas fins al subtipus.",
      "hintDirect": "Tots els subtipus a la vista, amb un sol clic.",
      "reset": "Neteja",
      "directTitle": "Tria el subtipus",
      "phaseTitle": "En quin moment es troba la fractura?",
      "groupTitleAcute": "És estable?",
      "groupLedeAcute": "Estable: tubercle o fissura incompleta. Inestable: traç complet, desplaçament, pol proximal, cominució o lesió perilunar.",
      "groupTitleEvo": "Com ha evolucionat?",
      "groupLedeEvo": "Retard si encara pot consolidar; pseudoartrosi si la manca d'unió està establerta.",
      "subtypeTitle": "Subtipus",
      "subtypeTitleD": "Tipus de pseudoartrosi",
      "groupBadge": "Grup {{group}}",
      "selected": "Seleccionat:",
      "aiSuggested": "IA",
      "imgAlt": "Il·lustració: {{name}}",
      "next": {
        "direct": "Tria el subtipus que veus a la imatge.",
        "phase": "Comença triant si la fractura és aguda o ja és en evolució.",
        "groupAcute": "Indica si la fractura és estable o inestable.",
        "groupEvo": "Indica si és un retard de consolidació o una pseudoartrosi.",
        "sub": "Tria el subtipus del grup {{group}}.",
        "done": "Classificació completa: Herbert {{code}}. Copia el text per a l'informe."
      },
      "panel": {
        "finalType": "Tipus final",
        "mgmt": "Maneig orientatiu",
        "scale": "Escala",
        "path": "Recorregut",
        "report": "Text per a l'informe",
        "copy": "Copia",
        "copied": "Copiat",
        "disclaimer": "Orientació general. La decisió terapèutica correspon a l'equip clínic."
      },
      "report": {
        "c": "Fractura de l'escafoides carpià tipus C de la classificació d'Herbert: retard de consolidació.",
        "sub": "Fractura de l'escafoides carpià tipus {{code}} de la classificació d'Herbert ({{group}}): {{rep}}."
      },
      "phases": {
        "aguda": {
          "name": "Fractura aguda",
          "text": "Traumatisme recent. Es valora l'estabilitat del traç."
        },
        "evo": {
          "name": "Evolució",
          "text": "La fractura no ha consolidat en el temps esperable."
        }
      },
      "groups": {
        "A": {
          "name": "Aguda estable",
          "tile": "Estable",
          "text": "Tubercle o fissura incompleta de la cintura.",
          "desc": "Fractures agudes estables, que es poden tractar de manera conservadora.",
          "mgmt": "Immobilització. Tria el subtipus per concretar."
        },
        "B": {
          "name": "Aguda inestable",
          "tile": "Inestable",
          "text": "Traç complet, desplaçat, del pol proximal, cominut o amb luxació.",
          "desc": "Fractures agudes inestables, amb risc de desplaçament i pseudoartrosi.",
          "mgmt": "Habitualment fixació interna amb cargol de compressió."
        },
        "C": {
          "name": "Retard de consolidació",
          "tile": "Retard de consolidació",
          "text": "Continua sense consolidar, amb eixamplament del traç.",
          "desc": "La fractura no ha consolidat en el termini esperable. El traç persisteix, amb vores irregulars, eixamplament o quists.",
          "mgmt": "Fixació amb cargol de compressió, amb o sense empelt ossi."
        },
        "D": {
          "name": "Pseudoartrosi establerta",
          "tile": "Pseudoartrosi",
          "text": "Absència de consolidació establerta: fibrosa o escleròtica.",
          "desc": "Manca d'unió establerta entre els fragments.",
          "mgmt": "Tractament quirúrgic. Tria el subtipus per concretar."
        }
      },
      "types": {
        "A1": {
          "name": "Fractura del tubercle",
          "short": "Tubercle",
          "desc": "Fractura del tubercle distal, extraarticular i ben vascularitzada.",
          "mgmt": "Conservador: fèrula o guix durant 4–6 setmanes.",
          "rep": "fractura del tubercle"
        },
        "A2": {
          "name": "Fractura incompleta de la cintura",
          "short": "Cintura incompleta",
          "sub": "Fissura sense desplaçament",
          "desc": "Fissura que no travessa tota la cintura i no té desplaçament.",
          "mgmt": "Guix 6–8 setmanes, o fixació percutània amb cargol si es busca una tornada ràpida a l'activitat.",
          "rep": "fractura incompleta, no desplaçada, de la cintura"
        },
        "B1": {
          "name": "Fractura obliqua del terç distal",
          "short": "Obliqua terç distal",
          "desc": "Traç obliqu llarg al terç distal, sotmès a forces de cisallament.",
          "mgmt": "Fixació amb cargol de compressió.",
          "rep": "fractura obliqua del terç distal"
        },
        "B2": {
          "name": "Fractura completa de la cintura",
          "short": "Cintura completa",
          "desc": "Traç complet a través de la cintura, amb o sense desplaçament.",
          "mgmt": "Fixació amb cargol de compressió, percutània o oberta segons el desplaçament.",
          "rep": "fractura completa de la cintura"
        },
        "B3": {
          "name": "Fractura del pol proximal",
          "short": "Pol proximal",
          "desc": "Fragment proximal petit que depèn de la vascularització retrògrada.",
          "mgmt": "Fixació quirúrgica precoç, habitualment per via dorsal.",
          "rep": "fractura del pol proximal"
        },
        "B4": {
          "name": "Fractura-luxació transescafoperilunar",
          "short": "Transescafoperilunar",
          "desc": "Fractura de l'escafoides associada a luxació perilunar del carp.",
          "mgmt": "Urgent: reducció immediata, després reducció oberta amb fixació i reparació lligamentosa.",
          "rep": "fractura-luxació transescafoperilunar del carp"
        },
        "B5": {
          "name": "Fractura cominuta",
          "short": "Cominuta",
          "desc": "Múltiples fragments al focus de fractura.",
          "mgmt": "Fixació amb cargol, amb o sense empelt ossi. La TC ajuda a planificar.",
          "rep": "fractura cominuta"
        },
        "D1": {
          "name": "Pseudoartrosi fibrosa",
          "short": "Fibrosa",
          "sub": "Unió fibrosa estable",
          "desc": "Unió fibrosa entre els fragments, sense esclerosi ni deformitat rellevant.",
          "mgmt": "Cargol de compressió, amb o sense empelt esponjós.",
          "rep": "pseudoartrosi fibrosa"
        },
        "D2": {
          "name": "Pseudoartrosi escleròtica",
          "short": "Escleròtica",
          "sub": "Vores escleròtiques i quists",
          "desc": "Focus obert amb vores escleròtiques i quists; pot associar deformitat en gepa.",
          "mgmt": "Resecció del teixit escleròtic, empelt corticoesponjós i fixació. Empelt vascularitzat si el pol proximal no és viable.",
          "rep": "pseudoartrosi escleròtica"
        }
      },
      "alerts": {
        "A1": {
          "h": "Bon pronòstic",
          "t": "Extraarticular i ben vascularitzada; consolida amb immobilització."
        },
        "B2": {
          "h": "Mesurar el desplaçament",
          "t": "Més d'1 mm de separació o esglaó orienta a fixació oberta."
        },
        "B3": {
          "h": "Risc de necrosi avascular",
          "t": "El pol proximal rep la sang de manera retrògrada des de distal."
        },
        "B4": {
          "h": "Urgència",
          "t": "Lesió perilunar associada: requereix reducció immediata."
        },
        "B5": {
          "h": "Planificar amb TC",
          "t": "Defineix el nombre i la mida dels fragments abans de la cirurgia."
        },
        "C": {
          "h": "Seguiment",
          "t": "Valora amb TC el pont ossi i l'aparició de quists."
        },
        "D1": {
          "h": "Pol proximal viable",
          "t": "Sol conservar la vascularització: bon pronòstic amb fixació."
        },
        "D2": {
          "h": "Deformitat en gepa",
          "t": "Valora la flexió de l'escafoides i la inestabilitat carpiana (DISI)."
        },
        "D2b": {
          "h": "Viabilitat",
          "t": "Estudia el pol proximal amb RM amb contrast abans de planificar l'empelt."
        }
      },
      "hints": {
        "A2": {
          "h": "El traç és complet o està desplaçat?",
          "t": "Llavors no és A2 sinó B2. Si la radiografia no ho aclareix, confirma amb TC.",
          "btn": "És B2"
        },
        "B2": {
          "h": "És només una fissura incompleta i sense desplaçament?",
          "t": "Llavors és A2, una fractura estable. Si dubtes, confirma amb TC.",
          "btn": "És A2"
        },
        "B3": {
          "h": "El pol proximal sempre és B3",
          "t": "Encara que el traç no estigui desplaçat: la seva vascularització retrògrada el fa inestable."
        }
      }
    },
    "herbert_classification": "Classificació de Herbert-Fisher",
    "herbert_desc": "Fractures de l'escafoides carpià — Herbert-Fisher",
    "herbert_criteria": "Escafoides carpià · Herbert i Fisher, 1984",
    "herbert_description": "Classifica les fractures de l'escafoides carpià segons la seva estabilitat i evolució (Herbert i Fisher, 1984) i orienta el maneig.",
    "herbert_acutePattern": "Fractura aguda",
    "herbert_instability": "Criteri d'inestabilitat",
    "herbert_chronicity": "Evolució",
    "herbert_chooseOne": "Triar 1",
    "herbert_optional": "Opcional",
    "herbert_highestGrade": "El tipus de major gravetat determina la classificació",
    "herbert_selectFeatures": "Seleccioneu característiques",
    "herbert_a1Tubercle": "Fractura del tubercle",
    "herbert_a2WaistNondisplaced": "Cintura no desplaçada (confirmada per TC)",
    "herbert_b1DistalOblique": "Oblíqua del terç distal",
    "herbert_b2WaistDisplaced": "Cintura desplaçada o mòbil",
    "herbert_b3ProximalPole": "Pol proximal",
    "herbert_b4Perilunate": "Fractura-luxació transescafoperilunar",
    "herbert_b5Comminuted": "Cominuta",
    "herbert_instDisplacement": "Desplaçament > 1 mm",
    "herbert_instDisi": "DISI: angle escafolunar > 60°",
    "herbert_instAngle": "Angle intraescafoide lateral > 35°",
    "herbert_instComminution": "Cominució",
    "herbert_instPerilunate": "Part d'una lesió perilunar",
    "herbert_cDelayed": "Retard de consolidació",
    "herbert_d1Fibrous": "Pseudoartrosi fibrosa (pol proximal habitualment viable)",
    "herbert_d2Mobile": "Pseudoartrosi mòbil",
    "herbert_d3Sclerotic": "Pseudoartrosi escleròtica, amb defecte i deformitat en gepa",
    "herbert_d4Avn": "Necrosi avascular amb col·lapse i pèrdua d'arquitectura",
    "herbert_extB3a": "Angle escafolunar < 60°",
    "herbert_extB3b": "Angle escafolunar > 60°",
    "herbert_extShortLt2": "Escurçament < 2 mm",
    "herbert_extShortGt2": "Escurçament > 2 mm",
    "herbert_extSlac": "Amb canvis SLAC",
    "herbert_tA_label": "Aguda estable",
    "herbert_tB_label": "Aguda inestable",
    "herbert_tC_label": "Retard de consolidació",
    "herbert_tD_label": "Pseudoartrosi establerta",
    "herbert_recA": "Tractament conservador o fixació percutània.",
    "herbert_recB": "Fixació quirúrgica.",
    "herbert_recC": "Cirurgia, sovint amb empelt ossi.",
    "herbert_recD": "Cirurgia, sovint amb empelt ossi.",
    "herbert_scoringNote": "El tipus final es determina per la troballa de major gravetat. Qualsevol d'aquests criteris fa la fractura aguda inestable (B): desplaçament > 1 mm, angle escafolunar > 60° (DISI), angle intraescafoide lateral > 35°, cominució o lesió perilunar. El pol proximal (B3) és sempre inestable per la seva vascularització retrògrada. Confirmar A2 davant B2 amb TC.",
    "herbert_reference": "Referència:",
    "herbert_conclusion": "Fractura de l'escafoides carpià classificada com a Herbert {{subtype}} ({{label}}). {{recommendation}}",
    "tnm_lung_classification": "Classificació TNM de pulmó",
    "tnmLungName": "TNM de pulmó",
    "tnm_lung_desc": "Càncer de pulmó no microcític — TNM 7a edició",
    "tnm_lung_criteria": "Classificació TNM de pulmó",
    "tnm_lung_description": "Sistema d'estadificació per al càncer de pulmó no microcític basat en descriptors de tumor primari (T), ganglis limfàtics regionals (N) i metàstasis a distància (M), segons la 7a edició TNM (IASLC/UICC/AJCC, 2010).",
    "tnm_lung_tumorDescriptor": "Tumor primari (T)",
    "tnm_lung_nodeDescriptor": "Ganglis limfàtics regionals (N)",
    "tnm_lung_metastasisDescriptor": "Metàstasis a distància (M)",
    "tnm_lung_chooseOne": "Triar 1",
    "tnm_lung_stageGrouping": "Determinació de l'estadi",
    "tnm_lung_stage": "Estadi",
    "tnm_lung_selectDescriptors": "Selecciona els descriptors T, N i M",
    "tnm_lung_survival5y": "Supervivència als 5 anys",
    "tnm_lung_scoringNote": "L'estadi TNM final es determina combinant els descriptors T, N i M. En presència de M1, l'estadi és sempre IV independentment de T i N.",
    "tnm_lung_reference": "Referència:",
    "tnm_lung_tTX": "TX — Tumor primari no valorable",
    "tnm_lung_tT0": "T0 — Sense evidència de tumor primari",
    "tnm_lung_tTis": "Tis — Carcinoma in situ",
    "tnm_lung_tT1a": "T1a — Tumor ≤ 2 cm",
    "tnm_lung_tT1b": "T1b — Tumor > 2 cm i ≤ 3 cm",
    "tnm_lung_tT2a": "T2a — Tumor > 3 cm i ≤ 5 cm",
    "tnm_lung_tT2b": "T2b — Tumor > 5 cm i ≤ 7 cm",
    "tnm_lung_tT3": "T3 — Tumor > 7 cm, o invasió de paret toràcica / diafragma / nervi frènic, o nòdul(s) al mateix lòbul",
    "tnm_lung_tT4": "T4 — Invasió de mediastí, cor, grans vasos, tràquea, carina, esòfag, vèrtebra; o nòdul(s) en un lòbul ipsilateral diferent",
    "tnm_lung_nNX": "NX — Ganglis regionals no valorables",
    "tnm_lung_nN0": "N0 — Sense metàstasis als ganglis regionals",
    "tnm_lung_nN1": "N1 — Metàstasis als ganglis peribronquials / hiliars ipsilaterals",
    "tnm_lung_nN2": "N2 — Metàstasis als ganglis mediastínics / subcarinals ipsilaterals",
    "tnm_lung_nN3": "N3 — Metàstasis als ganglis mediastínics / hiliars contralaterals, escalens o supraclaviculars",
    "tnm_lung_mM0": "M0 — Sense metàstasis a distància",
    "tnm_lung_mM1a": "M1a — Nòdul(s) al pulmó contralateral, vessament pleural / pericàrdic maligne",
    "tnm_lung_mM1b": "M1b — Metàstasis a distància (extratoràcica)",
    "tnm_lung_conclusionOculto": "Càncer de pulmó en estadi ocult (TX N0 M0). Es recomana completar l'estudi d'extensió.",
    "tnm_lung_conclusion0": "Càncer de pulmó en estadi 0 (Tis N0 M0, carcinoma in situ). Es recomana resecció quirúrgica.",
    "tnm_lung_conclusionIA": "Càncer de pulmó en estadi IA (T1a-T1b N0 M0). Es recomana resecció quirúrgica (lobectomia). Supervivència als 5 anys: 73%.",
    "tnm_lung_conclusionIB": "Càncer de pulmó en estadi IB (T2a N0 M0). Es recomana resecció quirúrgica amb quimioteràpia adjuvant opcional. Supervivència als 5 anys: 58%.",
    "tnm_lung_conclusionIIA": "Càncer de pulmó en estadi IIA (T1-T2a N1, T2b N0). Es recomana resecció quirúrgica més quimioteràpia adjuvant. Supervivència als 5 anys: 46%.",
    "tnm_lung_conclusionIIB": "Càncer de pulmó en estadi IIB (T2b N1, T3 N0). Es recomana resecció quirúrgica més quimioteràpia adjuvant. Supervivència als 5 anys: 36%.",
    "tnm_lung_conclusionIIIA": "Càncer de pulmó en estadi IIIA (T1-T2 N2, T3 N1-N2, T4 N0-N1). Es recomana quimioradioteràpia amb valoració quirúrgica. Supervivència als 5 anys: 24%.",
    "tnm_lung_conclusionIIIB": "Càncer de pulmó en estadi IIIB (T4 N2, qualsevol T N3). Es recomana quimioradioteràpia. Supervivència als 5 anys: 9%.",
    "tnm_lung_conclusionIV": "Càncer de pulmó en estadi IV (qualsevol T, qualsevol N, M1). Es recomana tractament sistèmic (quimioteràpia / teràpia dirigida / immunoteràpia). Supervivència als 5 anys: 13%.",
    "tnm_lung_matrixTitle": "Matriu d'estadificació (T × N)",
    "tnm_lung_matrixDesc": "Estadi resultant de la combinació dels descriptors T i N quan M = M0. En presència de M1a o M1b, l'estadi és sempre IV independentment de T i N.",
    "tnm_lung_matrixM1Note": "Qualsevol T, qualsevol N — sempre estadi IV",
    "tnm_lung_matrixOccult": "Ocult",
    "smartBarPlaceholder": "Escriu aquí...",
    "noCommandsUnderstood": "No he entès bé què vols que faci. Podries ser més específic, si us plau?",
    "bold": "Negreta",
    "italic": "Cursiva",
    "underline": "Subratllat",
    "textColor": "Color del text",
    "custom": "Personalitzat",
    "untitled": "Informe sense títol",
    "facturationRate": "Facturació setmanal",
    "billedReports": "informes facturats",
    "vsLastWeek": "respecte a la setmana passada",
    "weeklyCompletionRate": "Informes setmanals",
    "byPeriod": {
      "month": { "facturationRate": "Facturació del mes", "avgEditTimeSub": "{{count}} informes aquest mes" },
      "week": { "facturationRate": "Facturació setmanal", "avgEditTimeSub": "{{count}} informes aquesta setmana" },
      "day": { "facturationRate": "Facturació d'avui", "avgEditTimeSub": "{{count}} informes avui" },
      "last30": { "facturationRate": "Facturació dels últims 30 dies", "avgEditTimeSub": "{{count}} informes en els últims 30 dies" }
    },
    "activitySummary": "Resum d'activitat",
    "viewMoreStats": "Veure més estadístiques",
    "avgEditTime": "Temps mitjà per informe",
    "avgEditTimeSub": "{{count}} informes aquesta setmana",
    "avgEditTimeEmpty": "Sense dades d'edició",
    "countDrafts": "{{count}} esborranys",
    "countBatches": "{{count}} lots",
    "countSent": "{{count}} enviats",
    "countShared": "{{count}} compartits",
    "workHistoryTitle": "Historial de treball",
    "viewGroupWorkHistory": "Veure l'historial de treball del grup",
    "sent": "Enviats",
    "moreStats": "Veure totes les estadístiques",
    "moreStatsDesc": "Analitza la teva productivitat i les tendències",
    "versionHistory": "Historial de versions",
    "closePanel": "Tancar tauler",
    "saveDocToSeeHistory": "Desa el document per veure l'historial.",
    "noVersionsSaved": "Encara no hi ha versions desades.",
    "restoring": "Restaurant…",
    "restoreThisVersion": "Restaurar aquesta versió",
    "loadMore": "Carregar-ne més",
    "comparingDiffs": "Comparant diferències",
    "previewingVersion": "Vista prèvia de la versió",
    "restoreAction": "Restaurar",
    "exitPreview": "Sortir de la vista prèvia",
    "versionRestored": "Versió restaurada",
    "versionRestoreError": "No s'ha pogut restaurar la versió",
    "triggerAutosave": "Desament automàtic",
    "triggerManualSave": "Desament manual",
    "triggerAiGeneration": "Generació amb IA",
    "triggerVoiceCommand": "Ordre de veu",
    "triggerMagicWrite": "Escriptura màgica",
    "triggerTemplateInserted": "Plantilla inserida",
    "triggerTemplateChange": "Canvi de plantilla",
    "sourceMagicWriting": "Escriptura màgica",
    "sourceManual": "Manual",
    "sourceDictation": "Dictat",
    "triggerVersionRestored": "Versió restaurada",
    "standardTemplateHint": "No has indicat cap plantilla, així que he utilitzat la plantilla estàndard.\n Si vols, digues-me quina plantilla he d'utilitzar i l'aplicaré a l'instant.\n Per exemple: «Utilitza la plantilla TC TÒRAX. Al parènquima pulmonar s'identifica ...».",
    "patientData": "Dades del pacient",
    "patientHistory": "Historial del pacient",
    "closePatientPanel": "Tancar el tauler del pacient",
    "demographics": "Demografia",
    "birth": "Naixement",
    "age": "Edat",
    "sex": "Sexe",
    "studySection": "Estudi",
    "date": "Data",
    "descriptionLabel": "Descripció",
    "clinic": "Clínica",
    "reportHistory": "Historial d'informes",
    "signed": "Signat",
    "reportIssueTitle": "Comunicar un problema",
    "reportIssueThanks": "Gràcies per comunicar-nos el problema!",
    "reportIssueReview": "El revisarem al més aviat possible i treballarem per solucionar-lo.",
    "reportIssueDescribe": "Descriu el problema",
    "reportIssuePlaceholder": "Descriu amb detall què ha passat, en quina pantalla o acció i com reproduir-ho...",
    "reportIssueSendError": "No s'ha pogut enviar el problema. Torna-ho a provar.",
    "reportIssueConsent": "Accepto que l'equip d'Ainovis es posi en contacte amb mi per obtenir més detalls",
    "reportIssueDisclaimer": "Utilitzarem aquesta informació únicament per millorar la nostra eina i resoldre el problema comunicat.",
    "reportIssueSubmit": "Enviar incidència",
    "menuFile": "Fitxer",
    "menuInsert": "Inserir",
    "menuClassifications": "Classificacions",
    "menuTemplates": "Plantilles",
    "menuSupport": "Suport",
    "menuCopy": "Copiar",
    "menuShare": "Compartir",
    "menuVersionHistory": "Historial de versions",
    "menuDownloadPdf": "Descarregar com a PDF",
    "menuPrint": "Imprimir",
    "menuRename": "Canviar nom",
    "menuDelete": "Eliminar",
    "menuLanguage": "Idioma",
    "menuImage": "Imatge",
    "menuTable": "Taula",
    "insertTable": "Inserir taula",
    "menuDivider": "Línia divisòria",
    "menuChart": "Gràfic",
    "menuShortcuts": "Dreceres de teclat",
    "menuAskCarolina": "Preguntar a Carolina",
    "menuReportIssue": "Comunicar un problema",
    "menuExploreTemplates": "Explorar plantilles",
    "menuUseAinovisTemplates": "Utilitzar plantilles d'Ainovis",
    "menuCreateTemplate": "Crear plantilla",
    "saveAsTemplate": "Desar com a plantilla",
    "templateNameInvalid": "El nom només pot contenir lletres, números, espais, guions, apòstrofs i punts",
    "templateNameAinovis": "Ja hi ha una plantilla d'Ainovis amb aquest nom. Tria un altre nom.",
    "templateNameGroup": "El nom de la plantilla no pot contenir el nom del teu grup.",
    "templateName": "Nom de la plantilla",
    "contentCopiedToClipboard": "Contingut copiat al porta-retalls",
    "errorCopyingContent": "No s'ha pogut copiar el contingut",
    "noSavedDocToDelete": "No hi ha cap document desat per eliminar.",
    "deleteDocumentTitle": "Eliminar document",
    "confirmDeleteDocument": "Segur que vols eliminar aquest document? Aquesta acció no es pot desfer.",
    "documentDeleted": "Document eliminat correctament.",
    "errorDeletingDocument": "No s'ha pogut eliminar el document.",
    "errorDeleteForbidden": "No tens permís per eliminar aquest esborrany.",
    "draftNoAccessTitle": "No tens accés a aquest esborrany",
    "draftNoAccessMessage": "Demana al seu autor que el comparteixi amb tu.",
    "draftNotFoundTitle": "Aquest esborrany no existeix",
    "draftNotFoundMessage": "Potser el seu autor l'ha eliminat.",
    "noContentToExport": "No hi ha contingut per exportar.",
    "browserBlockedPopup": "El navegador ha bloquejat la finestra emergent.",
    "saveTemplate": "Desar plantilla",
    "backToReports": "Tornar als informes",
    "untitledTemplate": "Plantilla sense títol",
    "templateTitleRequired": "Has d'afegir un títol a la plantilla",
    "actionVersions": "Versions",
    "actionPatients": "Pacients",
    "actionReportsHistory": "Informes previs",
    "patientsSidebarTitlePatient": "Dades del pacient",
    "patientsSidebarTitleHistory": "Historial del pacient",
    "patientsSidebarClose": "Tancar el tauler del pacient",
    "patientsSidebarNotConnected": "No connectat",
    "patientsSidebarTabPatient": "Dades del pacient",
    "patientsSidebarTabHistory": "Historial d'informes",
    "patientsSidebarSectionDemographics": "Demografia",
    "patientsSidebarSectionStudy": "Estudi actual",
    "patientsSidebarSectionClinical": "Clínica",
    "patientsSidebarLabelBirth": "Naixement",
    "patientsSidebarLabelAge": "Edat",
    "patientsSidebarLabelSex": "Sexe",
    "patientsSidebarLabelModality": "Modalitat",
    "patientsSidebarLabelDate": "Data",
    "patientsSidebarLabelAccession": "Núm. d'accés",
    "patientsSidebarLabelDescription": "Descripció",
    "patientsSidebarLabelReferring": "Metge sol·licitant",
    "patientsSidebarLabelReason": "Motiu de la petició",
    "patientsSidebarAddReason": "Afegir motiu de la petició",
    "patientsSidebarAddReasonShort": "Afegir",
    "patientsSidebarReasonHint": "Has d'estar connectat a un sistema extern (RIS/PACS) per afegir aquesta funcionalitat.",
    "patientsSidebarStudyUid": "UID de l'estudi",
    "patientsSidebarSexMale": "Masculí",
    "patientsSidebarSexFemale": "Femení",
    "patientsSidebarYearsOld": "{{years}} anys",
    "patientsSidebarNoPatientName": "Pacient sense nom",
    "patientsSidebarReportFallbackTitle": "Informe",
    "patientsSidebarNoReport": "Sense informe",
    "patientsSidebarHistoryEmpty": "Sense informes previs disponibles",
    "patientsSidebarHistoryUnread": "No s'han pogut carregar els informes",
    "patientsSidebarHistoryCount": "{{studies}} estudis · {{reports}} informes",
    "priorViewerClose": "Tancar informe previ",
    "priorViewerNoContent": "Aquest informe no té contingut disponible.",
    "priorViewerConclusion": "Conclusió",
    "patientSummaryButton": "Resumeix",
    "patientSummaryButtonHint": "Resum dels informes previs generat per Carolina",
    "patientSummaryTitle": "Resum del pacient",
    "patientSummaryRegenerate": "Regenera",
    "patientSummaryCollapse": "Plega el resum",
    "patientSummaryExpand": "Desplega el resum",
    "patientSummaryShowMore": "Mostra-ho tot",
    "patientSummaryShowLess": "Mostra'n menys",
    "patientSummaryStepAnalyzing": "S'estan analitzant els informes previs ({{count}})…",
    "patientSummaryStepWriting": "S'està redactant el resum…",
    "patientSummaryNoPriors": "No hi ha informes previs amb text que es puguin analitzar.",
    "patientSummaryNoFindings": "No s'han trobat antecedents rellevants als informes previs.",
    "patientSummaryStale": "Els informes previs han canviat des que es va generar aquest resum.",
    "patientSummaryRetry": "Torna-ho a provar",
    "patientSummaryErrorGeneric": "No s'ha pogut generar el resum.",
    "patientSummaryErrorTimeout": "El resum ha trigat massa. Torna-ho a provar.",
    "patientSummaryErrorLimits": "Hi ha massa informes previs per resumir-los alhora.",
    "patientSummaryErrorUnavailable": "El servei de resum no està disponible en aquest moment.",
    "patientSummaryDisclaimer": "Generat per Carolina a les {{time}} · Verifica les referències",
    "patientSummaryReferences": "Referències ({{count}})",
    "patientSummaryViewInReport": "Mostra a l'informe",
    "actionAiAssistant": "Assistent d'IA",
    "actionMicQr": "Micròfon del mòbil",
    "micQrSidebarTitle": "Micròfon del mòbil",
    "micQrSidebarClose": "Tancar el tauler del micròfon",
    "micQrStep1": "Obre la càmera del telèfon.",
    "micQrStep2": "Escaneja el codi QR.",
    "micQrStep3": "Accepta el permís del micròfon.",
    "micQrStep4": "Prem el botó d'enregistrar.",
    "micQrNeedsPermission": "Accepta el permís del micròfon al mòbil abans d'enregistrar.",
    "micQrLoading": "Generant codi…",
    "micQrError": "No s'ha pogut crear el codi. Torna-ho a provar.",
    "micQrExpired": "El codi ha caducat",
    "micQrExpiresIn": "Caduca d'aquí a {{minutes}} min",
    "micQrHttpsHint": "El telèfon necessita HTTPS (o localhost) per utilitzar el micròfon.",
    "micQrRefresh": "Generar un altre codi",
    "micQrWaiting": "Esperant el telèfon…",
    "micQrStartRemote": "Connectat al micròfon del mòbil. Prem per enregistrar.",
    "micQrConnected": "Telèfon connectat",
    "micQrConnectedHint": "Prem el botó d'enregistrar.",
    "micQrDisconnect": "Desconnectar",
    "useTemplate": "Utilitzar plantilla",
    "newChat": "Nou xat",
    "closeAiPanel": "Tancar el tauler d'IA",
    "aiHeroText": "Pregunta'm qualsevol dubte que tinguis sobre Ainovis",
    "aiPlaceholder": "Escriu un missatge...",
    "aiErrorMessage": "Ho sento, no he pogut processar la teva pregunta. Torna-ho a provar.",
    "aiQuestion1": "Com genero un informe amb la SmartBar?",
    "aiQuestion2": "Com inicio el dictat per veu?",
    "aiQuestion3": "Quines classificacions mèdiques puc utilitzar?",
    "toolbarParagraphStyle": "Estil de paràgraf",
    "toolbarFontFamily": "Tipus de lletra",
    "toolbarStyleNormal": "Text normal",
    "toolbarStyleH1": "Encapçalament 1",
    "toolbarStyleH2": "Encapçalament 2",
    "toolbarStyleH3": "Encapçalament 3",
    "toolbarStyleH4": "Encapçalament 4",
    "toolbarStyleH5": "Encapçalament 5",
    "toolbarApplyStyleToAll": "Aplicar a tots: \"{{style}}\"",
    "toolbarBold": "Negreta (Ctrl+B)",
    "toolbarItalic": "Cursiva (Ctrl+I)",
    "toolbarUnderline": "Subratllat (Ctrl+U)",
    "toolbarStrikethrough": "Ratllat",
    "toolbarTextColor": "Color del text",
    "toolbarHighlightColor": "Color del ressaltat",
    "toolbarHighlight": "Ressaltat",
    "toolbarNoColor": "Cap",
    "toolbarPresetColors": "Colors predeterminats",
    "toolbarCustomColors": "Colors personalitzats",
    "toolbarAddCustomColor": "Color personalitzat...",
    "toolbarAlignLeft": "Alinear a l'esquerra",
    "toolbarAlignCenter": "Centrar",
    "toolbarAlignRight": "Alinear a la dreta",
    "toolbarJustify": "Justificar",
    "toolbarBulletList": "Llista amb pics",
    "toolbarNumberedList": "Llista numerada",
    "toolbarLineSpacing": "Interlineat",
    "toolbarRemoveSpaceBefore": "Eliminar espai abans del paràgraf",
    "toolbarAddSpaceBefore": "Afegir espai abans del paràgraf",
    "toolbarRestoreSpaceAfter": "Restaurar espais després del paràgraf",
    "toolbarRemoveSpaceAfter": "Eliminar espais després del paràgraf",
    "toolbarCustomSpacing": "Espaiat personalitzat…",
    "toolbarKeepWithNext": "Mantenir amb el següent",
    "toolbarKeepLinesTogether": "Mantenir les línies juntes",
    "toolbarAvoidOrphans": "Evitar línies aïllades",
    "toolbarPageBreakBefore": "Afegir salt de pàgina abans",
    "toolbarDecreaseSize": "Reduir mida",
    "toolbarIncreaseSize": "Augmentar mida",
    "toolbarAlignment": "Alineació",
    "toolbarSingleSpacing": "Simple",
    "toolbarDoubleSpacing": "Doble",
    "toolbarZoom": "Zoom",
    "toolbarZoomOut": "Reduir zoom",
    "toolbarZoomIn": "Augmentar zoom",
    "toolbarUndo": "Desfer (Ctrl+Z)",
    "toolbarRedo": "Refer (Ctrl+Y)",
    "toolbarMoreOptions": "Més opcions de format",
    "toolbarFindingsMode": "Mode de troballes",
    "toolbarFindingsFirst": "Troballes al principi",
    "toolbarFindingsFirstDesc": "Les troballes es col·loquen per sobre del text de normalitat",
    "toolbarFindingsInside": "Troballes dins del text",
    "toolbarFindingsInsideDesc": "Les troballes s'integren al cos de l'informe",
    "toolbarHighlightFindings": "Ressaltar troballes",
    "toolbarLineSpacingSingle": "Simple",
    "toolbarLineSpacingDouble": "Doble",
    "toolbarLanguagePlaceholder": "Idioma"
  },
  "inconsistencies": {
    "label": "Incoherència",
    "show": "Mostrar",
    "hide": "Descartar",
    "mixedLateralityTerm": "Lateralitats mixtes",
    "mixedLateralityReason": "S'han detectat lateralitats diferents (RIGHT i LEFT) en el mateix estudi. Verifica que sigui correcte.",
    "missingLateralityTerm": "Lateralitat absent",
    "missingLateralityReason": "El procediment requereix lateralitat però no se n'ha detectat cap (dreta o esquerra) a la tècnica."
  },
  "settings": {
    "title": "Configuració",
    "subtitle": "Personalitza l'idioma i el format dels informes",
    "profile": "Perfil",
    "account": "Compte",
    "preferences": "Preferències",
    "language": "Idioma",
    "languageDescription": "Selecciona l'idioma de la interfície d'usuari",
    "theme": "Tema",
    "themeDescription": "Tria el tema de color de l'aplicació",
    "themeOptions": {
      "light": "Clar",
      "dark": "Fosc",
      "system": "Sistema"
    },
    "notifications": "Notificacions",
    "security": "Seguretat",
    "changePassword": "Canviar contrasenya",
    "currentPassword": "Contrasenya actual",
    "privacyPolicy": "Política de privacitat",
    "termsOfService": "Condicions del servei",
    "audio": "Àudio",
    "audioDescription": "Configura el dispositiu d'entrada d'àudio per al dictat",
    "audioDevice": "Dispositiu d'àudio",
    "audioDeviceDescription": "Selecciona el micròfon que vols utilitzar per al dictat",
    "selectMicrophone": "Seleccionar micròfon",
    "selectedDevice": "Dispositiu seleccionat",
    "microphone": "Micròfon",
    "onboarding": "Tutorial",
    "onboardingDescription": "Torna a veure el tutorial de l'aplicació",
    "onboardingText": "Si vols tornar a veure el tutorial guiat de l'aplicació, prem el botó per reactivar-lo. Es mostrarà la pròxima vegada que accedeixis a les pantalles corresponents.",
    "onboardingButton": "Reactivar tutorial",
    "onboardingResetSuccess": "Tutorial reactivat correctament",
    "session": "Sessió",
    "sessionDescription": "Gestiona la teva sessió actual",
    "logoutText": "En tancar la sessió, se't redirigirà a la pàgina d'inici de sessió",
    "signature": "Signatura",
    "signatureDescription": "Escriu el text que s'inserirà en signar un informe",
    "defaultSignatureName": "Dr. Nom Cognom",
    "signedBy": "Signat per",
    "colegiadoLabel": "Núm. de col·legiat",
    "signatureHint": "Configura el número de col·legiat i el títol professional a la secció d'administració d'usuaris.",
    "signatureSaved": "Signatura desada",
    "deleteSignature": "Eliminar signatura",
    "generateSignature": "Generar signatura",
    "ainovisTemplates": "Plantilles d'Ainovis",
    "ainovisTemplatesDescription": "Utilitza les plantilles predefinides d'Ainovis en generar informes",
    "ainovisTemplatesText": "Activa aquesta opció per utilitzar les plantilles d'Ainovis. Si la desactives, només s'utilitzaran les teves plantilles personals."
  },
  "users": {
    "professionalTitle": "Títol",
    "professionalTitlePlaceholder": "Dr., Dra., etc.",
    "practitionerIdentifier": "Núm. de col·legiat",
    "practitionerIdentifierPlaceholder": "Ex.: 282812345",
    "practitionerIdentifierSystem": "Sistema d'identificació",
    "practitionerIdentifierSystemPlaceholder": "URI del col·legi o registre professional",
    "title": "Usuaris",
    "user": "usuari",
    "usersPlural": "usuaris",
    "userList": "Llista d'usuaris",
    "addUser": "Afegir usuari",
    "editUser": "Editar usuari",
    "deleteUser": "Eliminar usuari",
    "userDetails": "Detalls de l'usuari",
    "newUser": "Nou usuari",
    "management": "Gestió d'usuaris",
    "subtitle": "Administra i visualitza la informació dels usuaris del sistema",
    "searchPlaceholder": "Cercar per nom, correu electrònic o codi...",
    "sortBy": "Ordenar per",
    "defaultSort": "Per defecte (Nom)",
    "nameAsc": "Nom (A-Z)",
    "nameDesc": "Nom (Z-A)",
    "surnameAsc": "Cognom (A-Z)",
    "emailAsc": "Correu electrònic (A-Z)",
    "emailDesc": "Correu electrònic (Z-A)",
    "roleAsc": "Rol (A-Z)",
    "roleDesc": "Rol (Z-A)",
    "noUsers": "No hi ha usuaris disponibles",
    "showing": "Mostrant",
    "of": "de",
    "firstName": "Nom",
    "lastName": "Cognom",
    "role": "Rol",
    "roleSuper": "Super",
    "roleAdmin": "Admin",
    "roleSupervisor": "Supervisor",
    "roleUser": "Usuari",
    "status": "Estat",
    "active": "Actiu",
    "inactive": "Inactiu",
    "verified": "Verificat",
    "pending": "Pendent",
    "lastLogin": "Últim accés",
    "createSuccess": "Usuari creat correctament",
    "createError": "Error en crear l'usuari",
    "updateSuccess": "Usuari actualitzat correctament",
    "deleteSuccess": "Usuari eliminat correctament",
    "notVerified": "Usuari no verificat",
    "notVerifiedDescription": "Aquest usuari encara no ha verificat el correu electrònic",
    "resendVerification": "Reenviar correu de verificació",
    "resending": "Reenviant...",
    "emailSentSuccess": "Correu enviat correctament",
    "basicInfo": "Informació bàsica",
    "personalInfo": "Informació personal",
    "assignments": "Assignacions",
    "code": "Codi",
    "primaryEmail": "Correu principal",
    "secondaryEmail": "Correu secundari",
    "nationalId": "ID nacional",
    "birthDate": "Data de naixement",
    "address": "Adreça",
    "account": "Compte",
    "notSpecified": "No especificat",
    "required": "*",
    "optional": "(opcional)",
    "namePlaceholder": "Nom de l'usuari",
    "surnamePlaceholder": "Cognom de l'usuari",
    "emailPlaceholder": "usuario@ejemplo.com",
    "email2Placeholder": "opcional@ejemplo.com",
    "searchAccountPlaceholder": "Cercar compte...",
    "roleRadiologist": "Radiòleg",
    "roleRadiologistDesc": "Accés bàsic al sistema",
    "roleSupervisorDesc": "Supervisa i revisa informes",
    "roleAdminDesc": "Gestiona els usuaris del seu compte",
    "roleSuperDesc": "Accés total al sistema",
    "nameRequired": "El nom és obligatori",
    "nameMinLength": "El nom ha de tenir almenys 2 caràcters",
    "nameMaxLength": "El nom és massa llarg (màxim 100 caràcters)",
    "nameInvalidChars": "El nom conté caràcters no vàlids",
    "surnameRequired": "El cognom és obligatori",
    "surnameMinLength": "El cognom ha de tenir almenys 2 caràcters",
    "surnameMaxLength": "El cognom és massa llarg (màxim 100 caràcters)",
    "surnameInvalidChars": "El cognom conté caràcters no vàlids",
    "emailRequired": "El correu electrònic és obligatori",
    "emailInvalid": "El format del correu electrònic no és vàlid",
    "emailMaxLength": "El correu electrònic és massa llarg (màxim 255 caràcters)",
    "email2Invalid": "El format del correu secundari no és vàlid",
    "email2MaxLength": "El correu secundari és massa llarg (màxim 255 caràcters)",
    "roleRequired": "El rol és obligatori",
    "accountRequired": "El compte és obligatori",
    "saving": "Desant...",
    "create": "Crear usuari",
    "createWithoutInvite": "Crear sense convidar",
    "update": "Actualitzar"
  },
  "accounts": {
    "title": "Comptes",
    "account": "compte",
    "accountsPlural": "comptes",
    "accountList": "Llista de comptes",
    "addAccount": "Afegir compte",
    "editAccount": "Editar compte",
    "accountDetails": "Detalls del compte",
    "accountName": "Nom del compte",
    "accountType": "Tipus de compte",
    "newAccount": "Nou compte",
    "management": "Gestió de comptes",
    "subtitle": "Administra hospitals, usuaris i llicències",
    "searchPlaceholder": "Cercar per nom o @domini...",
    "sortBy": "Ordenar per",
    "defaultSort": "Per defecte (Actualització)",
    "nameAsc": "Nom (A-Z)",
    "nameDesc": "Nom (Z-A)",
    "newestFirst": "Més recents",
    "oldestFirst": "Més antics",
    "recentlyModified": "Modificats recentment",
    "notModified": "Sense modificar",
    "noAccounts": "No s'han trobat comptes",
    "tryDifferentSearch": "Prova amb altres termes de cerca",
    "createFirstAccount": "Crea el teu primer compte per començar",
    "page": "Pàgina",
    "of": "de",
    "domains": "Dominis de correu",
    "noDomains": "Sense dominis configurats",
    "licenseLimits": "Límits de llicències",
    "administrators": "Administradors",
    "supervisors": "Supervisors",
    "radiologists": "Radiòlegs",
    "unlimited": "Il·limitat",
    "metadata": "Metadades",
    "createdAt": "Creat el",
    "updatedAt": "Actualitzat el",
    "deleteConfirm": "Segur que vols eliminar aquest compte?",
    "deleteWarning": "Aquesta acció no es pot desfer i eliminarà totes les dades associades",
    "deletion": {
      "title": "Eliminar el compte {{name}}",
      "lead": "L'eliminació afecta tot el que depèn del compte. No es pot desfer.",
      "loading": "Calculant l'abast...",
      "planFailed": "No s'ha pogut calcular l'abast de l'eliminació.",
      "groups": "grups",
      "usersToDelete": "usuaris s'eliminaran",
      "usersToDeactivate": "usuaris es desactivaran (tenen historial clínic)",
      "gateways": "passarel·les es desactivaran al Hub",
      "hubUnreachable": "El Hub d'integració no respon. No es pot eliminar el compte sense desactivar abans les seves passarel·les.",
      "confirm": "Eliminar en cascada",
      "success": "Compte eliminat: {{groups}} grups, {{deleted}} usuaris esborrats i {{deactivated}} desactivats."
    },
    "deleteSuccess": "Compte eliminat correctament",
    "createSuccess": "Compte creat correctament",
    "updateSuccess": "Compte actualitzat correctament",
    "nameRequired": "El nom és obligatori",
    "invalidNumber": "Ha de ser un número positiu",
    "invalidDomain": "Format no vàlid. Ha de ser com @dominio.com",
    "domainExists": "Aquest domini ja s'ha afegit",
    "addDomain": "Afegir domini",
    "domainPlaceholder": "@ejemplo.com",
    "optional": "(Opcional, deixa-ho buit per no establir cap límit)",
    "generalInfo": "Informació general",
    "additionalInfo": "Informació addicional",
    "creationDate": "Data de creació",
    "lastUpdate": "Última actualització",
    "deleteAccount": "Vols eliminar el compte?",
    "deleteAccountMessage": "Aquesta acció eliminarà permanentment el compte {name} i no es pot desfer.",
    "cancel": "Cancel·lar",
    "confirmDelete": "Sí, eliminar",
    "accountNameField": "Nom del compte",
    "requiredField": "*",
    "domainsDescription": "Afegeix els dominis de correu permesos per a aquest compte",
    "domainInputPlaceholder": "Ex.: @hospital.com",
    "limitsDescription": "Defineix el màxim d'usuaris per rol",
    "maxAdmins": "Màxim d'administradors",
    "maxSupervisors": "Màxim de supervisors",
    "maxRadiologists": "Màxim de radiòlegs",
    "packageTypeTitle": "Tipus de paquet",
    "packageTypeDescription": "Selecciona el nivell de paquet per a aquest compte",
    "packageType": "Paquet",
    "packageBronze": "Bronze",
    "packageSilver": "Argent",
    "packageGold": "Or",
    "distributorTitle": "Distribuïdor",
    "distributorDescription": "Selecciona el distribuïdor associat a aquest compte. Pots crear distribuïdors nous.",
    "distributor": "Distribuïdor",
    "hierarchy": {
      "title": "Estructura organitzativa",
      "manage": "Administrar organització",
      "manageHint": "Grups, equip, plantilles institucionals i polítiques, al tauler d'organització."
    },
    "distributorDefault": "Per defecte",
    "distributorCreate": "Crear distribuïdor…",
    "distributorCreatePlaceholder": "Ex.: NUEVO_DISTRIBUIDOR",
    "distributorNameRequired": "Introdueix un nom vàlid"
  },
  "groups": {
    "management": "Gestió de grups",
    "subtitle": "Administra els grups mèdics de la plataforma",
    "newGroup": "Nou grup",
    "editGroup": "Editar grup",
    "searchPlaceholder": "Cercar per nom o NIF...",
    "group": "grup",
    "groupsPlural": "grups",
    "noGroups": "No s'han trobat grups",
    "tryDifferentSearch": "Prova amb altres termes de cerca",
    "createFirstGroup": "Crea el teu primer grup per començar",
    "generalInfo": "Informació general",
    "contactInfo": "Informació de contacte",
    "accountInfo": "Informació del compte",
    "code": "Codi",
    "groupName": "Nom del grup",
    "groupNamePlaceholder": "Ex.: Grup de Diagnòstic Nord",
    "nationalId": "NIF / CIF",
    "nationalIdPlaceholder": "Ex.: B12345678",
    "address": "Adreça",
    "addressPlaceholder": "Ex.: Avinguda de la Salut 45",
    "email": "Correu de contacte",
    "emailPlaceholder": "Ex.: contacto@grupo.com",
    "phone": "Telèfon de contacte",
    "phonePlaceholder": "Ex.: +34 912 345 678",
    "account": "Compte",
    "selectAccount": "Seleccionar compte...",
    "delete": "Eliminar",
    "edit": "Editar",
    "cancel": "Cancel·lar",
    "saving": "Desant...",
    "update": "Actualitzar",
    "create": "Crear grup",
    "deleteSuccess": "Grup eliminat correctament",
    "createSuccess": "Grup creat correctament",
    "updateSuccess": "Grup actualitzat correctament",
    "nameRequired": "El nom és obligatori",
    "addressRequired": "L'adreça és obligatòria",
    "emailRequired": "El correu electrònic és obligatori",
    "phoneRequired": "El telèfon és obligatori",
    "accountRequired": "El compte és obligatori",
    "invalidEmail": "Format del correu electrònic no vàlid",
    "notSpecified": "No especificat",
    "notAssigned": "No assignat",
    "close": "Tancar",
    "loadError": "Error en carregar els grups"
  },
  "validation": {
    "required": "Aquest camp és obligatori",
    "invalidEmail": "Correu electrònic no vàlid",
    "passwordTooShort": "La contrasenya ha de tenir almenys 8 caràcters",
    "passwordMismatch": "Les contrasenyes no coincideixen",
    "invalidFormat": "Format no vàlid"
  },
  "navigation": {
    "home": "Inici",
    "dashboard": "Tauler",
    "reports": "Informes",
    "templates": "Plantilles",
    "users": "Usuaris",
    "accounts": "Comptes",
    "settings": "Configuració"
  },
  "templates": {
    "title": "Plantilles",
    "preparationNoticeLabel": "Hi ha plantilles que s'estan desant.",
    "preparationNoticeHint": "Espera abans d'utilitzar-les al dictat.",
    "preparationNoticeDetail": "Les plantilles ja s'han desat, però encara s'estan preparant per al dictat. Espera que desaparegui aquest avís.",
    "galleryTitle": "Galeria de plantilles",
    "viewAllTemplates": "Veure totes les plantilles",
    "count": "{{count}} plantilles",
    "all": "Totes",
    "personal": "Personals",
    "emptyPersonal": "No tens plantilles associades.",
    "createFirst": "Crear nova plantilla",
    "newTemplate": "Nova plantilla",
    "searchPlaceholder": "Cercar plantilla...",
    "allTypes": "Tots els tipus",
    "allSources": "Tots els orígens",
    "allLanguages": "Tots els idiomes",
    "customSelect": "Seleccionar idioma",
    "showing": "Mostrant",
    "template": "plantilla",
    "templates_plural": "plantilles",
    "searching": "Cercant plantilles...",
    "loadingMore": "Carregant més plantilles...",
    "empty": "No s'han trobat plantilles",
    "emptyHint": "Afegeix plantilles noves",
    "newTemplateTitle": "Nova plantilla",
    "details": "Detalls",
    "selectTemplate": "Selecciona una plantilla",
    "templateName": "Nom de la plantilla",
    "templateNameLabel": "Nom de la plantilla",
    "templatePlaceholder": "Ex.: RM_RODILLA_CONTRASTE",
    "isBlock": "És una plantilla patològica?",
    "no": "No (Normalitat)",
    "yes": "Sí (Patològica)",
    "activationWord": "Paraula d'activació",
    "activationWordLabel": "Paraula d'activació",
    "activationWordPlaceholder": "Ex.: TUMOR, LESIÓ, etc.",
    "activationWordInfo": "La paraula d'activació permet distingir plantilles d'una mateixa zona anatòmica. Per exemple, per a la pancreatitis pots utilitzar 'PANCREATITIS' per diferenciar-la d'altres plantilles del pàncrees",
    "autoUppercase": "Es convertirà a majúscules automàticament",
    "standard": "Estàndard",
    "defaultBadge": "Estàndard",
    "setDefault": "Fes servir «{{name}}» com a plantilla estàndard",
    "unsetDefault": "Deixa de fer servir «{{name}}» com a plantilla estàndard",
    "defaultSet": "«{{name}}» és ara la teva plantilla estàndard",
    "defaultUnset": "Ja no tens plantilla estàndard pròpia",
    "defaultError": "No s'ha pogut canviar la plantilla estàndard",
    "standardInfoTitle": "Plantilla estàndard",
    "standardInfoBody": "",
    "standardInfoIntro": "La plantilla estàndard està dissenyada per a estudis radiològics generals. Utilitza marcadors dinàmics a la tècnica que se substitueixen automàticament en generar l'informe.",
    "standardInfoTechniqueTitle": "Tècnica",
    "standardInfoTechniqueBody": "La tècnica inclou marcadors dinàmics entre claudàtors dobles (com ara [[lateralidad]], [[secuencias]], [[regiones_anatomicas]]) que el sistema substitueix automàticament pels valors corresponents en generar l'informe.",
    "standardInfoTechniqueExample": "Es fa TC [[regiones_anatomicas]] amb tècnica helicoidal [[protocolo]].",
    "standardInfoFindingsTitle": "Troballes",
    "standardInfoFindingsBody": "Les troballes es redacten com a text descriptiu continu en format de prosa, descrivint les estructures avaluades i les seves característiques de manera narrativa.",
    "standardInfoUseCaseTitle": "Quan s'ha d'utilitzar?",
    "standardInfoUseCaseBody": "Ideal per a estudis radiològics generals: TC d'extremitats, RM de genoll, columna, abdomen, ecografies, radiografies, etc.",
    "infoExample": "Ex.:",
    "content": "3. Contingut de la plantilla",
    "contentPlaceholder": "Arrossega un fitxer .txt aquí o escriu el contingut",
    "dragFile": "📄 Arrossega un fitxer .txt aquí",
    "referenceIf": "4. Referència d'activació (REFERENCE_IF)",
    "alwaysActive": "Sempre activa (ALWAYS)",
    "referenceIfWarning": "⚠️ No hi pot haver dos REFERENCE_IF = ALWAYS per al mateix procediment",
    "activationWordRequired": "Paraula d'activació:",
    "activationWordInputPlaceholder": "Ex.: PATOLOGIA, URGENT...",
    "language": "Codi d'idioma",
    "type": "Tipus",
    "saving": "Desant...",
    "saveChanges": "Desar canvis",
    "createTemplate": "Crear plantilla",
    "creating": "Creant plantilla...",
    "nameRequired": "El nom de la plantilla és obligatori",
    "activationRequired": "Has d'introduir una paraula d'activació per a les plantilles patològiques",
    "activationOrAlways": "Has d'introduir una paraula d'activació o marcar \"Sempre activa\"",
    "supportsBilaterality": "ℹ️ Admet unilateralitat i bilateralitat",
    "viewOtherTechnique": "Revisar la plantilla amb la bilateralitat/unilateralitat contrària",
    "relatedTechnique": "Tècnica relacionada (Bilateral/Unilateral)",
    "contentRequired": "El contingut de la plantilla no pot ser buit",
    "techniqueRequired": "El contingut de la tècnica no pot ser buit",
    "findingsRequired": "El contingut de les troballes no pot ser buit",
    "conclusionRequired": "El contingut de la conclusió no pot ser buit",
    "technique": "Tècnica",
    "techniquePlaceholder": "Escriu el contingut de la tècnica",
    "techniquePlaceholderStandard": "Ex.: Es fa RM del genoll [[lateralidad]] [[secuencias]].",
    "findings": "Troballes",
    "findingsBlocks": "Troballes",
    "findingsPlaceholder": "Escriu el contingut de les troballes",
    "findingsPlaceholderStandard": "Ex.: Estructures òssies amb senyal medul·lar normal, sense edema ni lesions focals.",
    "conclusion": "Conclusió",
    "conclusionPlaceholder": "Escriu el contingut de la conclusió",
    "conclusionPlaceholderStandard": "Ex.: Exploració sense troballes significatives.",
    "noProcedures": "No hi ha procediments associats a la teva plantilla",
    "templateCreated": "Plantilla creada correctament",
    "errorSaving": "Error en desar la plantilla",
    "normal": "Normal",
    "pathology": "Patologia",
    "urgent": "Urgent",
    "followUp": "Seguiment",
    "pediatric": "Pediàtric",
    "USER": "Usuari",
    "STANDARD": "Estàndard",
    "AINOVIS": "Ainovis",
    "procedureAssignment": "Assignar procediments",
    "procedureAssignmentExplanation": "Quan generis un informe i es detecti un dels procediments assignats, s'utilitzarà automàticament aquesta plantilla per generar l'informe",
    "groupFull": "Grup ple",
    "principal": "Principal",
    "complementary": "Complementari",
    "procedure": "Procediment",
    "addPrincipalFirst": "Primer afegeix un procediment principal",
    "dragOrAssign": "Arrossega o assigna procediments",
    "suggestedProcedures": "Procediments suggerits",
    "availableProcedures": "Procediments disponibles",
    "highRelevance": "Rellevància alta",
    "mediumRelevance": "Rellevància mitjana",
    "assignAsPrincipal": "Assignar com a principal",
    "assignAsComplementary": "Assignar com a complementari",
    "confirmSelection": "Confirmar selecció",
    "remove": "Treure",
    "resolving": "Resolent la plantilla amb procediments...",
    "contentLabel": "Plantilla",
    "groupsDescription": "Crea grups de procediments per associar-los a aquesta plantilla",
    "assignedGroups": "Grups de procediments",
    "group": "Grup",
    "groupsPlural": "grups",
    "groupsExamples": "Exemples de grups",
    "singleExample": "Únic",
    "singleExampleValue": "Genoll → Un sol procediment",
    "multiExample": "Multi",
    "multiExampleValue": "Genoll + Cama → Diversos procediments junts",
    "clickToAddProcedure": "Fes clic o arrossega un procediment per afegir-lo",
    "single": "Únic",
    "multi": "Multi",
    "removeGroup": "Eliminar grup",
    "selectGroup": "Seleccionar grup",
    "whereToAdd": "On vols afegir",
    "createNewGroup": "Crear nou grup",
    "add": "Afegir",
    "assigned": "Assignat",
    "dropHere": "Deixa anar aquí per crear un grup",
    "dropToCreateGroup": "Deixa anar aquí per crear un nou grup",
    "expandList": "Desplegar llista",
    "collapseList": "Plegar llista",
    "activationReference": "Referència d'activació",
    "alwaysActiveDesc": "La plantilla s'activa sempre",
    "customReference": "Referència personalitzada",
    "customReferenceDesc": "Escriu una paraula clau d'activació",
    "customActivation": "Activació personalitzada",
    "selectDestination": "Seleccionar destinació",
    "addToExisting": "Afegir a un d'existent",
    "willCreateMulti": "Crearà un multiprocediment",
    "willCreateSingle": "Crearà un procediment únic",
    "full": "Ple",
    "createNewSection": "Crear nou",
    "createNewProcedure": "Crear com a procediment únic",
    "assignedProcedures": "Procediments assignats",
    "item": "element",
    "items": "elements",
    "examples": "Exemples",
    "singleProcedure": "Procediment únic",
    "multiProcedure": "Multiprocediment",
    "collapse": "Plegar",
    "expand": "Desplegar",
    "dropToCreate": "Deixa anar aquí per crear-ne un de nou",
    "templateContent": "Contingut de la plantilla",
    "block": "Patològica",
    "howToTemplates": "Com funcionen les plantilles",
    "chipLegendSelector": "Selector",
    "chipLegendPlaceholder": "Marcador de substitució",
    "chipInsertHint": "Fes clic en un camp o escriu <kbd>/</kbd> per inserir",
    "stepConfigureTemplate": "Configurar",
    "stepSelectMarkers": "Marcadors",
    "stepAssignProcedures": "Procediments",
    "analyzeTemplate": "Analitzar plantilla",
    "assignProcedures": "Assignar procediments",
    "saveTemplate": "Desar plantilla",
    "blocksHint": "Les plantilles patològiques només requereixen troballes i una paraula d'activació. La tècnica i la conclusió s'ometen.",
    "normalHint": "Les plantilles de normalitat inclouen tècnica, troballes i conclusió.",
    "standardHint": "Text lliure per descriure troballes sense estructura fixa.",
    "cancelConfirmTitle": "Vols descartar els canvis?",
    "cancelConfirmMessage": "Tens canvis sense desar. Què vols fer?",
    "discardChanges": "Descartar",
    "keepEditing": "Continuar editant",
    "draftSaved": "Esborrany desat",
    "draftSavedJustNow": "Esborrany desat",
    "fieldRequired": "Aquest camp és obligatori",
    "procedureStepIntro": "Pas 1: Fes clic en un procediment per assignar-lo.",
    "procedureStepGroup": "Pas 2: Si ja hi ha grups, tria on afegir-lo.",
    "procedureStepConfirm": "Pas 3: Confirma la selecció quan acabis.",
    "confirmDelete": "Segur que vols eliminar aquesta plantilla? S'eliminaran totes les versions associades (bilateral/unilateral) i les seves relacions amb procediments.",
    "voiceChipTemplate": "Utilitza la plantilla",
    "voiceChipTemplatesHint": "Dicta «Utilitza la plantilla ...» o selecciona",
    "copyAsPersonal": "Copiar com a personal",
    "copying": "Copiant...",
    "copySuccess": "Copiada!",
    "copyError": "Error en copiar la plantilla",
    "copyConflictTitle": "Conflicte de procediments",
    "copyConflictMessage": "Ja hi ha plantilles personals per als procediments assignats a aquesta plantilla:",
    "copyConflictHint": "Per utilitzar aquesta plantilla, has d'assignar una paraula d'activació que la diferenciï de les existents.",
    "copyWithActivation": "Copiar amb activació",
    "help": {
      "title": "Com crear plantilles",
      "intro": "Les plantilles permeten generar informes radiològics de manera ràpida i coherent. Escriu el text base de l'informe i afegeix <strong>camps variables</strong> on necessitis valors dinàmics.",
      "selectorTitle": "Selector",
      "selectorDesc": "Defineix una llista d'opcions possibles per a un camp. En generar l'informe, se'n triarà una. Opcionalment pots marcar un <strong>valor per defecte</strong> que s'utilitzarà si no se n'indica un altre.",
      "exampleInEditor": "Exemple a l'editor:",
      "selectorExampleChip": "conservada / augmentada / disminuïda: *conservada*",
      "selectorDetail": "Això significa que les opcions són «conservada», «augmentada» i «disminuïda». Si no s'especifica cap altra cosa, s'utilitzarà <strong>«conservada»</strong> com a valor per defecte. El valor per defecte és opcional — si no l'indiques, simplement es mostraran les opcions sense cap valor preseleccionat.",
      "placeholderTitle": "Marcador de substitució",
      "placeholderDesc": "Un marcador genèric que serà <strong>substituït</strong> per un valor concret en generar l'informe (una descripció, una mesura, una troballa, etc.).",
      "placeholderExampleChip": "troballa",
      "placeholderDetail": "Aquest marcador se substituirà pel text corresponent quan es generi l'informe final.",
      "tipTitle": "💡 Consell",
      "tipText": "Escriu <kbd>/</kbd> a l'editor per obrir el menú ràpid d'inserció de camps, o utilitza els botons de la barra superior de cada secció.",
      "ok": "Entès"
    },
    "source": "Origen",
    "galleryNormalPrefix": "Galeria de ",
    "galleryBlockPrefix": "Galeria de ",
    "galleryBlockSuffix": "",
    "gallerySubtitle": "Gestiona les teves plantilles i blocs d'informe",
    "countShown": "{{count}} plantilles",
    "countShown_one": "{{count}} plantilla",
    "countShown_other": "{{count}} plantilles",
    "blocksCountShown": "{{count}} blocs",
    "blocksCountShown_one": "{{count}} bloc",
    "blocksCountShown_other": "{{count}} blocs",
    "blocksWord": "Blocs",
    "templatesWord": "plantilles",
    "myTemplates": "Les teves plantilles",
    "import": "Importar plantilla",
    "importTemplates": "Importar plantilles",
    "importDropTitle": "Deixa anar un DOCX, PDF o TXT aquí",
    "importDropActive": "Deixa anar els fitxers aquí",
    "importDropHint": "O fes clic per seleccionar els fitxers",
    "importAddMore": "Afegeix més fitxers o continua",
    "importFilesCount": "{{count}} fitxers",
    "importTotalSize": "{{count}} fitxers · {{size}} de {{limit}}",
    "importTotalTooLarge": "La mida total dels fitxers supera el límit de {{limit}}",
    "importProcessingN": "Processant el document {{current}} de {{total}}…",
    "importFormats": "Formats admesos: .docx, .pdf, .txt · Màx. 25 MB en total",
    "importInvalidFormat": "Format no admès. Utilitza un fitxer .docx, .pdf o .txt",
    "importProcessing": "Processant document…",
    "importSaving": "Important…",
    "importSaveFailed": "No s'han pogut importar les plantilles",
    "importPartialFailure": "No s'han pogut importar: {{titles}}",
    "importDone": "{{created}} plantilles creades i {{replaced}} substituïdes",
    "importSkippedAinovis": "Descartades perquè coincideixen amb plantilles d'Ainovis: {{titles}}",
    "importFailed": "No s'ha pogut processar el document",
    "importEmpty": "No s'ha trobat cap plantilla al document.",
    "importRemoveFile": "Treure fitxer",
    "importSplitTitle": "Dividir document",
    "importSplitHint": "Tria com separar les plantilles del document.",
    "importSplitAi": "Detecció amb IA",
    "importSplitAiHint": "La IA detecta cada plantilla del document.",
    "importSplitPageBreaks": "Salts de pàgina",
    "importSplitPageBreaksHint": "Una plantilla per cada pàgina del document.",
    "importSplitHorizontalLine": "Línia horitzontal",
    "importSplitHorizontalLineHint": "Divideix el document a cada línia horitzontal.",
    "importPreviewTitle": "Vista prèvia",
    "importFoundCount": "{{count}} plantilles trobades",
    "importSplitBy": "Dividir per",
    "importNameLabel": "Nom de la plantilla",
    "importWordCount": "{{count}} paraules",
    "importNoConflict": "No hi ha cap plantilla amb aquest nom.",
    "importReplaces": "Substitueix «{{name}}»",
    "importAinovisConflict": "Ja hi ha una plantilla d'Ainovis amb aquest nom",
    "importAinovisConflictFull": "Ja hi ha una plantilla d'Ainovis amb aquest nom. Canvia'l per poder importar-la.",
    "importDuplicateInDocument": "Nom repetit en aquest document",
    "importDuplicateInDocumentFull": "Una altra plantilla d'aquest document ja utilitza aquest nom. Canvia'l per poder importar-la.",
    "importEmptyName": "Posa-li un nom per poder importar-la",
    "importUntitled": "Sense nom",
    "importBlocked": "Corregeix {{count}} nom(s) per poder importar",
    "importFilledPerReport": "S'emplena a cada informe",
    "importSummary": "{{total}} de {{found}} seleccionades",
    "importChooseAnother": "Triar un altre fitxer",
    "importConfirm": "Importar {{count}} plantilles",
    "tabMine": "Personals",
    "tabShared": "Institucionals",
    "tabAinovis": "Ainovis",
    "filterStandard": "Estàndard",
    "loading": "Carregant plantilles...",
    "editTitle": "Editar plantilla",
    "saveEdit": "Desar canvis",
    "filterSource": "Origen",
    "filterLanguage": "Idioma",
    "normalTab": "Plantilles",
    "blocksTab": "Blocs",
    "filters": "Filtres",
    "deleteTitle": "Eliminar plantilla",
    "deleteConfirm": "Segur que vols eliminar <strong>{{name}}</strong>? Aquesta acció eliminarà totes les versions d'aquesta plantilla i no es pot desfer.",
    "deleting": "Eliminant…",
    "delete": "Eliminar",
    "bulkDeleteTitle": "Eliminar plantilles",
    "bulkDeleteMessage": "Estàs segur que vols eliminar {{count}} plantilles? Aquesta acció eliminarà totes les seves versions i no es pot desfer.",
    "selectedCount": "{{count}} seleccionades",
    "selectTemplate": "Seleccionar «{{name}}»",
    "tabNormal": "Plantilles",
    "tabBlocks": "Blocs",
    "previewLabel": "Vista prèvia:",
    "apply": "Aplicar",
    "cancel": "Cancel·lar"
  },
  "recommendations": {
    "title": "Suggeriments",
    "show": "Mostrar suggeriments",
    "hide": "Amagar suggeriments",
    "list": "Suggeriments disponibles",
    "block": "Bloc",
    "classification": "Classificació",
    "loading": "Carregant suggeriments…",
    "error": "No s'han pogut actualitzar tots els suggeriments.",
    "noTemplate": "Selecciona una plantilla per veure suggeriments.",
    "empty": "Encara no s'ha utilitzat aquesta plantilla.",
    "expandName": "Llegir el nom complet",
    "collapseName": "Plegar nom",
    "remove": "Treure {{name}} dels suggeriments"
  },
  "blocks": {
    "sectionContentPlaceholder": "Escriu aquí el contingut que s'inserirà a la secció...",
    "namePlaceholder": "Nom del bloc (ex.: Pancreatitis aguda)",
    "createHint": "Aquest contingut s'inserirà dins de la secció on l'arrosseguis.",
    "empty": "Sense blocs",
    "createFirst": "Crear bloc",
    "createCard": "Crear bloc",
    "deleteTitle": "Eliminar bloc",
    "deleteConfirm": "Segur que vols eliminar <strong>{{name}}</strong>? Aquesta acció no es pot desfer.",
    "deleting": "Eliminant…",
    "delete": "Eliminar",
    "cancel": "Cancel·lar",
    "sidebarTitle": "Blocs",
    "searchToPin": "Cercar bloc...",
    "noResults": "Sense resultats",
    "expand": "Desplegar",
    "collapse": "Tancar",
    "addToTemplate": "Afegir",
    "unpin": "Desfixar",
    "pinnedLoadError": "Els blocs fixats no estan disponibles. Pots continuar utilitzant els blocs.",
    "preview": "Vista prèvia",
    "removeAssociation": "Treure de la llista"
  },
  "classificationCarousel": {
    "searchPlaceholder": "Cerca classificació...",
    "empty": "No s'han trobat classificacions",
    "descriptions": {
      "FLEISCHNER": "Seguiment de nòduls pulmonars incidentals en TC.",
      "TI-RADS": "Risc de malignitat dels nòduls tiroïdals per ecografia.",
      "PI-RADS": "Sospita de càncer de pròstata clínicament significatiu en RM.",
      "BOSNIAK_2019": "Estratificació de masses renals quístiques per TC o RM.",
      "GARDEN": "Fractures subcapitals del coll femoral segons el desplaçament.",
      "EATON_LITTLER": "Estadificació de la rizartrosi trapeziometacarpiana.",
      "SNYDER": "Ruptures completes del manegot dels rotadors segons la mida i els tendons afectats.",
      "HERBERT_FISCHER": "Fractures de l'escafoides carpià segons l'estabilitat i l'evolució."
    }
  },
  "classificationRequest": {
    "title": "Sol·licitar classificació",
    "close": "Tancar",
    "successTitle": "Gràcies per la teva sol·licitud!",
    "successSub": "Revisarem el teu suggeriment i treballarem per afegir la classificació.",
    "intro": "Creus que falta una classificació? Explica'ns quina necessites i l'avaluarem per afegir-la.",
    "descriptionLabel": "Descriu la classificació que necessites",
    "descriptionPlaceholder": "Indica el nom de la classificació, en quina especialitat o tipus d'estudi s'utilitza i qualsevol detall rellevant...",
    "submitError": "No s'ha pogut enviar la sol·licitud. Torna-ho a provar.",
    "allowContact": "Accepto que l'equip d'Ainovis es posi en contacte amb mi per obtenir més detalls",
    "disclaimer": "Utilitzarem aquesta informació únicament per avaluar i desenvolupar classificacions noves.",
    "submitting": "Enviant…",
    "submit": "Enviar sol·licitud",
    "requestClassification": "Sol·licitar classificació"
  },
  "keyboardShortcuts": {
    "title": "Dreceres de teclat",
    "close": "Tancar",
    "groupDictation": "Dictat",
    "dictationStart": "Començar a enregistrar",
    "dictationSend": "Enviar àudio",
    "dictationSendAlt": "Enviar àudio",
    "dictationPauseResume": "Posar en pausa / reprendre el dictat",
    "dictationCancel": "Cancel·lar àudio",
    "groupTextFormat": "Format de text",
    "bold": "Negreta",
    "italic": "Cursiva",
    "underline": "Subratllat",
    "strikethrough": "Ratllat",
    "groupAlignment": "Alineació",
    "alignLeft": "Alinear a l'esquerra",
    "alignCenter": "Centrar",
    "alignRight": "Alinear a la dreta",
    "justify": "Justificar",
    "groupEditing": "Edició",
    "undo": "Desfer",
    "redo": "Refer",
    "selectAll": "Seleccionar tot",
    "copy": "Copiar",
    "cut": "Retallar",
    "paste": "Enganxar",
    "save": "Desar",
    "groupIndent": "Sagnat",
    "indent": "Augmentar sagnat",
    "unindent": "Reduir sagnat",
    "groupView": "Vista",
    "zoomIn": "Augmentar zoom",
    "zoomOut": "Reduir zoom",
    "zoomReset": "Restablir zoom",
    "key_space": "Espai",
    "key_enter": "Intro",
    "key_esc": "Esc",
    "key_tab": "Tab",
    "key_shift": "Majús"
  },
  "aiSidebar": {
    "title": "Carolina",
    "newChat": "Nou xat",
    "closePanel": "Tancar el tauler d'IA",
    "heroText": "Pregunta'm qualsevol dubte que tinguis sobre Ainovis",
    "inputPlaceholder": "Escriu un missatge...",
    "errorMessage": "Ho sento, no he pogut processar la teva pregunta. Torna-ho a provar.",
    "question1": "Com genero un informe amb la SmartBar?",
    "question2": "Com inicio el dictat per veu?",
    "question3": "Quines classificacions mèdiques puc utilitzar?"
  },
  "diffModal": {
    "badge": "Conversió a plantilla",
    "progressOptions": "opcions",
    "title": "Marcadors detectats al text",
    "subtitle": "Revisa els canvis proposats per convertir aquest informe en una plantilla reutilitzable",
    "closeLabel": "Tancar finestra modal",
    "selectMarkers": "Triar marcadors",
    "slotsTitle": "Opcions de construcció de la plantilla",
    "slotsSubtitle": "Selecciona quins marcadors vols aplicar. Els textos coincidents se substituiran",
    "globalMode": "Mode global",
    "individualMode": "Mode individual",
    "useGlobalMarker": "Utilitzar marcador global",
    "globalMarkerDescription": "Aplicarà el mateix marcador a totes les regions anatòmiques",
    "finalResult": "Resultat final",
    "previewBadge": "Vista prèvia",
    "defaultValue": "Valor per defecte",
    "unspecified": "Sense especificar",
    "defaultHint": "Les parts ressaltades utilitzen valors per defecte. Selecciona totes les opcions per confirmar",
    "infoTitle": "Què són els marcadors?",
    "infoDescription": "Els marcadors (ex.: [region anatomica], [lateralidad]) són camps que s'emplenaran automàticament en utilitzar aquesta plantilla i que permeten reutilitzar-la per a diferents casos",
    "warningTitle": "Completa totes les seleccions",
    "warningDescription": "Falten {count} opcions per seleccionar. Els camps sense seleccionar estan ressaltats",
    "keepOriginal": "Mantenir l'original",
    "applyTemplate": "Aplicar plantilla",
    "lateralityDisabledByRegion": "Les lateralitats estan deshabilitades perquè les regions anatòmiques ja les inclouen",
    "regionDisabledByLaterality": "Les regions anatòmiques estan deshabilitades perquè hi ha lateralitats seleccionades",
    "flexibilityTitle": "Plantilla més flexible",
    "flexibilityDescription": "En triar marcadors, el teu informe serà més versàtil. Els camps marcats s'emplenaran automàticament segons el procediment, cosa que et permetrà reutilitzar aquesta plantilla per a múltiples casos sense haver d'editar-la manualment",
    "noMarkersTitle": "Sense marcadors seleccionats",
    "noMarkersDescription": "Selecciona almenys un marcador per aplicar canvis a la tècnica, o continua per utilitzar el text original",
    "replace": "Substituir",
    "insert": "Inserir"
  },
  "editor": {
    "sectionTitleEditToast": "Et recordo que pots editar els títols per defecte des de la configuració"
  },
  "errors": {
    "authInvalidCredentials": "Correu electrònic o contrasenya incorrectes",
    "authInvalidToken": "Sessió no vàlida o caducada",
    "authTokenExpired": "La teva sessió ha caducat. Si us plau, torna a iniciar sessió",
    "authMissingToken": "Has d'iniciar sessió per accedir-hi",
    "authUserNotFound": "Usuari no trobat",
    "authUserAlreadyExists": "Aquest usuari ja existeix",
    "authInactiveUser": "El teu compte està desactivat. Contacta amb l'administrador",
    "authInsufficientPermissions": "No tens prou permisos per fer aquesta acció",
    "authValidationError": "Error en la validació de les dades",
    "validationError": "Si us plau, verifica les dades introduïdes",
    "templateNotFound": "Plantilla no trobada",
    "templateValidationError": "Error en les dades de la plantilla",
    "templateRetrievalError": "Error en obtenir les plantilles",
    "templateAlreadyExists": "Ja hi ha una plantilla amb aquest nom",
    "templateNameDuplicate": "Ja hi ha una plantilla amb aquest nom per a aquest usuari",
    "templateReferenceIfConflictAlways": "Ja hi ha una plantilla \"{{templateName}}\" per a la combinació de procediments: {{procedureNames}}. Només hi pot haver una plantilla per defecte per combinació de procediments.",
    "templateReferenceIfConflict": "Ja hi ha una plantilla \"{{templateName}}\" amb la paraula d'activació \"{{referenceIf}}\" per a la combinació de procediments: {{procedureNames}}. Si us plau, utilitza una paraula d'activació diferent.",
    "templateNoTemplatesFound": "No s'han trobat plantilles per a aquest usuari",
    "templateInvalidFormat": "Format de plantilla no vàlid",
    "templateAccessDenied": "No tens accés a aquesta plantilla",
    "blockLimitReached": "Has arribat al límit de {{limit}} blocs. Elimina'n algun per poder crear-ne un altre.",
    "reportNotFound": "Informe no trobat",
    "reportValidationError": "Error en les dades de l'informe",
    "reportGenerationError": "Error en generar l'informe",
    "reportSaveError": "Error en desar l'informe",
    "reportAlreadyExists": "Ja hi ha un informe amb aquest identificador",
    "reportRetrievalError": "Error en obtenir els informes",
    "reportModalityNotFound": "La modalitat seleccionada no existeix",
    "reportAccessDenied": "No tens accés a aquest informe",
    "reportDataInvalid": "Les dades de l'informe no són vàlides",
    "reportMissingField": "Falten camps obligatoris a l'informe",
    "reportInvalidFormat": "Format d'informe no vàlid",
    "reportInvalidGenerationRequest": "Sol·licitud de generació no vàlida",
    "reportApiError": "Error en connectar amb el servei d'informes",
    "reportServiceError": "Error en el servei d'informes",
    "reportAlignmentError": "Error durant l'alineació de l'informe",
    "reportNoModalityOrRegions": "No s'ha pogut detectar la modalitat ni les regions anatòmiques al text",
    "reportTemplatesNotFoundForProcedure": "No s'han trobat plantilles per al teu procediment i idioma",
    "reportTemplatesFoundForDifferentType": "No s'han trobat plantilles del tipus sol·licitat per al teu procediment, però sí que hi ha plantilles de tipus {{availableType}}",
    "reportTemplateType_STANDARD": "troballes al principi o troballes dins del text",
    "reportsTemplateNotFound": "No hi ha cap plantilla disponible per a aquest descriptiu. En pots crear una per utilitzar-lo",
    "reportsTemplateIncomplete": "La plantilla és incompleta i no es pot utilitzar per generar l'informe",
    "reportsTemplateContentNotFound": "No s'ha trobat el contingut de la plantilla",
    "reportsTemplateContentIncomplete": "El contingut de la plantilla és incomplet",
    "reportsPromptNotFound": "No s'ha trobat la instrucció necessària per a la generació",
    "reportsFindingsGenerationError": "Error en generar les troballes de l'informe",
    "reportsConclusionGenerationError": "Error en generar la conclusió de l'informe",
    "reportsSectionGenerationError": "Error en generar una secció de l'informe",
    "reportsParallelGenerationError": "Error durant la generació paral·lela de l'informe",
    "reportsInvalidGenerationParameters": "Paràmetres de generació no vàlids",
    "reportsAlignmentError": "Error durant l'alineació de l'informe",
    "reportsPreSaveReviewError": "Error en la revisió prèvia al desament",
    "reportsLlmServiceError": "Error en el servei d'intel·ligència artificial",
    "reportLanguageCodeNotFound": "No s'ha trobat el codi d'idioma sol·licitat",
    "reportInactiveTemplate": "La plantilla seleccionada està inactiva",
    "reportProcedureNotFound": "No s'ha trobat el procediment sol·licitat",
    "reportAnatomicalRegionNotFound": "No s'ha trobat la regió anatòmica sol·licitada",
    "reportVariantNotFound": "No s'ha trobat la variant sol·licitada",
    "reportTemplateNotFound": "No s'ha trobat la plantilla per a l'informe",
    "ainovisApiError": "Error en el servei d'IA",
    "ainovisConnectionError": "Error de connexió amb el servei d'IA",
    "ainovisTimeoutError": "El servei d'IA ha trigat massa a respondre",
    "ainovisInvalidAudioFormat": "Format d'àudio no vàlid",
    "ainovisAudioFileSizeExceeded": "El fitxer d'àudio és massa gran",
    "ainovisMissingAudioFile": "No s'ha proporcionat cap fitxer d'àudio",
    "sttServiceError": "Error en el servei de transcripció",
    "sttValidationError": "Error en la validació de les dades de transcripció",
    "sttMissingField": "Falten camps obligatoris per a la transcripció",
    "sttProcessingError": "Error en processar l'àudio",
    "sttApiError": "Error en connectar amb el servei de transcripció",
    "sttNoVoiceDetected": "No s'ha detectat veu a l'àudio",
    "sttAudioProcessingError": "Error en processar el fitxer d'àudio",
    "sttNoAudioChunks": "No s'han generat fragments d'àudio vàlids",
    "sttTranscriptionError": "Error en la transcripció de veu a text",
    "sttNoTranscriptionResults": "No s'han obtingut resultats de transcripció",
    "sttEmptyTranscript": "La transcripció ha resultat buida",
    "sttInvalidAudioFile": "El fitxer d'àudio no és vàlid o està malmès",
    "sttAudioFormatNotSupported": "El format d'àudio no s'admet",
    "emailSendFailed": "Error en enviar el correu",
    "emailInvalidConfig": "Configuració de correu no vàlida",
    "emailInvalidAddress": "Adreça de correu no vàlida",
    "emailTemplateNotFound": "Plantilla de correu no trobada",
    "emailTemplateRenderError": "Error en renderitzar el correu",
    "emailConnectionError": "Error de connexió amb el servidor de correu",
    "emailAuthenticationError": "Error d'autenticació amb el servidor de correu",
    "networkError": "Error de connexió. Verifica la connexió a internet",
    "noResponse": "El servidor no respon. Torna-ho a provar",
    "requestSetupError": "Error en processar la sol·licitud",
    "unexpectedError": "S'ha produït un error inesperat"
  },
  "billing": {
    "studies": "Estudis",
    "revenue": "Facturació (€)",
    "modality": {
      "rx": "Radiografia",
      "eco": "Ecografia",
      "tc": "TC",
      "rm": "RM"
    }
  },
  "statistics": {
    "dateRange": "Gen. 15 – Feb. 15, 2026",
    "sections": {
      "productionVolume": "Producció i volum",
      "performanceEfficiency": "Rendiment i eficiència",
      "billing": "Facturació",
      "realtimeActivity": "Activitat en temps real"
    },
    "kpi": {
      "reportsToday": "Informes avui",
      "activeRadiologists": "Radiòlegs actius",
      "averageTime": "Temps mitjà",
      "templateUsage": "Ús de plantilles",
      "vsYesterday": "12.3% respecte a ahir",
      "thisWeek": "+2 aquesta setmana",
      "vsAvg": "0.8 min respecte a la mitjana",
      "thisMonth": "5% aquest mes"
    },
    "charts": {
      "reportsPerMonth": "Informes generats per mes",
      "reportsPerMonthSubtitle": "Últims 30 dies — Total: 22,487",
      "reportsPerMonthBadge": "+18% mensual",
      "billing": "Facturació per modalitat",
      "billingSubtitle": "Tarifa or · Volum i facturació",
      "billingBadge": "🪩 Tarifa or",
      "billingMonthly": "Tendència dels ingressos mensuals",
      "billingMonthlySubtitle": "Últims 6 mesos · Ingressos per modalitat",
      "topRadiologists": "Mètriques per radiòleg",
      "topRadiologistsSubtitle": "Informes aquesta setmana per radiòleg",
      "mostUsedTemplates": "Procediments amb més informes",
      "mostUsedTemplatesSubtitle": "Distribució per tipus",
      "anatomicalRegions": "Troballes per procediment",
      "anatomicalRegionsSubtitle": "Nombre de troballes per procediment",
      "heatmap": "Comparativa per radiòleg",
      "heatmapSubtitle": "Informes per radiòleg i modalitat",
      "reportsByModality": "Informes per modalitat",
      "reportsByModalitySubtitle": "Distribució estadística (caixa i bigotis)",
      "timePerRadiologist": "Temps de generació per radiòleg",
      "timePerRadiologistSubtitle": "Min. de mitjana respecte al volum",
      "correlationMatrix": "Matriu de correlació diagnòstica",
      "correlationMatrixSubtitle": "Concordança de Pearson entre radiòlegs (20 estudis)",
      "correlationLegend": "Coeficient de correlació (Pearson)",
      "frequentFindings": "Troballes freqüents",
      "frequentFindingsSubtitle": "Freqüència per tipus de troballa",
      "weeklyComparison": "Comparativa setmanal",
      "weeklyComparisonSubtitle": "Els 5 primers — Actual respecte a l'anterior",
      "realtimeFeed": "Flux en temps real",
      "realtimeFeedSubtitle": "Últims informes",
      "live": "En directe",
      "average": "Mitjana",
      "reports": "informes",
      "currentMonth": "Mes actual",
      "previousMonth": "Mes anterior",
      "currentWeek": "Setmana actual",
      "previousWeek": "Setmana anterior",
      "reportsLabel": "Informes",
      "avgMinutes": "Min. de mitjana",
      "volume": "Volum",
      "timeMins": "Temps (min)",
      "time": "Temps"
    },
    "days": {
      "mon": "Dl.",
      "tue": "Dt.",
      "wed": "Dc.",
      "thu": "Dj.",
      "fri": "Dv.",
      "sat": "Ds.",
      "sun": "Dg."
    },
    "specialties": {
      "neuroradiology": "Neuroradiologia",
      "musculoskeletal": "Musculoesquelètic",
      "chest": "Tòrax",
      "abdomen": "Abdomen",
      "breast": "Mama"
    },
    "templateNames": {
      "ctBrain": "TC de cervell",
      "xrayChest": "RX de tòrax",
      "mriKnee": "RM de genoll",
      "ctAbdomen": "TC d'abdomen",
      "usThyroid": "Eco de tiroide",
      "other": "Altres"
    },
    "regions": {
      "head": "Cap",
      "chest": "Tòrax",
      "abdomen": "Abdomen",
      "spine": "Columna",
      "extremities": "Extremitats",
      "pelvis": "Pelvis"
    },
    "findings": {
      "noFindings": "Sense troballes",
      "pulmonaryNodule": "Nòdul pulmonar",
      "discHerniation": "Hèrnia discal",
      "pleuralEffusion": "Vessament pleural",
      "fracture": "Fractura",
      "renalMass": "Massa renal",
      "aneurysm": "Aneurisma",
      "stenosis": "Estenosi",
      "calcification": "Calcificació",
      "hepaticCyst": "Quist hepàtic"
    },
    "feed": {
      "minAgo": "Fa {{value}} min"
    },
    "additionalTemplate": {
      "title": "Generar versió complementària",
      "infoBanner": "S'ha detectat que aquesta plantilla podria tenir una versió complementària (bilateral/unilateral). A l'esquerra, indica quin tipus de versió estàs escrivint aquí. La plantilla original es desarà automàticament com a versió contrària. Per exemple, si tries 'Unilateral', el que escriguis aquí serà la versió unilateral i la plantilla original es desarà com a bilateral.",
      "selectVersion": "Quin tipus de versió és?",
      "selectionHint": "Indica si la versió complementària que escriuràs és bilateral o unilateral.",
      "bilateral": "Bilateral",
      "bilateralDescription": "La versió complementària s'aplica a tots dos costats (tots dos genolls, totes dues espatlles, etc.)",
      "unilateral": "Unilateral",
      "unilateralDescription": "La versió complementària s'aplica a un sol costat amb l'etiqueta [lateralidad].",
      "selectedVersion": "Versió {{option}} seleccionada",
      "noSelection": "Selecciona un tipus de versió",
      "editContent": "Contingut de la versió complementària",
      "edited": "Editat",
      "editHint": "Modifica els camps per definir el contingut de la versió complementària. Aquest serà el contingut que es desarà.",
      "technique": "Tècnica",
      "techniquePlaceholder": "Escriu la tècnica de la versió complementària...",
      "findings": "Troballes",
      "findingsPlaceholder": "Escriu les troballes de la versió complementària...",
      "impression": "Conclusió",
      "impressionPlaceholder": "Escriu la conclusió de la versió complementària...",
      "skipGeneration": "Continuar sense versió addicional",
      "save": "Desar versió"
    }
  },
  "onboarding": {
    "skip": "Ometre",
    "next": "Següent",
    "previous": "Anterior",
    "finish": "Entès!",
    "tryIt": "Prova-ho!",
    "example": "Exemple",
    "interactionPending": "Escriu a l'editor per continuar",
    "interactionDone": "Perfecte! Pots continuar",
    "welcomeTitle": "Benvingut a Ainovis!",
    "welcomeDesc": "Sembla que és la primera vegada que ets aquí. Vols fer un recorregut ràpid per conèixer les eines principals?",
    "skipTour": "Ara no",
    "startTour": "Iniciar recorregut",
    "reportCreate": {
      "editorTitle": "Editor de dictat",
      "editorDesc": "Aquí apareixerà el teu dictat. Pots escriure directament o utilitzar el micròfon per dictar l'estudi.",
      "micTitle": "Dictat per veu",
      "micDesc": "Prem el micròfon per iniciar el dictat per veu. El micròfon funciona en l'idioma de l'aplicació. Si no t'hi sents còmode, pots canviar l'idioma als ajustos.",
      "generateTitle": "Generar informe",
      "generateDesc": "Un cop hagis dictat o escrit la descripció de l'estudi, prem aquest botó per generar l'informe automàticament.",
      "modeTitle": "Mode automàtic / manual",
      "modeDesc": "Alterna entre el mode automàtic (Ainovis selecciona la plantilla) i el manual (tu tries la plantilla que s'ha d'utilitzar).",
      "speedModeTitle": "Velocitat de generació",
      "speedModeDesc": "Tria entre el mode ràpid (menys latència) o el precís (més qualitat en la generació de l'informe).",
      "settingsTitle": "Configuració de l'informe",
      "settingsDesc": "Configura l'idioma, el tipus de plantilla i el tipus de conclusió abans de generar el teu informe.",
      "tryRomTitle": "Ara prova-ho tu!",
      "tryRomDesc": "Escriu a l'editor una ressonància magnètica (RM) de genoll. Pots copiar l'exemple o escriure el que vulguis. Això ens ajudarà a mostrar-te com Ainovis genera un informe.",
      "tryRomHint": "Escriu una RM de genoll...",
      "tryRomExample": "RM de genoll. Normal",
      "tryGenerateTitle": "Genera el teu primer informe!",
      "tryGenerateDesc": "Ara prem el botó d'enviar per generar el teu informe. Ainovis processarà el que has escrit i crearà un informe complet."
    },
    "reportEdit": {
      "lateralMenuTitle": "Menú lateral",
      "lateralMenuDesc": "En aquest tauler lateral trobaràs els paràmetres de l'informe. Si vens de la pantalla de creació, els ajustos que has configurat (idioma, tipus de plantilla, mode) ja estaran aplicats aquí.",
      "lateralMenuParamsTitle": "Regenerar amb paràmetres nous",
      "lateralMenuParamsDesc": "Des d'aquí pots canviar l'idioma, el tipus d'informe, el tipus de conclusió o la velocitat i regenerar l'informe amb els paràmetres nous. També pots crear versions noves directament.",
      "patientBannerTitle": "Dades del pacient",
      "patientBannerDesc": "Aquí pots associar les dades del pacient a l'informe: nom, ID, edat, sexe, data de l'estudi i motiu de consulta. També pots accedir a estudis previs del pacient per comparar o reutilitzar informes anteriors.",
      "mainEditorTitle": "Editor de l'informe",
      "mainEditorDesc": "Aquest és l'editor principal on es mostra l'informe generat, dividit en seccions (Tècnica, Troballes, Conclusió). Pots editar el text lliurement, dictar per veu, i els canvis es desen automàticament com a esborrany.",
      "versionTabsTitle": "Versions de l'informe",
      "versionTabsDesc": "Cada vegada que regeneres l'informe o crees un document en blanc, es crea una versió nova. Les pestanyes de la part inferior et permeten navegar entre versions, tancar les que no necessitis o crear una versió nova buida amb el botó +.",
      "actionsTitle": "Accions de l'informe",
      "actionsDesc": "Utilitza 'Copiar' per copiar l'informe al porta-retalls, 'Enviar' per desar l'informe com a definitiu, o 'Eliminar' per descartar l'esborrany del tot."
    },
    "home": {
      "welcomeTitle": "El teu tauler de control",
      "welcomeDesc": "Aquest és el teu tauler principal. Des d'aquí pots crear informes nous, pujar àudios per al dictat per lots i accedir a tot el teu historial de treball.",
      "createBtnTitle": "Crear informe",
      "createBtnDesc": "Prem aquest botó per crear un informe nou des de zero. S'obrirà l'editor on podràs dictar o escriure l'estudi.",
      "uploadBtnTitle": "Carregar àudio",
      "uploadBtnDesc": "Puja fitxers d'àudio amb múltiples dictats. Ainovis els transcriurà i els separarà automàticament en estudis individuals.",
      "performanceTitle": "Resum d'activitat",
      "performanceDesc": "Aquí pots veure les teves estadístiques: informes creats, temps estalviat i tendències de productivitat. Prem 'Veure més estadístiques' per accedir al tauler complet.",
      "templatesTitle": "Plantilles",
      "templatesDesc": "A la pestanya Plantilles trobaràs les teves plantilles d'informe completes, preparades per utilitzar-les en generar un informe. Pots crear-ne de noves, editar les existents o utilitzar les compartides pel teu equip.",
      "blocksTitle": "Blocs",
      "blocksDesc": "Canvia a la pestanya Blocs: aquí veus els blocs, fragments reutilitzables (paràgrafs, troballes, descripcions) que pots inserir en qualsevol informe per redactar més ràpid.",
      "reportListTitle": "Historial de treball",
      "reportListDesc": "Aquí trobaràs tots els teus esborranys, informes desats, informes compartits amb tu i lots de dictat. Utilitza les pestanyes per filtrar."
    },
    "reportEditV2": {
      "smartBarTitle": "SmartBar — La teva barra intel·ligent",
      "smartBarDesc": "La SmartBar és la teva eina principal. Escriu text descriptiu de l'estudi o dicta per veu i prem enviar per generar l'informe automàticament amb Carolina. També la pots utilitzar per editar seccions específiques.",
      "canvasTitle": "Editor de l'informe",
      "canvasDesc": "Aquest és l'editor principal on es mostra l'informe generat, dividit en seccions editables. Pots modificar el text lliurement i els canvis es desen automàticament.",
      "toolbarTitle": "Barra d'eines",
      "toolbarDesc": "Personalitza el format del text: tipus de lletra, mida, negreta, cursiva, alineació, llistes i més. Funciona com qualsevol editor de text enriquit.",
      "findingsModeTitle": "Modes de redacció",
      "findingsModeDesc": "Des d'aquí tries com es redacten les troballes: «Troballes al principi» les agrupa a dalt, per sobre del text normal; «Troballes dins del text» les integra al cos de l'informe. Pots canviar de mode en qualsevol moment.",
      "menuBarTitle": "Barra de menú",
      "menuBarDesc": "Accedeix a totes les funcions: gestió de fitxers, inserció d'elements (imatges, taules, gràfics), classificacions mèdiques, plantilles i suport.",
      "classificationsTitle": "Classificacions mèdiques",
      "classificationsDesc": "Accedeix a classificacions estandarditzades com Fleischner, TI-RADS, PI-RADS, Bosniak i més. Selecciona els paràmetres i la classificació s'inserirà automàticament al teu informe.",
      "versionsTitle": "Historial de versions",
      "versionsDesc": "Aquest és l'historial de versions de l'informe. Cada vegada que envies, regeneres o apliques una plantilla es desa una versió aquí. Els passos que han canviat cada versió s'agrupen per data perquè puguis comparar, previsualitzar i restaurar qualsevol versió anterior.",
      "patientsTitle": "Pacients",
      "patientsDesc": "Des d'aquest tauler cerques i associes el pacient de l'estudi. En seleccionar-lo, les seves dades i els seus estudis previs queden connectats a l'informe per consultar-los o reutilitzar informes anteriors.",
      "patientsNotIntegrated": "Aquesta funcionalitat encara no està integrada. Per veure les dades i l'historial del pacient, l'informe s'ha d'obrir des d'un sistema extern (RIS/PACS).",
      "reportsHistoryTitle": "Informes previs",
      "reportsHistoryDesc": "Aquí veus l'historial d'informes desats i els pots consultar per comparar troballes amb estudis anteriors.",
      "micQrTitle": "Micròfon del mòbil",
      "micQrDesc": "Escaneja aquest codi amb el mòbil per utilitzar-lo com a micròfon de dictat sense fils. El codi caduca al cap d'un temps; si es desconnecta, torna'l a generar des d'aquí.",
      "aiBtnTitle": "Assistent d'IA — Carolina",
      "aiBtnDesc": "Obre el tauler de Carolina, la teva assistent d'IA. Pots fer-li preguntes sobre l'informe, demanar-li suggeriments o consultar-li dubtes mèdics relacionats.",
      "testReportExample": "Utilitza la plantilla {{template}} i afegeix el bloc {{block}}",
      "testTemplateTitle": "Crea la teva primera plantilla",
      "testTemplateDesc": "Fes clic a la targeta «CREAR PLANTILLA»: emplenarem el nom i un informe d'exemple per tu.",
      "testTemplateSaveTitle": "Desa la teva plantilla",
      "testTemplateSaveDesc": "Ja tens la plantilla emplenada amb un informe d'RM de genoll d'exemple. Prem «Desar plantilla» per acabar.",
      "testTemplatePending": "Desa la plantilla per continuar",
      "autoFillTemplateName": "RM de genoll de prova",
      "autoFillTemplateSectionTechnique": "TÈCNICA",
      "autoFillTemplateTechniqueBody": "Estudi d'RM de genoll dret en seqüències DP FS i T1 en els tres plans de l'espai, sense administració de contrast intravenós.",
      "autoFillTemplateSectionFindings": "TROBALLES",
      "autoFillTemplateFindingsBody": "Meniscs de morfologia i intensitat de senyal normals, sense evidència de ruptura. Lligaments encreuats i col·laterals íntegres. Cartílag articular conservat. No s'observa vessament articular significatiu. Medul·la òssia de senyal normal.",
      "autoFillTemplateSectionConclusion": "CONCLUSIÓ",
      "autoFillTemplateConclusionBody": "Estudi d'RM de genoll dret dins de la normalitat.",
      "testBlockTitle": "Crea el teu primer bloc",
      "testBlockDesc": "Prem la targeta «Crear bloc»: emplenarem un fragment reutilitzable d'exemple per tu. Només has de prémer «Desar».",
      "testBlockPending": "Desa el bloc per continuar",
      "autoFillBlockName": "Ruptura del menisc intern",
      "autoFillBlockContent": "Ruptura horitzontal de la banya posterior del menisc intern, amb extensió a la superfície articular inferior.",
      "testReportTitle": "Dicta a Carolina el teu primer informe",
      "testReportDesc": "Prem el micròfon i digues en veu alta l'ordre de sota. Així treballaràs cada dia: parlant, no escrivint.",
      "testReportPending": "Digues l'ordre en veu alta per continuar",
      "voiceGateIdle": "Prem el micròfon i digues l'ordre en veu alta.",
      "voiceGateSayThis": "Digues en veu alta:",
      "voiceGateNoMic": "No puc utilitzar el micròfon",
      "voiceGatePlaceholder": "Utilitza el micròfon →",
      "voiceGateChecking": "Escoltant el que has dit…",
      "voiceGateHeard": "He entès:",
      "voiceGateMissingTemplate": "Falta anomenar la teva plantilla.",
      "voiceGateMissingBlock": "Falta anomenar el teu bloc.",
      "voiceGateRetry": "Repeteix l'ordre tal com apareix a dalt.",
      "voiceGateTypeFallback": "També la pots escriure a la barra.",
      "voiceGateError": "No s'ha pogut transcriure l'àudio. Torna-ho a provar."
    }
  },
  "voiceHelp": {
    "title": "Ordres de veu",
    "intro": "Mentre enregistres pots utilitzar ordres de veu per editar l'informe. També pots simplement dictar text i s'inserirà a la posició del cursor. Aquí tens les ordres disponibles:",
    "deleteTitle": "Esborrar text",
    "deleteDesc": "Elimina text de l'informe. Pots especificar una secció concreta.",
    "deleteEx1": "Esborra el pacient presenta dolor",
    "deleteEx2": "Elimina a la secció troballes la massa hepàtica",
    "updateTitle": "Modificar text",
    "updateDesc": "Substitueix un text per un altre. Utilitza 'per' per indicar el valor nou.",
    "updateEx1": "Canvia pacient per individu",
    "updateEx2": "Substitueix a l'apartat tècnica seqüència FLAIR per seqüència T2",
    "insertTitle": "Inserir text",
    "insertDesc": "Afegeix text nou a l'informe. Pots indicar una secció o una posició relativa (abans/després de).",
    "insertEx1": "Insereix el pacient presenta bon estat general",
    "insertEx2": "Afegeix a la secció troballes massa de 3 cm",
    "insertEx3": "Insereix a la secció tècnica amb seqüències en T1 després de RM de genoll",
    "insertEx4": "Afegeix aquest contingut abans de troballes",
    "insertSectionTitle": "Inserir secció",
    "insertSectionDesc": "Crea una secció nova a l'informe. Pots indicar-ne la posició relativa a una altra secció.",
    "insertSectionEx1": "Insereix una secció nova tècnica",
    "insertSectionEx2": "Afegeix secció notes abans de la conclusió",
    "selectTitle": "Seleccionar opcions",
    "selectDesc": "Quan el sistema mostra opcions numerades, pots seleccionar, canviar o esborrar opcions concretes per número.",
    "selectEx1": "Selecciona l'u i el dos",
    "selectEx2": "Tria de l'1 al 4",
    "selectEx3": "Canvia el primer",
    "selectEx4": "Esborra el 4",
    "selectEx5": "Canvia tots",
    "generateTitle": "Generar informe",
    "generateDesc": "Genera o regenera l'informe complet.",
    "generateEx1": "Generar informe",
    "dictationTitle": "Dictat i puntuació",
    "dictationDesc": "Pots dictar signes de puntuació i format amb la veu.",
    "dictationEx1": "punt → .",
    "dictationEx2": "coma → ,",
    "dictationEx3": "dos punts → :",
    "dictationEx4": "línia nova → salt de línia",
    "dictationEx5": "paràgraf nou → salt de paràgraf",
    "tip": "💡 Les ordres funcionen amb prefixos opcionals com ara el nom de l'assistent (Carolina), expressions de cortesia (si us plau) o salutacions informals (escolta). També toleren la puntuació generada pel reconeixement de veu."
  },
  "batch": {
    "title": "Dictat per lots",
    "uploadSubtitle": "Puja un fitxer d'àudio amb múltiples informes",
    "transcribingSubtitle": "Transcrivint àudio...",
    "reviewSubtitle": "Revisa i corregeix els estudis detectats",
    "generatingSubtitle": "Generant informes...",
    "stepUpload": "Pujar àudio",
    "stepReview": "Revisar",
    "transcriptionComplete": "Transcripció completada — {{count}} estudis detectats",
    "transcriptionError": "Error en transcriure l'àudio",
    "noStudies": "No s'han trobat estudis. Assegura't d'utilitzar el format [Paciente ID].",
    "batchSaved": "Lot desat correctament — {{count}} estudis",
    "saveError": "Error en desar el lot",
    "invalidFormat": "Format no admès. Utilitza fitxers .wav, .mp3, .ogg o .webm",
    "durationExceeded": "La durada total dels fitxers no pot superar els 30 minuts",
    "transcribingAudio": "Transcrivint àudio...",
    "transcribingHint": "L'àudio s'està processant. Això pot trigar uns segons.",
    "dropHere": "Deixa anar el fitxer aquí",
    "uploadTitle": "Puja el teu fitxer d'àudio",
    "uploadHint": "Arrossega un fitxer aquí o fes clic per seleccionar-lo",
    "supportedFormats": "Formats admesos: .wav, .mp3, .ogg, .webm",
    "useMockData": "Utilitzar dades d'exemple",
    "processAudio": "Processar àudio",
    "pause": "Posar en pausa",
    "playAll": "Reproduir tot",
    "unifiedHint": "Cada estudi està separat per [Paciente ID]. Prem ▶ al costat de cada pacient per escoltar el seu segment d'àudio.",
    "studiesDetected": "{{count}} estudis detectats",
    "scrollToBottom": "Anar al final",
    "goToEnd": "Anar al final",
    "saving": "Desant lot...",
    "playSegment": "Reproduir segment",
    "unifiedPlaceholder": "[Paciente 12345678]\nDescriptiu de l'estudi...\n\n[Paciente 87654321]\nUn altre estudi...",
    "generateAll": "Generar tots"
  },
  "voiceCommands": {
    "noTextToDelete": "No s'ha especificat cap text per eliminar",
    "editorNotAvailable": "Editor no disponible",
    "completeUpdatesBeforeDelete": "Completa o cancel·la les actualitzacions pendents abans de fer eliminacions",
    "textNotFound": "No s'ha trobat \"{{text}}\"",
    "textNotFoundInDocument": "No s'ha trobat \"{{text}}\" al document",
    "couldNotDeleteText": "No s'ha pogut eliminar el text",
    "noPendingOperations": "No hi ha operacions pendents. Utilitza primer l'ordre DELETE, UPDATE o INSERT.",
    "noMatchesFound": "No s'han trobat coincidències marcades",
    "noIndicesSpecified": "No s'han especificat índexs",
    "invalidIndices": "Índexs no vàlids: {{indices}}. Interval vàlid: 1-{{max}}",
    "noMatchesForIndices": "No s'han trobat coincidències amb els índexs especificats",
    "noMatchesForIndicesDetail": "No s'han trobat coincidències amb els índexs especificats: {{indices}}",
    "noTextToUpdate": "No s'ha especificat cap text per actualitzar",
    "noReplacementText": "No s'ha especificat cap text de substitució",
    "completeDeletesBeforeUpdate": "Completa o cancel·la les eliminacions pendents abans de fer actualitzacions",
    "couldNotUpdateText": "No s'ha pogut actualitzar el text",
    "updateExtensionNotAvailable": "L'extensió d'actualització no està disponible",
    "noMarkedElements": "No s'han trobat elements marcats al document",
    "noPendingOperationsSimple": "No hi ha operacions pendents",
    "couldNotFindInsertPosition": "No s'ha pogut trobar la posició d'inserció",
    "noContentToInsert": "No hi ha contingut per inserir",
    "noReferenceText": "No s'ha especificat el text de referència",
    "completeDeletesBeforeInsert": "Completa o cancel·la les eliminacions pendents abans de fer insercions",
    "completeUpdatesBeforeInsert": "Completa o cancel·la les actualitzacions pendents abans de fer insercions",
    "insertExtensionNotAvailable": "L'extensió d'inserció no està disponible",
    "couldNotGenerateReport": "No s'ha pogut generar l'informe",
    "textInsertedInReport": "Text inserit a l'informe",
    "textInsertedInDescription": "Text inserit a la descripció",
    "textInsertedAtEndOfReport": "Text inserit al final de l'informe",
    "textUpdated": "Text actualitzat",
    "textDeleted": "Text eliminat",
    "matchesFoundClickToUpdate": "{{count}} coincidències trobades. Fes clic al text subratllat per actualitzar-lo.",
    "matchesFoundUseSelect": "{{count}} coincidències trobades. Utilitza 'selecciona' per triar quines vols eliminar.",
    "matchesDeleted": "Coincidències eliminades: {{count}}",
    "matchesUpdated": "Coincidències actualitzades: {{count}}",
    "couldNotProcessDeletions": "No s'han pogut processar les eliminacions",
    "couldNotProcessUpdates": "No s'han pogut processar les actualitzacions",
    "generateReportOnlyFromDescription": "L'ordre generar informe només funciona des de la descripció o amb índexs",
    "generatingReport": "Generant informe...",
    "voiceInputProcessingError": "Error en processar l'entrada de veu",
    "deleteExtensionNotAvailable": "L'extensió d'eliminació no està disponible",
    "textNotFoundInValidSection": "No s'ha trobat \"{{text}}\" dins d'una secció vàlida",
    "textNotFoundForInsert": "No s'ha trobat \"{{text}}\" per inserir",
    "noSectionSpecified": "No s'ha especificat la secció",
    "sectionNotFound": "No s'ha trobat la secció \"{{section}}\"",
    "textNotFoundInSection": "No s'ha trobat \"{{text}}\" a la secció \"{{section}}\"",
    "sectionTitleRequired": "Cal un títol per a la secció",
    "referenceSectionRequired": "Cal especificar la secció de referència",
    "cannotAddSection": "No es pot afegir la secció",
    "couldNotInsertSection": "No s'ha pogut inserir la secció",
    "errorInsertingSection": "Error en inserir la secció",
    "couldNotDetermineInsertPosition": "No s'ha pogut determinar la posició d'inserció a \"{{section}}\"",
    "errorInsertingTextInSection": "Error en inserir el text a la secció",
    "noCommandRecognized": "No s'ha reconegut cap ordre"
  },
  "share": {
    "me": "Jo",
    "sharedWith": "Compartit amb",
    "title": "Compartir esborrany",
    "tabUsers": "Persones",
    "tabLink": "Enllaç",
    "searchUser": "Cercar usuari per nom o correu electrònic...",
    "userAdded": "Usuari afegit correctament",
    "cannotShareSelf": "No pots compartir amb tu mateix",
    "differentAccount": "Només pots compartir amb usuaris del teu mateix compte",
    "errorSharing": "Error en compartir",
    "userRemoved": "Accés revocat",
    "errorRemoving": "Error en revocar l'accés",
    "errorUpdating": "Error en actualitzar els permisos",
    "linkEnabled": "Enllaç activat",
    "errorLink": "Error en actualitzar l'enllaç",
    "linkCopied": "Enllaç copiat al porta-retalls",
    "errorCopyLink": "Error en copiar l'enllaç",
    "tokenRegenerated": "Enllaç regenerat",
    "errorRegenerate": "Error en regenerar l'enllaç",
    "owner": "Propietari",
    "addedBy": "Afegit per",
    "permView": "Veure",
    "permEdit": "Editar",
    "targetNotFound": "No s'ha trobat l'usuari amb qui vols compartir",
    "linkInvalid": "Enllaç no vàlid o desactivat",
    "linkOtherAccount": "Aquest enllaç és d'un altre compte i no es pot obrir",
    "joinError": "Error en accedir a l'esborrany compartit",
    "goToReports": "Ves als informes",
    "joining": "Accedint a l'esborrany compartit...",
    "noUsersFound": "No s'han trobat usuaris",
    "noUsersShared": "Encara no s'ha compartit amb ningú",
    "shareLinkTitle": "Compartir per enllaç",
    "shareLinkDesc": "Qualsevol persona amb l'enllaç hi pot accedir",
    "linkPermission": "Permís de l'enllaç",
    "removeAccess": "Revocar accés",
    "addUser": "Compartir",
    "copy": "Copiar",
    "copyLink": "Copiar enllaç",
    "errorUpdatingLink": "Error en actualitzar l'enllaç"
  },
  "collaboration": {
    "connected": "En directe",
    "connecting": "Connectant...",
    "invite": "Convida",
    "inviteMore": "Convida més persones"
  },
  "workHistory": {
    "title": "Historial de treball",
    "subtitle": "Historial de treball",
    "sent": "Enviats",
    "drafts": "Esborranys",
    "empty": "No hi ha informes en aquesta secció.",
    "error": "No s'ha pogut carregar l'historial."
  },
  "groupReports": {
    "exportFileName": "historial_treball",
    "titlePrefix": "Historial de ",
    "titleAccent": "treball",
    "subtitle": "Informes enviats i esborranys dels membres del grup.",
    "subtitleAccount": "Informes enviats i esborranys dels membres del compte.",
    "subtitleSelf": "Els teus informes enviats i esborranys.",
    "kind": "Tipus d'informe",
    "sent": "Enviats",
    "drafts": "Esborranys",
    "author": "Autor",
    "allAuthors": "Tot el grup",
    "scope": "Àmbit",
    "scopeAccount": "Tot el compte",
    "scopeSearch": "Cercar grup o persona…",
    "scopeExpand": "Veure els usuaris del grup",
    "scopeNoMatches": "Sense coincidències.",
    "scopeEmptyGroup": "Grup sense usuaris.",
    "search": "Cercar",
    "searchPlaceholder": "Cercar per títol…",
    "from": "Des de",
    "to": "Fins a",
    "clearFilters": "Esborrar filtres",
    "count": "{{count}} resultats",
    "searchModality": "Modalitat…",
    "searchRegion": "Regió…",
    "modalities": "Modalitats",
    "regions": "Regions",
    "allTags": "Veure totes les etiquetes",
    "exportReports": "Descarregar informes",
    "exportPreviewTitle": "Descarregar informes",
    "exportPreviewSubtitle": "Previsualització del fitxer Excel que es descarregarà.",
    "exportSheetName": "historial_treball",
    "exportRowCount": "{{count}} files",
    "exportMoreRows": "+ {{count}} files més a la descàrrega",
    "exportCol_title": "Títol",
    "exportCol_author": "Autor",
    "exportCol_group": "Grup",
    "exportCol_date": "Data",
    "exportCol_modality": "Modalitat",
    "exportCol_region": "Regió",
    "exportDownload": "Descarregar Excel",
    "exportError": "No s'han pogut carregar els informes per descarregar-los.",
    "exportErrorDownload": "No s'ha pogut generar el fitxer Excel.",
    "processingLabel": "{{count}} informe(s) en procés",
    "processingTooltip": "Hi ha {{count}} informe(s) en procés. La llista s'actualitzarà automàticament en acabar.",
    "untitled": "Sense títol",
    "noMatches": "Cap informe no coincideix amb els filtres.",
    "empty": "Encara no hi ha informes al teu grup.",
    "emptySelf": "Encara no tens informes.",
    "error": "No s'han pogut carregar els informes del grup.",
    "errorSelf": "No s'han pogut carregar els teus informes."
  },
  "radiologistInsights": {
    "periodCustom": "Període personalitzat",
    "title": "Les teves mètriques",
    "subtitle": "Activitat de {{name}}",
    "groupFallbackName": "grup",
    "scopeLabel": "Àmbit de les estadístiques",
    "scopePersonal": "Àrea personal",
    "scopeGroup": "Àrea del grup",
    "groupPlaceholderTitle": "Estadístiques del grup",
    "groupPlaceholderText": "Les estadístiques agregades del grup estaran disponibles pròximament.",
    "correlationTitle": "Activitat conjunta dels radiòlegs",
    "correlationSubtitle": "Activitat conjunta respecte al radiòleg amb més informes del grup (0–1)",
    "correlationPairCount": "{{count}} comparacions",
    "correlationPairOne": "1 comparació",
    "correlationNoPairs": "Calen almenys dos radiòlegs per comparar-ne l'activitat.",
    "correlationError": "No s'han pogut carregar els radiòlegs del grup.",
    "correlationEmpty": "No hi ha radiòlegs al grup.",
    "groupError": "No s'han pogut carregar les estadístiques del grup.",
    "groupOverviewSection": "Visió del grup",
    "groupRadiologistsSection": "Radiòlegs",
    "groupProductionTitle": "Producció del grup",
    "groupProductionSubtitle": "{{total}} informes en el període seleccionat",
    "groupModalityTitle": "Informes per modalitat",
    "groupModalitySubtitle": "Distribució del grup",
    "topRadiologistsTitle": "Radiòlegs més productius",
    "topRadiologistsSubtitle": "Informes fets per radiòleg",
    "timePerRadiologistTitle": "Temps mitjà per radiòleg",
    "timePerRadiologistSubtitle": "Minuts d'edició per informe",
    "snomedTooltip": "Totes les troballes s'estandarditzen amb el codi internacional SNOMED CT",
    "processingLabel": "{{count}} informe(s) en procés",
    "processingTooltip": "Hi ha {{count}} informe(s) en procés. Els gràfics s'actualitzaran automàticament quan acabi.",
    "periodMonth": "Aquest mes",
    "periodWeek": "Aquesta setmana",
    "periodLast30": "Últims 30 dies",
    "periodDay": "Avui",
    "kpi": {
      "reportsMonth": "Informes aquest mes",
      "reportsRange": "Informes del període",
      "vsPrevRange": "vs període anterior",
      "reportsWeek": "Informes aquesta setmana",
      "reportsDay": "Informes avui",
      "reportsLast30": "Informes dels últims 30d",
      "vsLastMonth": "respecte al mes anterior",
      "vsLastWeek": "respecte a la setmana anterior",
      "vsYesterday": "respecte a ahir",
      "vsPrev30": "respecte als 30 dies previs",
      "topModality": "La teva modalitat principal",
      "topRegion": "La teva regió principal",
      "reportsCount": "{{count}} informes",
      "percentOfTotal": "{{percent}}% del total",
      "findingsPerReport": "Troballes per informe",
      "billing": "Facturació",
      "accumulated": "Acumulat del mes",
      "topRadiologist": "Radiòleg amb més informes",
      "groupTotalReports": "Informes del grup",
      "thisMonth": "aquest mes",
      "activeRadiologists": "Radiòlegs actius",
      "inTheGroup": "al grup",
      "groupAvgEditTime": "Temps mitjà d'edició",
      "perReport": "per informe"
    },
    "reportsPerDay": "Informes per dia",
    "dailyAverage": "La teva mitjana diària: {{average}} informes",
    "reports": "informes",
    "dayLabel": "Dia {{day}}",
    "today": "avui",
    "average": "mitjana",
    "modalities": "Les teves modalitats",
    "periodDistribution": "Distribució del període",
    "noData": "Sense dades",
    "frequentFindings": "Troballes més freqüents",
    "seeAll": "Veure tots →",
    "inYourReports": "Als teus informes · {{total}} mencions totals",
    "findingsBy": "Troballes per",
    "searchModality": "Cercar modalitat...",
    "searchRegion": "Cercar regió...",
    "noFindingsForFilters": "No hi ha troballes per a aquests filtres en el període.",
    "filter": "Filtrar:",
    "yourReportsCount": "{{count}} informes teus",
    "billing": "La teva facturació",
    "billingMeta": "{{range}} · <strong>{{accumulated}}</strong> acumulat · projecció de final de mes {{projection}}",
    "billingMetaWeek": "{{range}} · <strong>{{accumulated}}</strong> acumulat · projecció de final de setmana {{projection}}",
    "billingMetaDay": "{{range}} · <strong>{{accumulated}}</strong> acumulat avui",
    "billingMetaLast30": "{{range}} · <strong>{{accumulated}}</strong> acumulat en els últims 30 dies",
    "billingDaily": "Ingressos diaris",
    "billingDailySubtitle": "El que s'ha facturat en cada jornada del període",
    "editTimeSection": "Temps d'edició",
    "reportsSection": "Informes",
    "findingsSection": "Troballes",
    "billingSection": "Facturació",
    "editTimeAvgCard": "Temps mitjà per informe",
    "editTimeCardSub": "{{reports}} informes · {{total}} total",
    "editTimeEmpty": "Sense dades d'edició en aquest període",
    "editTimeMedianCard": "Mediana per informe",
    "editTimeMedianSub": "Valor central de {{reports}} informes",
    "editTimeLastCard": "Últim informe",
    "editTimeLastSub": "Temps de l'informe més recent",
    "editTime": "Temps dedicat al dia",
    "editTimeAvg": "Mitjana per informe: {{average}} · Total: {{total}} en {{reports}} informes",
    "editTimeLabel": "temps",
    "presave": {
      "sectionTitle": "Incoherències i avisos",
      "overrideRate": "Taxa d'enviaments forçats",
      "overrideTrendTooltip": "Variació respecte al període anterior (punts percentuals)",
      "overrideSub": "{{count}} decisions",
      "totalWarnings": "Avisos del grup",
      "totalSub": "{{forced}} enviats igualment",
      "warningsPerReport": "Incoherències per informe",
      "perReport": "densitat",
      "topOverride": "Taxa més alta d'enviaments forçats",
      "topOverrideSub": "{{pct}}% · {{forced}} enviats igualment",
      "timelineTitle": "Incoherències per dia",
      "timelineSubtitle": "Repartiment diari entre Revisar (verd) i Enviar igualment (vermell)",
      "splitTitle": "Repartiment de decisions",
      "splitSubtitle": "Proporció d'enviaments forçats sobre el total de decisions",
      "radiologistsTitle": "Taxa d'incoherències sense resoldre per radiòleg",
      "radiologistsSubtitle": "% d'avisos enviats igualment sobre el total de decisions",
      "radiologistsVolumeTitle": "Radiòlegs amb més incoherències",
      "radiologistsVolumeSubtitle": "Total d'avisos emesos per cada radiòleg del grup",
      "templatesTitle": "Plantilles amb més avisos",
      "templatesSubtitle": "Procediments on s'origina la incoherència",
      "listTitle": "Esdeveniments d'incoherències",
      "listMeta": "{{total}} avisos",
      "colDate": "Data",
      "colRadiologist": "Radiòleg",
      "colJustification": "Justificació",
      "colDecision": "Decisió",
      "review": "Revisar",
      "forceSend": "Enviar igualment",
      "pending": "Pendent",
      "override": "Forçats",
      "empty": "Sense avisos en el període seleccionat.",
      "loadMore": "Carregar-ne més ({{remaining}} restants)",
      "collapse": "Plegar"
    }
  },
  "voice": {
    "dictationNoAccess": "No tens accés a aquest esborrany.",
    "dictationTooLarge": "L'àudio supera la mida màxima per dictar.",
    "recoveryTitle": "Enregistrament sense processar",
    "recoveryDescription": "No s'ha pogut processar el teu enregistrament després de diversos intents. Pots tornar-ho a provar o descartar l'enregistrament.",
    "recoveryRetry": "Tornar-ho a provar",
    "recoveryDownload": "Descarregar àudio",
    "recoveryDiscard": "Descartar",
    "recoveryConfirmDiscard": "Segur? Prem de nou",
    "hardLimitReached": "S'ha arribat al límit màxim d'enregistrament (1h 30m). L'àudio s'està processant.",
    "importBusy": "Acaba o cancel·la el dictat en curs abans d'importar un àudio.",
    "importMultipleFiles": "Deixa anar un únic fitxer d'àudio.",
    "importUnsupportedType": "Només s'admeten fitxers d'àudio.",
    "importTooLarge": "El fitxer supera el màxim de {{maxMb}} MB.",
    "importTooLong": "L'àudio supera el màxim de {{maxMin}} minuts.",
    "importDecodeFailed": "No s'ha pogut llegir l'àudio. Prova amb un altre format.",
    "importNoVoice": "No s'ha detectat veu a l'àudio importat.",
    "importNoEncoder": "Aquest navegador no pot preparar àudio importat. Actualitza'l o fes servir un altre navegador.",
    "importError": "No s'ha pogut preparar l'àudio importat.",
    "importComposeFailed": "No s'ha pogut unir l'àudio. El dictat continua en pausa: torna a enviar-lo.",
    "importPreparing": "Preparant l'àudio…",
    "importDropHint": "Deixa anar l'àudio per carregar-lo",
    "softLimitWarning": "L'enregistrament dura més de 10 minuts",
    "errorTimeout": "El servidor ha trigat massa. El teu àudio està desat, pots tornar-ho a provar.",
    "errorDisconnected": "S'ha perdut la connexió amb el servidor. El teu àudio està desat.",
    "errorGeneration": "Error en generar l'informe. El teu àudio està desat, pots tornar-ho a provar.",
    "errorGeneric": "Error en processar l'àudio. El teu àudio està desat.",
    "generationInProgress": "Ja hi ha una generació en curs. Espera que acabi.",
    "errorAfterApplied": "La generació ha acabat amb un error. Revisa el contingut aplicat a l'informe.",
    "audioSaved": "Àudio rebut",
    "templateNotFound": "No s'ha trobat la plantilla \"{{templateName}}\".",
    "processingDictation": "Processant dictat…",
    "holdCancel": "Cancel·lar",
    "holdLock": "Bloquejar",
    "holdSend": "Enviar",
    "traditionalDictation": "Dictat tradicional",
    "holdRightClickHint": "Mantén premut per dictar"
  },
  "micPage": {
    "title": "Micròfon del mòbil",
    "connecting": "Connectant…",
    "needPermission": "Has d'acceptar el permís del micròfon al mòbil abans d'enregistrar. Prem per permetre-ho.",
    "allowMic": "Permetre micròfon",
    "retryMic": "Tornar a demanar el permís del micròfon",
    "permissionBlocked": "Has denegat l'accés al micròfon. Activa'l als ajustos del navegador del mòbil i torna a prémer.",
    "micNotFound": "No s'ha detectat cap micròfon en aquest mòbil.",
    "micBusy": "Una altra aplicació està utilitzant el micròfon. Tanca-la i torna-ho a provar.",
    "micUnavailable": "No s'ha pogut accedir al micròfon del mòbil. Torna a prémer per provar-ho.",
    "ready": "Preparat. Prem el botó per enregistrar.",
    "waitingDesktop": "Esperant l'escriptori…",
    "recording": "Enregistrant…",
    "paused": "En pausa",
    "processing": "Processant àudio…",
    "processingHint": "Silero està retallant silencis…",
    "record": "Enregistrar",
    "pause": "Pausa",
    "resume": "Reprendre",
    "stop": "Enviar",
    "cancel": "Cancel·lar",
    "desktopConnected": "Escriptori connectat",
    "desktopWaiting": "Escriptori no connectat",
    "desktopBusy": "L'escriptori està enregistrant. Espera que acabi.",
    "missingToken": "Falta l'enllaç d'aparellament. Torna a escanejar el QR.",
    "invalidToken": "L'enllaç no és vàlid. Genera un altre codi a l'escriptori.",
    "expiredToken": "El codi ha caducat. Genera'n un altre a l'escriptori.",
    "roomFull": "Ja hi ha un telèfon connectat a aquest codi.",
    "permissionDenied": "No s'ha pogut accedir al micròfon. Revisa el permís del navegador.",
    "insecureOrigin": "El micròfon necessita HTTPS (o localhost).",
    "disconnected": "S'ha perdut la connexió amb l'escriptori.",
    "helloTimeout": "No s'ha pogut accedir a la sala. Torna-ho a provar.",
    "idle": "La sala s'ha tancat per inactivitat.",
    "recordingLimit": "S'ha arribat al límit d'enregistrament.",
    "relayError": "No s'ha pogut connectar. Genera un altre codi a l'escriptori."
  },
  "orgAdmin": {
    "backToApp": "Tornar a Ainovis",
    "loadError": "No s'ha pogut carregar la informació.",
    "saveError": "No s'ha pogut desar. Revisa les dades i torna-ho a provar.",
    "comingSoon": "Pròximament",
    "shell": {
      "eyebrow": "Administració",
      "pageTitlePrefix": "Tauler d'",
      "pageTitleAccent": "administració",
      "pageSubtitle": "Administra tot el compte {{name}}",
      "meta": "{{groups}} grups · {{users}} usuaris"
    },
    "rail": {
      "title": "Compte",
      "groups": "Grups",
      "account": "Tot el compte",
      "accountPicker": "Compte",
      "emptyAccount": "Encara no hi ha grups. Afegir el primer",
      "usersTooltip": "Usuaris del grup"
    },
    "confirm": {
      "deleteGroupHint": "Els seus usuaris es quedaran sense grup assignat. No es pot desfer.",
      "irreversible": "Aquesta acció no es pot desfer."
    },
    "nav": {
      "overview": "Resum",
      "stats": "Estadístiques",
      "groups": "Grups",
      "users": "Usuaris",
      "templates": "Plantilles",
      "settings": "Permisos"
    },
    "period": {
      "month": "Mes",
      "week": "Setmana",
      "day": "Dia",
      "last30": "Últims 30 dies"
    },
    "overview": {
      "title": "Resum",
      "subtitle": "Activitat de {{name}}",
      "reports": "Informes",
      "activeUsers": "Usuaris actius",
      "avgEdit": "Edició mitjana",
      "topUser": "Usuari destacat",
      "reportsCount": "{{count}} informes",
      "activity": "Activitat",
      "contact": "Dades de contacte",
      "noContact": "Sense dades de contacte.",
      "parent": "Compte",
      "shortcuts": "Anar a",
      "groupsTitle": "Grups",
      "topGroup": "Grup amb més informes",
      "fastestGroup": "Grup més ràpid"
    },
    "groups": {
      "title": "Grups",
      "subtitle": "Grups del compte",
      "addGroup": "Afegir grup",
      "emptyGroups": "Aquest compte encara no té grups.",
      "usersCount": "{{active}}/{{count}} usuaris",
      "deleteGroupConfirm": "Vols eliminar el grup {{name}}?",
      "editGroup": "Editar grup"
    },
    "form": {
      "name": "Nom",
      "surname": "Cognoms",
      "nationalId": "NIF",
      "nameRequired": "El nom és obligatori.",
      "address": "Adreça",
      "professionalTitle": "Títol professional (opcional)",
      "email": "Correu electrònic",
      "phone": "Telèfon",
      "namePlaceholder": "Ex.: Maria",
      "surnamePlaceholder": "Ex.: García López",
      "emailPlaceholder": "Ex.: maria@hospital.com",
      "nationalIdPlaceholder": "Ex.: 12345678A",
      "addressPlaceholder": "Ex.: Carrer Major 1, Madrid",
      "professionalTitlePlaceholder": "Dr., Dra., ...",
      "phonePlaceholder": "Ex.: +34 912 345 678"
    },
    "users": {
      "title": "Usuaris",
      "searchPlaceholder": "Cercar per nom o correu electrònic",
      "allRoles": "Tots els rols",
      "allStatuses": "Tots els estats",
      "filters": "Filtres",
      "columnUser": "Usuari",
      "columnRole": "Rol",
      "columnGroup": "Grup",
      "columnStatus": "Estat",
      "statusActive": "Actiu",
      "statusPending": "Pendent",
      "statusInactive": "Inactiu",
      "noGroup": "Sense grup",
      "count": "{{count}} usuaris",
      "empty": "Aquest compte encara no té usuaris.",
      "emptyFiltered": "Cap usuari no coincideix amb els filtres.",
      "selected": "{{count}} seleccionats",
      "selectAll": "Seleccionar tots",
      "bulkLabel": "Plantilles personals:",
      "bulkDone": "S'han actualitzat {{count}} usuaris.",
      "bulkPartial": "No s'han pogut actualitzar {{count}} usuaris.",
      "columnActions": "Accions",
      "add": "Afegir usuari",
      "addHint": "Rebrà un correu per verificar el compte i triar una contrasenya.",
      "sendInvite": "Crear i convidar",
      "createOnly": "Crear sense convidar",
      "edit": "Editar usuari",
      "editHint": "El rol i el grup es canvien des de la taula.",
      "emailLocked": "El correu d'accés no es pot canviar.",
      "updated": "Usuari actualitzat.",
      "formRequired": "Completa tots els camps obligatoris.",
      "resend": "Reenviar invitació",
      "activate": "Activar",
      "deactivate": "Desactivar",
      "activated": "Usuari activat.",
      "deactivated": "Usuari desactivat.",
      "roleChanged": "Rol actualitzat.",
      "groupChanged": "Usuari traslladat de grup.",
      "inviteSent": "Invitació enviada.",
      "deleted": "Usuari eliminat.",
      "deleteTitle": "Vols eliminar {{name}}?",
      "deleteHint": "També s'esborren els seus esborranys, plantilles i ajustos.",
      "loadMore": "Carregar-ne més ({{remaining}} restants)",
      "endOfList": "No hi ha més usuaris.",
      "page": "Pàgina {{page}} de {{totalPages}}",
      "loadError": "No s'han pogut carregar els usuaris.",
      "accessTitle": "Accés i permisos",
      "accessSelfHint": "No pots canviar el teu propi rol ni els teus permisos."
    },
    "templates": {
      "title": "Plantilles",
      "total": "{{count}} plantilles",
      "upload": "Pujar",
      "uploadScope": "Àmbit",
      "uploadScopePlaceholder": "Tria un àmbit…",
      "scopeEverything": "Compte i grups",
      "scopeAll": "{{name}}",
      "scopeOnlyAccount": "Només el compte",
      "hintAll": "{{total}} plantilles en {{count}} grups",
      "hintAccount": "Visible per als {{count}} grups del compte {{name}} · {{total}} plantilles",
      "hintGroup": "Visible només per a l'equip de {{name}} · {{total}} plantilles",
      "searchPlaceholder": "Cercar plantilla",
      "selected": "{{count}} seleccionades",
      "moveTo": "Moure a",
      "edit": "Editar plantilla",
      "select": "Seleccionar {{name}}",
      "page": "Pàgina {{page}} de {{totalPages}}",
      "emptyAccount": "Aquest compte encara no té plantilles institucionals.",
      "emptyGroup": "Aquest grup no té plantilles pròpies.",
      "emptyGroupHint": "També veu les {{count}} del compte {{name}}.",
      "emptyFiltered": "Cap plantilla no coincideix amb la cerca.",
      "confirmDelete": "Vols eliminar {{count}} plantilles? No es pot desfer.",
      "confirmPromote": "Faràs visibles {{count}} plantilles per als {{groups}} grups del compte {{name}}.",
      "loadError": "No s'han pogut carregar les plantilles.",
      "moveError": "No s'han pogut moure les plantilles.",
      "languageError": "No s'ha pogut canviar l'idioma de la plantilla.",
      "deleteError": "No s'han pogut eliminar les plantilles.",
      "processing": "Desant",
      "processingHint": "La plantilla ja s'ha desat. S'està acabant de preparar per al dictat; fins aleshores no es podrà detectar automàticament."
    },
    "scope": {
      "account": "Tot el compte",
      "group": "Grup"
    },
    "settings": {
      "title": "Configuració",
      "applyNote": "Sobreescriu la política dels {{count}} grups existents amb els valors de dalt."
    },
    "policy": {
      "title": "Política de plantilles",
      "groupNote": "S'aplica als usuaris d'aquest grup que no tinguin permisos personalitzats.",
      "personalTitle": "Plantilles personals",
      "personalHint": "Permet als radiòlegs utilitzar, crear i editar les seves pròpies plantilles i blocs. En desactivar-ho, també deixen de veure's les plantilles personals que ja tinguessin.",
      "ainovisTitle": "Plantilles d'Ainovis",
      "ainovisHint": "Permet accedir a les plantilles d'Ainovis. Si es desactiva, deixaran d'estar disponibles a l'aplicació.",
      "institutionalTitle": "Plantilles institucionals",
      "institutionalHint": "Permet accedir a les plantilles del grup i del compte. Si es desactiva, deixaran d'estar disponibles a l'aplicació.",
      "allowed": "Permès",
      "blocked": "Bloquejat",
      "inherit": "Heretat del grup ({{state}})",
      "inheritShort": "Heretat del grup",
      "groupPolicy": "Heretat del grup",
      "legend": "Permès / Bloquejat / Heretat del grup: què significa cada valor.",
      "legendAllowed": "aquesta persona sempre ho pot utilitzar, encara que el grup ho prohibeixi.",
      "legendBlocked": "aquesta persona no ho pot utilitzar mai, encara que el grup ho permeti.",
      "legendGroup": "aquesta persona no té una decisió pròpia; s'aplica el que hagi decidit el seu grup (es mostra al costat).",
      "legendNoGroup": "aquesta persona no té cap grup assignat; s'aplica la política per defecte del compte.",
      "alwaysAllowed": "Sempre permès",
      "exemptHint": "Els administradors sempre poden crear plantilles.",
      "saved": "Política actualitzada.",
      "defaultsTitle": "Permisos de plantilles",
      "defaultsWarning": "Aquests permisos s'aplicaran als grups nous. Els grups existents no es modificaran.",
      "applyToGroups": "Aplicar permisos als grups existents",
      "applyConfirm": "Se sobreescriurà la política de tots els grups del compte. Vols continuar?",
      "applied": "Aplicat a {{count}} grups."
    },
    "classifications": {
      "title": "Política de classificacions",
      "note": "Decideix qui pot utilitzar les classificacions en aquest compte i quines escales estan disponibles.",
      "groupNote": "El que s'aplica als usuaris d'aquest grup, tret que tinguin un permís propi.",
      "defaultsWarning": "Valors inicials dels grups nous. Els grups existents mantenen els seus.",
      "userTitle": "Classificacions",
      "userHint": "Permet a aquesta persona utilitzar les classificacions, al marge del que decideixi el seu grup.",
      "scalesTitle": "Classificacions disponibles",
      "scalesCount": "{{active}} de {{total}} actives",
      "scalesUserTitle": "Triar una per una",
      "scalesUserHint": "Excepcions per a aquesta persona; el que no es modifica segueix el grup.",
      "audienceTitle": "Qui pot classificar",
      "saved": "Política de classificacions actualitzada.",
      "audience": {
        "nobody": "Ningú",
        "admins": "Només administradors",
        "everyone": "Tot el compte"
      },
      "audienceDesc": {
        "nobody": "Ningú del compte no pot classificar.",
        "admins": "Comportament actual: només els administradors poden classificar.",
        "everyone": "Qualsevol usuari del compte pot classificar."
      },
      "hints": {
        "FLEISCHNER": "Nòdul pulmonar",
        "TI-RADS": "Tiroide",
        "PI-RADS": "Pròstata",
        "BOSNIAK_2019": "Quist renal",
        "GARDEN": "Fractura de maluc",
        "EATON_LITTLER": "Rizartrosi (mà)",
        "SNYDER": "Manegot dels rotadors (espatlla)",
        "HERBERT_FISCHER": "Fractura d'escafoides (canell)"
      }
    },
    "permissions": {
      "column": "Permisos",
      "edit": "Editar permisos",
      "title": "Permisos de {{name}}",
      "bulkTitle": "Permisos de {{count}} usuaris",
      "bulkHint": "Els canvis s'apliquen a tots els usuaris seleccionats.",
      "inherited": "Heretats",
      "custom": "Personalitzats",
      "mixed": "Diversos valors",
      "partialExempt": "{{count}} dels seleccionats ho tenen sempre permès."
    },
    "group": {
      "back": "Tornar als grups",
      "title": "Grup",
      "subtitle": "Activitat i equip del grup",
      "team": "Equip",
      "emptyTeam": "Aquest grup encara no té usuaris.",
      "active": "Actiu",
      "inactive": "Inactiu"
    },
    "roles": {
      "user": "Usuari",
      "admin": "Admin",
      "supervisor": "Supervisor",
      "super": "Super"
    }
  }
}